'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var classNames = require('classnames');
var nextId = require('react-id-generator');
var keyname = require('keyname');
var reactDom = require('react-dom');
var focusable = require('focusable');
var dom = require('@floating-ui/dom');
var reactDom$1 = require('@floating-ui/react-dom');
var SyntaxHighlighter = require('react-syntax-highlighter/dist/cjs/light');
var js = require('react-syntax-highlighter/dist/cjs/languages/hljs/javascript');
var css = require('react-syntax-highlighter/dist/cjs/languages/hljs/css');
var xml = require('react-syntax-highlighter/dist/cjs/languages/hljs/xml');
var yaml = require('react-syntax-highlighter/dist/cjs/languages/hljs/yaml');
var reactAriaComponents = require('react-aria-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var nextId__default = /*#__PURE__*/_interopDefaultLegacy(nextId);
var keyname__default = /*#__PURE__*/_interopDefaultLegacy(keyname);
var focusable__default = /*#__PURE__*/_interopDefaultLegacy(focusable);
var SyntaxHighlighter__default = /*#__PURE__*/_interopDefaultLegacy(SyntaxHighlighter);
var js__default = /*#__PURE__*/_interopDefaultLegacy(js);
var css__default = /*#__PURE__*/_interopDefaultLegacy(css);
var xml__default = /*#__PURE__*/_interopDefaultLegacy(xml);
var yaml__default = /*#__PURE__*/_interopDefaultLegacy(yaml);

var Main = /** @class */ (function (_super) {
    tslib.__extends(Main, _super);
    function Main() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Main.prototype.render = function () {
        var _a = this.props, mainRef = _a.mainRef, children = _a.children, other = tslib.__rest(_a, ["mainRef", "children"]);
        return (React__default["default"].createElement("main", tslib.__assign({ className: "Main", ref: mainRef }, other), children));
    };
    Main.defaultProps = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        mainRef: function () { }
    };
    return Main;
}(React.Component));

var Layout = /** @class */ (function (_super) {
    tslib.__extends(Layout, _super);
    function Layout() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Layout.prototype.render = function () {
        var _a = this.props, layoutRef = _a.layoutRef, children = _a.children, other = tslib.__rest(_a, ["layoutRef", "children"]);
        return (React__default["default"].createElement("div", tslib.__assign({ className: "Layout", ref: layoutRef }, other), children));
    };
    Layout.defaultProps = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        layoutRef: function () { }
    };
    return Layout;
}(React__default["default"].Component));

var Workspace = /** @class */ (function (_super) {
    tslib.__extends(Workspace, _super);
    function Workspace() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Workspace.prototype.componentDidMount = function () {
        document.body.classList.toggle('Page--no-sidebar', this.props.noSideBar);
    };
    Workspace.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.noSideBar === this.props.noSideBar) {
            return;
        }
        document.body.classList.toggle('Page--no-sidebar', this.props.noSideBar);
    };
    Workspace.prototype.componentWillUnmount = function () {
        document.body.classList.remove('Page--no-sidebar');
    };
    Workspace.prototype.render = function () {
        var _a = this.props; 
        // defining `noSideBar` to prevent it from being passed through to Main
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.noSideBar; var children = _a.children, workspaceRef = _a.workspaceRef, layoutRef = _a.layoutRef, other = tslib.__rest(_a, ["noSideBar", "children", "workspaceRef", "layoutRef"]);
        return (React__default["default"].createElement(Layout, { layoutRef: layoutRef },
            React__default["default"].createElement(Main, tslib.__assign({ mainRef: workspaceRef }, other), children)));
    };
    Workspace.defaultProps = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        workspaceRef: function () { },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        layoutRef: function () { },
        noSideBar: false
    };
    return Workspace;
}(React__default["default"].Component));

var Offscreen = function (props) { return (React__default["default"].createElement("span", tslib.__assign({ className: "Offscreen" }, props))); };

/*!
 * GENERATED CODE. DO NOT EDIT DIRECTLY!
 */
/** iconTypes holds each valid icon type. */
var iconTypes = [
    'add-user',
    'arrow-circle-up',
    'arrow-circle-down',
    'arrow-circle-left',
    'arrow-circle-right',
    'arrow-up',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrows-alt',
    'bolt',
    'broken-image',
    'caution',
    'check-circle',
    'check-shield',
    'check-solid',
    'check',
    'checkbox-checked',
    'checkbox-unchecked',
    'chevron-double-up',
    'chevron-double-down',
    'chevron-double-left',
    'chevron-double-right',
    'chevron-up',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'clipboard',
    'clock',
    'close',
    'code',
    'copy',
    'download',
    'dropper',
    'exchange',
    'export-solid',
    'external-link',
    'eye',
    'filter',
    'flag',
    'gears',
    'github',
    'grid',
    'hamburger-menu',
    'hashtag',
    'highlight',
    'images',
    'info-circle-alt',
    'info-circle',
    'info-square',
    'kabob',
    'link',
    'linkedin',
    'list',
    'lock',
    'magnifying-glass',
    'menu',
    'minus',
    'new-releases',
    'new',
    'no',
    'pause',
    'pencil',
    'person-running',
    'play',
    'plus',
    'question-circle-alt',
    'question-circle',
    'radio-checked',
    'radio-unchecked',
    'recycle-square',
    'recycle',
    'report',
    'resend',
    'robot',
    'run-again',
    'save',
    'share-nodes',
    'share',
    'sort-triangle',
    'sort',
    'star-outline',
    'star',
    'step-back',
    'step-forward',
    'sun',
    'table-sort-ascending',
    'table-sort-descending',
    'tag',
    'target',
    'trash',
    'triangle-up',
    'triangle-down',
    'triangle-left',
    'triangle-right',
    'twitter',
    'upload',
    'filter-solid'
];

function __variableDynamicImportRuntime0__(path) {
  switch (path) {
    case './icons/add-user.svg': return Promise.resolve().then(function () { return require('./add-user.js'); });
    case './icons/arrow-circle.svg': return Promise.resolve().then(function () { return require('./arrow-circle.js'); });
    case './icons/arrow.svg': return Promise.resolve().then(function () { return require('./arrow.js'); });
    case './icons/arrows-alt.svg': return Promise.resolve().then(function () { return require('./arrows-alt.js'); });
    case './icons/bolt.svg': return Promise.resolve().then(function () { return require('./bolt.js'); });
    case './icons/broken-image.svg': return Promise.resolve().then(function () { return require('./broken-image.js'); });
    case './icons/caution.svg': return Promise.resolve().then(function () { return require('./caution.js'); });
    case './icons/check-circle.svg': return Promise.resolve().then(function () { return require('./check-circle.js'); });
    case './icons/check-shield.svg': return Promise.resolve().then(function () { return require('./check-shield.js'); });
    case './icons/check-solid.svg': return Promise.resolve().then(function () { return require('./check-solid.js'); });
    case './icons/check.svg': return Promise.resolve().then(function () { return require('./check.js'); });
    case './icons/checkbox-checked.svg': return Promise.resolve().then(function () { return require('./checkbox-checked.js'); });
    case './icons/checkbox-unchecked.svg': return Promise.resolve().then(function () { return require('./checkbox-unchecked.js'); });
    case './icons/chevron-double.svg': return Promise.resolve().then(function () { return require('./chevron-double.js'); });
    case './icons/chevron.svg': return Promise.resolve().then(function () { return require('./chevron.js'); });
    case './icons/clipboard.svg': return Promise.resolve().then(function () { return require('./clipboard.js'); });
    case './icons/clock.svg': return Promise.resolve().then(function () { return require('./clock.js'); });
    case './icons/close.svg': return Promise.resolve().then(function () { return require('./close.js'); });
    case './icons/code.svg': return Promise.resolve().then(function () { return require('./code.js'); });
    case './icons/copy.svg': return Promise.resolve().then(function () { return require('./copy.js'); });
    case './icons/download.svg': return Promise.resolve().then(function () { return require('./download.js'); });
    case './icons/dropper.svg': return Promise.resolve().then(function () { return require('./dropper.js'); });
    case './icons/exchange.svg': return Promise.resolve().then(function () { return require('./exchange.js'); });
    case './icons/export-solid.svg': return Promise.resolve().then(function () { return require('./export-solid.js'); });
    case './icons/external-link.svg': return Promise.resolve().then(function () { return require('./external-link.js'); });
    case './icons/eye.svg': return Promise.resolve().then(function () { return require('./eye.js'); });
    case './icons/filter.svg': return Promise.resolve().then(function () { return require('./filter.js'); });
    case './icons/flag.svg': return Promise.resolve().then(function () { return require('./flag.js'); });
    case './icons/gears.svg': return Promise.resolve().then(function () { return require('./gears.js'); });
    case './icons/github.svg': return Promise.resolve().then(function () { return require('./github.js'); });
    case './icons/grid.svg': return Promise.resolve().then(function () { return require('./grid.js'); });
    case './icons/hamburger-menu.svg': return Promise.resolve().then(function () { return require('./hamburger-menu.js'); });
    case './icons/hashtag.svg': return Promise.resolve().then(function () { return require('./hashtag.js'); });
    case './icons/highlight.svg': return Promise.resolve().then(function () { return require('./highlight.js'); });
    case './icons/images.svg': return Promise.resolve().then(function () { return require('./images.js'); });
    case './icons/info-circle-alt.svg': return Promise.resolve().then(function () { return require('./info-circle-alt.js'); });
    case './icons/info-circle.svg': return Promise.resolve().then(function () { return require('./info-circle.js'); });
    case './icons/info-square.svg': return Promise.resolve().then(function () { return require('./info-square.js'); });
    case './icons/kabob.svg': return Promise.resolve().then(function () { return require('./kabob.js'); });
    case './icons/link.svg': return Promise.resolve().then(function () { return require('./link.js'); });
    case './icons/linkedin.svg': return Promise.resolve().then(function () { return require('./linkedin.js'); });
    case './icons/list.svg': return Promise.resolve().then(function () { return require('./list.js'); });
    case './icons/lock.svg': return Promise.resolve().then(function () { return require('./lock.js'); });
    case './icons/magnifying-glass.svg': return Promise.resolve().then(function () { return require('./magnifying-glass.js'); });
    case './icons/menu.svg': return Promise.resolve().then(function () { return require('./menu.js'); });
    case './icons/minus.svg': return Promise.resolve().then(function () { return require('./minus.js'); });
    case './icons/new-releases.svg': return Promise.resolve().then(function () { return require('./new-releases.js'); });
    case './icons/new.svg': return Promise.resolve().then(function () { return require('./new.js'); });
    case './icons/no.svg': return Promise.resolve().then(function () { return require('./no.js'); });
    case './icons/pause.svg': return Promise.resolve().then(function () { return require('./pause.js'); });
    case './icons/pencil.svg': return Promise.resolve().then(function () { return require('./pencil.js'); });
    case './icons/person-running.svg': return Promise.resolve().then(function () { return require('./person-running.js'); });
    case './icons/play.svg': return Promise.resolve().then(function () { return require('./play.js'); });
    case './icons/plus.svg': return Promise.resolve().then(function () { return require('./plus.js'); });
    case './icons/question-circle-alt.svg': return Promise.resolve().then(function () { return require('./question-circle-alt.js'); });
    case './icons/question-circle.svg': return Promise.resolve().then(function () { return require('./question-circle.js'); });
    case './icons/radio-checked.svg': return Promise.resolve().then(function () { return require('./radio-checked.js'); });
    case './icons/radio-unchecked.svg': return Promise.resolve().then(function () { return require('./radio-unchecked.js'); });
    case './icons/recycle-square.svg': return Promise.resolve().then(function () { return require('./recycle-square.js'); });
    case './icons/recycle.svg': return Promise.resolve().then(function () { return require('./recycle.js'); });
    case './icons/report.svg': return Promise.resolve().then(function () { return require('./report.js'); });
    case './icons/resend.svg': return Promise.resolve().then(function () { return require('./resend.js'); });
    case './icons/robot.svg': return Promise.resolve().then(function () { return require('./robot.js'); });
    case './icons/run-again.svg': return Promise.resolve().then(function () { return require('./run-again.js'); });
    case './icons/save.svg': return Promise.resolve().then(function () { return require('./save.js'); });
    case './icons/share-nodes.svg': return Promise.resolve().then(function () { return require('./share-nodes.js'); });
    case './icons/share.svg': return Promise.resolve().then(function () { return require('./share.js'); });
    case './icons/sort-triangle.svg': return Promise.resolve().then(function () { return require('./sort-triangle.js'); });
    case './icons/sort.svg': return Promise.resolve().then(function () { return require('./sort.js'); });
    case './icons/star-outline.svg': return Promise.resolve().then(function () { return require('./star-outline.js'); });
    case './icons/star.svg': return Promise.resolve().then(function () { return require('./star.js'); });
    case './icons/step-back.svg': return Promise.resolve().then(function () { return require('./step-back.js'); });
    case './icons/step-forward.svg': return Promise.resolve().then(function () { return require('./step-forward.js'); });
    case './icons/sun.svg': return Promise.resolve().then(function () { return require('./sun.js'); });
    case './icons/table-sort-ascending.svg': return Promise.resolve().then(function () { return require('./table-sort-ascending.js'); });
    case './icons/table-sort-descending.svg': return Promise.resolve().then(function () { return require('./table-sort-descending.js'); });
    case './icons/tag.svg': return Promise.resolve().then(function () { return require('./tag.js'); });
    case './icons/target.svg': return Promise.resolve().then(function () { return require('./target.js'); });
    case './icons/trash.svg': return Promise.resolve().then(function () { return require('./trash.js'); });
    case './icons/triangle.svg': return Promise.resolve().then(function () { return require('./triangle.js'); });
    case './icons/twitter.svg': return Promise.resolve().then(function () { return require('./twitter.js'); });
    case './icons/upload.svg': return Promise.resolve().then(function () { return require('./upload.js'); });
    default: return new Promise(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }
/**
 * Some icons have a mapped type different from their filename;
 * This is only a temporary measure to consolidate similar icons
 * until we can address Cauldron's iconography.
 * see: https://github.com/dequelabs/cauldron/issues/869
 */
var MAPPED_TYPES = {
    'filter-solid': 'filter'
};
var Icon = React.forwardRef(function (_a, ref) {
    var _b;
    var label = _a.label, className = _a.className, type = _a.type, other = tslib.__rest(_a, ["label", "className", "type"]);
    var isMounted = React.useRef(true);
    var _c = tslib.__read(type.match(/(.*)-(right|left|up|down)$/) || [
        '',
        type
    ], 3), name = _c[1], direction = _c[2];
    var _d = tslib.__read(React.useState(null), 2), IconSVG = _d[0], setIcon = _d[1];
    React.useEffect(function () {
        isMounted.current = true;
        // NOTE: we don't want to pollute test output with
        //  console.errors as a result of the dynamic imports
        if (process.env.NODE_ENV === 'test') {
            return;
        }
        var iconName = MAPPED_TYPES[name] || name;
        __variableDynamicImportRuntime0__("./icons/".concat(iconName, ".svg"))
            .then(function (icon) {
            isMounted.current && setIcon(function () { return icon.default; });
        })
            .catch(function () {
            console.error("Could not find icon type \"".concat(type, "\"."));
            isMounted.current && setIcon(null);
        });
        return function () {
            isMounted.current = false;
        };
    }, [type]);
    var data = tslib.__assign(tslib.__assign({}, other), { 'aria-hidden': !label, className: classNames__default["default"]('Icon', "Icon--".concat(type), className, (_b = {},
            _b["Icon__".concat(direction)] = !!direction,
            _b)) });
    return (React__default["default"].createElement("span", tslib.__assign({ ref: ref }, data),
        label && React__default["default"].createElement(Offscreen, null, label),
        IconSVG && React__default["default"].createElement(IconSVG, null)));
});
Icon.displayName = 'Icon';

var PanelTrigger = function (_a) {
    var children = _a.children, className = _a.className, open = _a.open, fullWidth = _a.fullWidth, onClick = _a.onClick, _b = _a.iconExpanded, iconExpanded = _b === void 0 ? 'chevron-down' : _b, _c = _a.iconCollapsed, iconCollapsed = _c === void 0 ? 'chevron-right' : _c, heading = _a.heading, otherProps = tslib.__rest(_a, ["children", "className", "open", "fullWidth", "onClick", "iconExpanded", "iconCollapsed", "heading"]);
    var Header = typeof heading === 'object' && 'level' in heading && !!heading.level
        ? "h".concat(heading.level)
        : React__default["default"].Fragment;
    return (React__default["default"].createElement(Header, null,
        React__default["default"].createElement("button", tslib.__assign({ className: classNames__default["default"](className, 'ExpandCollapse__trigger', {
                fullWidth: fullWidth
            }), type: "button", "aria-expanded": open, onClick: onClick }, otherProps),
            React__default["default"].createElement("span", { className: "ExpandCollapse__trigger-title" }, typeof children === 'function'
                ? children({ open: !!open })
                : children),
            React__default["default"].createElement(Icon, { type: open ? iconExpanded : iconCollapsed }))));
};
PanelTrigger.displayName = 'PanelTrigger';
var PanelTrigger$1 = React__default["default"].memo(PanelTrigger);

var injectStyleTag = function () {
    var style = document.createElement('style');
    document.head.appendChild(style);
    return style;
};
var setStyle = function (tag, cssString) {
    tag.textContent = cssString;
};
var removeStyleTag = function (tag) {
    document.head.removeChild(tag);
};

var ExpandCollapsePanel = /** @class */ (function (_super) {
    tslib.__extends(ExpandCollapsePanel, _super);
    function ExpandCollapsePanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            controlled: typeof _this.props.open !== 'undefined',
            isOpen: typeof _this.props.open !== 'undefined' ? _this.props.open : false
        };
        _this.panel = React__default["default"].createRef();
        _this.handleToggle = function (e) {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            var _a = _this.props.onToggle, onToggle = _a === void 0 ? function () { } : _a;
            var _b = _this.state, isOpen = _b.isOpen, controlled = _b.controlled;
            onToggle(e);
            if (!controlled) {
                _this.setState({ isOpen: !isOpen, isAnimating: true });
            }
        };
        _this.animateOpen = function () {
            var panel = _this.panel.current;
            var animationTiming = _this.props.animationTiming;
            var prefersReducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (!animationTiming || prefersReducedMotion) {
                _this.setState({ isAnimating: false });
                return;
            }
            var rect = panel === null || panel === void 0 ? void 0 : panel.getBoundingClientRect();
            if (!rect) {
                return;
            }
            if (!_this.styleTag) {
                _this.styleTag = injectStyleTag();
            }
            setStyle(_this.styleTag, "\n      @keyframes expandOpenAnimation {\n        0% { opacity: 0; height: 0; }\n        100% { opacity: 1; height: ".concat(rect.height, "px; }\n      }\n\n      .cauldron-expand-open {\n        will-change: opacity, height;\n        overflow: hidden;\n        animation: expandOpenAnimation ease-in-out ").concat(animationTiming, "ms forwards;\n      }\n    "));
            _this.setState({ animationClass: 'cauldron-expand-open' }, function () {
                setTimeout(function () {
                    _this.setState({ animationClass: '', isAnimating: false });
                    setStyle(_this.styleTag, '');
                }, animationTiming);
            });
        };
        _this.animateClose = function () {
            var panel = _this.panel.current;
            var animationTiming = _this.props.animationTiming;
            var prefersReducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
            if (!animationTiming || prefersReducedMotion) {
                _this.setState({ isAnimating: false });
                return;
            }
            if (!_this.styleTag) {
                _this.styleTag = injectStyleTag();
            }
            var rect = panel === null || panel === void 0 ? void 0 : panel.getBoundingClientRect();
            if (!rect)
                return;
            setStyle(_this.styleTag, "\n      @keyframes collapseCloseAnimation {\n        0% { opacity: 1; height: ".concat(rect.height, "px; }\n        100% { opacity: 0; height: 0; }\n      }\n\n      .cauldron-collapse-close {\n        will-change: opacity, height;\n        overflow: hidden;\n        animation: collapseCloseAnimation ease-in-out ").concat(animationTiming, "ms forwards;\n      }\n    "));
            _this.setState({ animationClass: 'cauldron-collapse-close' }, function () {
                setTimeout(function () {
                    _this.setState({ animationClass: '', isAnimating: false });
                    setStyle(_this.styleTag, '');
                }, animationTiming);
            });
        };
        return _this;
    }
    ExpandCollapsePanel.prototype.componentWillUnmount = function () {
        var styleTag = this.styleTag;
        if (styleTag) {
            removeStyleTag(styleTag);
        }
    };
    ExpandCollapsePanel.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a = this.state, openState = _a.isOpen, controlled = _a.controlled;
        var openProp = this.props.open;
        if (controlled && openState !== openProp) {
            this.setState({ isOpen: !!openProp, isAnimating: true });
        }
        if (typeof openProp !== typeof prevProps.open) {
            this.setState({ controlled: typeof openProp !== 'undefined' });
        }
        if (prevState.isOpen !== openState && openState) {
            this.animateOpen();
        }
        else if (prevState.isOpen !== openState && !openState) {
            this.animateClose();
        }
    };
    ExpandCollapsePanel.prototype.render = function () {
        var _a = this.props, children = _a.children; _a.animationTiming; var className = _a.className; _a.onToggle; _a.open; var otherProps = tslib.__rest(_a, ["children", "animationTiming", "className", "onToggle", "open"]);
        var _b = this.state, isOpen = _b.isOpen, isAnimating = _b.isAnimating, animationClass = _b.animationClass;
        var trigger = React__default["default"].Children.toArray(children).find(function (child) { return child.type === PanelTrigger$1; });
        var panelElements = React__default["default"].Children.toArray(children).filter(function (child) {
            return typeof child === 'string' ||
                child.type !== PanelTrigger$1;
        });
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            trigger &&
                React__default["default"].cloneElement(trigger, {
                    open: isOpen,
                    onClick: this.handleToggle
                }),
            React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"](className, 'ExpandCollapse__panel', animationClass, {
                    'is--hidden': !isOpen && !isAnimating
                }), ref: this.panel }, otherProps), panelElements)));
    };
    ExpandCollapsePanel.defaultProps = {
        animationTiming: 250,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onToggle: function () { }
    };
    return ExpandCollapsePanel;
}(React__default["default"].Component));

var AccordionTrigger = function (_a) {
    var children = _a.children; tslib.__rest(_a, ["children"]);
    return React__default["default"].createElement(React__default["default"].Fragment, null, children);
};
var AccordionContent = function (_a) {
    var children = _a.children, className = _a.className, otherProps = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('Accordion__panel', className) }, otherProps), children));
};
var Accordion = function (_a) {
    var children = _a.children, open = _a.open, onToggle = _a.onToggle, animationTiming = _a.animationTiming, props = tslib.__rest(_a, ["children", "open", "onToggle", "animationTiming"]);
    var elementId = nextId.useId();
    var childrenArray = React__default["default"].Children.toArray(children);
    var trigger = childrenArray.find(function (child) {
        return typeof child === 'string' ||
            (React__default["default"].isValidElement(child) && child.type === AccordionTrigger);
    });
    var panelElement = childrenArray.find(function (child) {
        return typeof child === 'string' ||
            (React__default["default"].isValidElement(child) && child.type === AccordionContent);
    });
    if (!React__default["default"].isValidElement(trigger) ||
        !React__default["default"].isValidElement(panelElement)) {
        console.warn('Must provide <AccordionTrigger /> and <AccordionContent /> element(s). You provided:', {
            trigger: trigger,
            panelElement: panelElement,
            isValid: false
        });
        return null;
    }
    var panelProps = panelElement.props;
    return (React__default["default"].createElement("div", tslib.__assign({ className: "Accordion" }, props),
        React__default["default"].createElement(ExpandCollapsePanel, tslib.__assign({ id: panelProps.id || "".concat(elementId, "-panel"), open: open, onToggle: onToggle, animationTiming: animationTiming }, panelProps),
            React__default["default"].createElement(PanelTrigger$1, tslib.__assign({ iconCollapsed: "triangle-right", iconExpanded: "triangle-down", "aria-controls": panelProps.id || "".concat(elementId, "-panel"), heading: trigger.props.heading }, trigger.props, { className: classNames__default["default"]('Accordion__trigger', trigger.props.className) }), trigger),
            panelElement)));
};
Accordion.displayName = 'Accordion';
AccordionContent.displayName = 'AccordionContent';
AccordionTrigger.displayName = 'AccordionTrigger';

var Scrim = /** @class */ (function (_super) {
    tslib.__extends(Scrim, _super);
    function Scrim(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            animationClass: '',
            destroy: !props.show
        };
        return _this;
    }
    Scrim.prototype.componentDidMount = function () {
        if (this.props.show) {
            this.fadeIn();
        }
    };
    Scrim.prototype.fadeIn = function () {
        var _this = this;
        this.setState({ destroy: false }, function () {
            _this.setState({
                animationClass: 'Scrim--show'
            });
            // using setTimeout because css transitions require us to add the classes separately
            setTimeout(function () {
                if (!_this.el) {
                    return;
                }
                _this.setState({
                    animationClass: 'Scrim--show Scrim--fade-in'
                });
            });
        });
    };
    Scrim.prototype.fadeOut = function () {
        var _this = this;
        this.setState({ animationClass: 'Scrim--show' }, function () {
            // using setTimeout because css transitions require us to add the classes separately
            setTimeout(function () {
                _this.setState({ animationClass: '' }, function () {
                    _this.setState({ destroy: true });
                });
            }, 100);
        });
    };
    Scrim.prototype.componentDidUpdate = function (prevProps) {
        var show = this.props.show;
        var changed = typeof show !== 'undefined' && prevProps.show !== show;
        if (changed) {
            if (!prevProps.show) {
                return this.fadeIn();
            }
            this.fadeOut();
        }
    };
    Scrim.prototype.render = function () {
        var _this = this;
        var _a = this.state, animationClass = _a.animationClass, destroy = _a.destroy;
        if (destroy) {
            return null;
        }
        return (React__default["default"].createElement("div", { ref: function (el) {
                _this.el = el;
            }, className: "Scrim ".concat(animationClass) }));
    };
    return Scrim;
}(React__default["default"].Component));

function clickLink(target, item) {
    item = item || target;
    var link = target.tagName !== 'A' && item.querySelector('a');
    if (!link) {
        return;
    }
    link.click();
}

// used for components that need to access and set the ref
function setRef(ref, element) {
    if (!ref)
        return;
    if (typeof ref === 'function') {
        ref(element);
    }
    else {
        // eslint-disable-next-line
        // @ts-ignore
        // we need to overwrite the existing value in some special cases
        ref.current = element;
    }
}

var MenuItem = /** @class */ (function (_super) {
    tslib.__extends(MenuItem, _super);
    function MenuItem(props) {
        var _this = _super.call(this, props) || this;
        _this.onClick = _this.onClick.bind(_this);
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        return _this;
    }
    MenuItem.prototype.onClick = function (e) {
        var _a = this.props, autoClickLink = _a.autoClickLink, onClick = _a.onClick;
        if (autoClickLink) {
            clickLink(e.target, this.item);
        }
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    MenuItem.prototype.onKeyDown = function (e) {
        var _a, _b, _c;
        var key = keyname__default["default"](e.which);
        if (key === 'enter' || key === 'space') {
            e.preventDefault();
            (_a = this.item) === null || _a === void 0 ? void 0 : _a.click();
        }
        (_c = (_b = this.props).onKeyDown) === null || _c === void 0 ? void 0 : _c.call(_b, e);
    };
    MenuItem.prototype.render = function () {
        var _this = this;
        // eslint-disable-next-line no-unused-vars
        var _a = this.props, children = _a.children, menuItemRef = _a.menuItemRef; _a.autoClickLink; var other = tslib.__rest(_a, ["children", "menuItemRef", "autoClickLink"]);
        return (React__default["default"].createElement("li", tslib.__assign({}, other, { role: "menuitem", ref: function (item) {
                _this.item = item;
                setRef(menuItemRef, item);
            }, onClick: this.onClick, onKeyDown: this.onKeyDown }), children));
    };
    MenuItem.displayName = 'MenuItem';
    MenuItem.defaultProps = {
        autoClickLink: true
    };
    return MenuItem;
}(React.Component));

var MENU_BREAKPOINT = 1024;

function isBrowser() {
    return (typeof window !== 'undefined' &&
        !!window.document &&
        !!window.document.createElement);
}

var isWide = function () {
    if (!isBrowser()) {
        return false;
    }
    return window.innerWidth >= MENU_BREAKPOINT;
};

var TopBar$1 = /** @class */ (function (_super) {
    tslib.__extends(TopBar, _super);
    function TopBar(props) {
        var _this = _super.call(this, props) || this;
        _this.menuBarRef = React__default["default"].createRef();
        _this.onResize = function () {
            var wide = isWide();
            if (wide === _this.state.wide) {
                return;
            }
            _this.setState({
                wide: wide
            });
        };
        _this.handleThin = function () {
            var thin = _this.props.thin;
            if (thin) {
                document.body.classList.add('TopBar--thin');
                return;
            }
            document.body.classList.remove('TopBar--thin');
        };
        _this.renderChild = function (child, index) {
            if (!child) {
                return null;
            }
            return React.cloneElement(child, {
                key: index,
                tabIndex: typeof child.props.tabIndex === 'undefined' ? 0 : child.props.tabIndex
            });
        };
        var wide = isWide();
        _this.state = {
            wide: wide
        };
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        return _this;
    }
    TopBar.prototype.componentDidMount = function () {
        this.handleThin();
        window.addEventListener('resize', this.onResize);
    };
    TopBar.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onResize);
    };
    TopBar.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.thin === this.props.thin) {
            return;
        }
        this.handleThin();
    };
    TopBar.prototype.onKeyDown = function (e) {
        var key = keyname__default["default"](e.which);
        var menuBarElement = this.menuBarRef.current;
        if (!menuBarElement) {
            return;
        }
        var menuItems = Array.from(menuBarElement.children);
        // account for hidden side bar trigger (hamburger)
        if (this.state.wide && this.props.hasTrigger) {
            menuItems.shift();
        }
        var currentIndex = menuItems.findIndex(function (menuitem) { return menuitem === e.target; });
        if (currentIndex === -1 || (key !== 'left' && key !== 'right')) {
            return;
        }
        e.preventDefault();
        var adjacentIndex = key === 'left' ? currentIndex - 1 : currentIndex + 1;
        // circular arrow focus
        if (adjacentIndex === -1) {
            // first to last
            adjacentIndex = menuItems.length - 1;
        }
        else if (adjacentIndex === menuItems.length) {
            // last to first
            adjacentIndex = 0;
        }
        menuItems[adjacentIndex].focus();
    };
    TopBar.prototype.render = function () {
        // disabling no-unused-vars to prevent thin/hasTrigger from being passed through to div
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var _a = this.props, children = _a.children, className = _a.className; _a.thin; _a.hasTrigger; tslib.__rest(_a, ["children", "className", "thin", "hasTrigger"]);
        return (React__default["default"].createElement("ul", { role: "menubar", onKeyDown: this.onKeyDown, className: className, ref: this.menuBarRef }, React.Children.map(children, this.renderChild)));
    };
    TopBar.defaultProps = {
        thin: false,
        hasTrigger: false
    };
    return TopBar;
}(React__default["default"].Component));

var TopBar = function (props) {
    var children = props.children, className = props.className, other = tslib.__rest(props, ["children", "className"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"](className, {
            // TopBar's default style is dark mode
            TopBar: true
        }) }, other), children));
};

var TopBarTrigger = function (_a) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement(MenuItem, tslib.__assign({ "aria-haspopup": "true", className: classNames__default["default"]('TopBar__menu-trigger', className) }, other), children));
};
TopBarTrigger.displayName = 'TopBarTrigger';

var menuAlignment = function (type) {
    switch (type) {
        case 'left':
            return 'OptionsMenu--align-left';
        case 'right':
            return 'OptionsMenu--align-right';
    }
};
/**
 * Wrapper / parent component for the <OptionsMenuTrigger /> and <OptionsMenu /> components
 */
var OptionsMenuWrapper = function (_a) {
    var className = _a.className, align = _a.align, other = tslib.__rest(_a, ["className", "align"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('OptionsMenu', menuAlignment(align), className) }, other)));
};

/**
 * When an element can be passed as a value that is either an element or an
 * elementRef, this will resolve the property down to the resulting element
 */
function resolveElement(elementOrRef) {
    if (elementOrRef instanceof Element) {
        return elementOrRef;
    }
    if (elementOrRef &&
        typeof elementOrRef === 'object' &&
        'current' in elementOrRef &&
        elementOrRef.current instanceof Element) {
        return elementOrRef.current;
    }
    return null;
}

function getChildRef(child, version) {
    if (version === void 0) { version = React__default["default"].version; }
    return parseInt(version, 10) >= 19
        ? child.props.ref
        : child.ref;
}

function ClickOutsideListener(_a, ref) {
    var children = _a.children, _b = _a.mouseEvent, mouseEvent = _b === void 0 ? 'click' : _b, _c = _a.touchEvent, touchEvent = _c === void 0 ? 'touchend' : _c, target = _a.target, _d = _a.onClickOutside, onClickOutside = _d === void 0 ? function () { return null; } : _d;
    var childElementRef = React.useRef(null);
    var handleEvent = function (event) {
        if (event.defaultPrevented) {
            return;
        }
        var eventTarget = event.target;
        var elementTarget = resolveElement(target);
        if (target && !(elementTarget === null || elementTarget === void 0 ? void 0 : elementTarget.contains(eventTarget))) {
            onClickOutside(event);
            // If a target is passed in via a prop, we defer to utilizing that
            // target instead of a child element target
            return;
        }
        if (!target &&
            childElementRef.current &&
            !childElementRef.current.contains(eventTarget)) {
            onClickOutside(event);
        }
    };
    var resolveRef = function (node) {
        childElementRef.current = node;
        // Ref for this component should pass-through to the child node
        setRef(ref, node);
        // Forward the child's own ref. In React 19 ref lives in props; in 16–18 it's element.ref.
        var childRef = getChildRef(children);
        setRef(childRef, node);
    };
    React.useEffect(function () {
        typeof mouseEvent === 'string' &&
            document.addEventListener(mouseEvent, handleEvent, true);
        typeof touchEvent === 'string' &&
            document.addEventListener(touchEvent, handleEvent, true);
        return function () {
            typeof mouseEvent === 'string' &&
                document.removeEventListener(mouseEvent, handleEvent, true);
            typeof touchEvent === 'string' &&
                document.removeEventListener(touchEvent, handleEvent, true);
        };
    }, [mouseEvent, touchEvent]);
    return !children
        ? null
        : React__default["default"].cloneElement(children, { ref: resolveRef });
}
ClickOutsideListener.displayName = 'ClickOutsideListener';
var ClickOutsideListener$1 = React__default["default"].forwardRef(ClickOutsideListener);

var _a$3 = tslib.__read([38, 40, 9, 13, 32, 27], 6), up = _a$3[0], down$1 = _a$3[1], tab = _a$3[2], enter = _a$3[3], space = _a$3[4], esc = _a$3[5];
var OptionsMenuList = function (_a) {
    var children = _a.children, menuRef = _a.menuRef, show = _a.show, className = _a.className, _b = _a.onClose, onClose = _b === void 0 ? function () { } : _b, // eslint-disable-line @typescript-eslint/no-empty-function
    _c = _a.onSelect, // eslint-disable-line @typescript-eslint/no-empty-function
    onSelect = _c === void 0 ? function () { } : _c, // eslint-disable-line @typescript-eslint/no-empty-function
    _d = _a.closeOnSelect, // eslint-disable-line @typescript-eslint/no-empty-function
    closeOnSelect = _d === void 0 ? true : _d, other = tslib.__rest(_a, ["children", "menuRef", "show", "className", "onClose", "onSelect", "closeOnSelect"]);
    var _e = tslib.__read(React.useState(0), 2), itemIndex = _e[0], setItemIndex = _e[1];
    var itemRefs = React.useRef([]);
    var menuRefInternal = React.useRef(null);
    var triggerRef = React.useRef(null);
    React.useEffect(function () {
        var _a;
        if (show && itemRefs.current.length) {
            // handles opens
            triggerRef.current = document.activeElement;
            (_a = itemRefs.current[0]) === null || _a === void 0 ? void 0 : _a.focus();
            setItemIndex(0);
        }
        if (!show) {
            triggerRef.current = null;
        }
    }, [show]);
    React.useEffect(function () {
        var _a;
        (_a = itemRefs.current[itemIndex]) === null || _a === void 0 ? void 0 : _a.focus();
    }, [itemIndex]);
    var handleKeyDown = function (e) {
        var which = e.which, target = e.target;
        switch (which) {
            case up:
            case down$1: {
                var itemCount = itemRefs.current.length;
                var newIndex = which === 38 ? itemIndex - 1 : itemIndex + 1;
                // circularity
                if (newIndex === -1) {
                    newIndex = itemCount - 1;
                }
                else if (newIndex === itemCount) {
                    newIndex = 0;
                }
                e.preventDefault();
                setItemIndex(newIndex);
                break;
            }
            case esc:
                onClose();
                break;
            case enter:
            case space:
                e.preventDefault();
                target.click();
                break;
            case tab:
                e.preventDefault();
                onClose();
        }
    };
    React.useEffect(function () {
        var currentMenuRef = menuRefInternal.current;
        currentMenuRef === null || currentMenuRef === void 0 ? void 0 : currentMenuRef.addEventListener('keydown', handleKeyDown);
        return function () {
            currentMenuRef === null || currentMenuRef === void 0 ? void 0 : currentMenuRef.removeEventListener('keydown', handleKeyDown);
        };
    }, [handleKeyDown]);
    var handleClick = function (e) {
        if (menuRefInternal.current &&
            menuRefInternal.current.contains(e.target)) {
            if (!e.defaultPrevented && closeOnSelect) {
                onClose();
            }
            onSelect(e);
        }
        var link = e.target.querySelector('a');
        if (link) {
            link.click();
        }
    };
    var handleClickOutside = function (e) {
        var target = e.target;
        var triggerElement = triggerRef.current;
        if (target === triggerElement || (triggerElement === null || triggerElement === void 0 ? void 0 : triggerElement.contains(target))) {
            return;
        }
        if (show) {
            e.preventDefault();
            onClose();
        }
    };
    var items = React__default["default"].Children.toArray(children).map(function (child, i) {
        var _a = child.props, childClassName = _a.className, childProps = tslib.__rest(_a, ["className"]);
        return React__default["default"].cloneElement(child, tslib.__assign({ key: "list-item-".concat(i), className: classNames__default["default"]('OptionsMenu__list-item', childClassName), tabIndex: -1, role: 'menuitem', ref: function (el) { return (itemRefs.current[i] = el); } }, childProps));
    });
    // This allows the ClickOutsideListener to only be activated when the menu is
    // currently open. This prevents an obscure behavior where the activation of a
    // different menu would cause all menus to close
    var clickOutsideEventActive = !show ? false : undefined;
    // Key event is being handled in the useEffect above
    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/role-supports-aria-props */
    return (React__default["default"].createElement(ClickOutsideListener$1, { onClickOutside: handleClickOutside, mouseEvent: clickOutsideEventActive, touchEvent: clickOutsideEventActive },
        React__default["default"].createElement("ul", tslib.__assign({}, other, { className: classNames__default["default"]('OptionsMenu__list', className, {
                'OptionsMenu--expanded': show
            }), role: "menu", onClick: handleClick, ref: function (el) {
                menuRefInternal.current = el;
                if (menuRef) {
                    setRef(menuRef, el);
                }
            } }), items)));
};

var _a$2 = tslib.__read([40], 1), down = _a$2[0];
var OptionsMenu = function (_a) {
    var children = _a.children, className = _a.className; _a.closeOnSelect; var menuRef = _a.menuRef, trigger = _a.trigger, _b = _a.align, align = _b === void 0 ? 'right' : _b, _c = _a.onClose, onClose = _c === void 0 ? function () { } : _c, // eslint-disable-line @typescript-eslint/no-empty-function
    _d = _a.onSelect, // eslint-disable-line @typescript-eslint/no-empty-function
    onSelect = _d === void 0 ? function () { } : _d, // eslint-disable-line @typescript-eslint/no-empty-function
    other = tslib.__rest(_a, ["children", "className", "closeOnSelect", "menuRef", "trigger", "align", "onClose", "onSelect"]);
    var _e = tslib.__read(React.useState(false), 2), show = _e[0], setShow = _e[1];
    var triggerRef = React.useRef(null);
    var toggleMenu = function (e) {
        if (e.defaultPrevented) {
            return;
        }
        setShow(!show);
    };
    var handleClose = function () {
        var _a;
        setShow(false);
        onClose();
        (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var handleTriggerKeyDown = function (event) {
        var which = event.which, target = event.target;
        if (which === down) {
            event.preventDefault();
            target.click();
        }
    };
    return (React__default["default"].createElement(OptionsMenuWrapper, { align: align, className: className },
        trigger &&
            trigger({
                onClick: toggleMenu,
                'aria-expanded': show,
                ref: triggerRef,
                onKeyDown: handleTriggerKeyDown
            }),
        React__default["default"].createElement(OptionsMenuList, tslib.__assign({ show: show, menuRef: function (el) {
                if (menuRef) {
                    setRef(menuRef, el);
                }
            }, onClose: handleClose, onSelect: onSelect }, other), children)));
};

function OptionsMenuItemComponent(_a) {
    var disabled = _a.disabled, className = _a.className, menuItemRef = _a.menuItemRef, _b = _a.onSelect, onSelect = _b === void 0 ? function () { } : _b, // eslint-disable-line @typescript-eslint/no-empty-function
    other = tslib.__rest(_a, ["disabled", "className", "menuItemRef", "onSelect"]);
    function handleClick(event) {
        if (!disabled) {
            onSelect(event);
        }
    }
    return (
    // keydown happens in OptionsMenu which proxies to click
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events
    React__default["default"].createElement("li", tslib.__assign({ role: "menuitem", ref: menuItemRef, "aria-disabled": disabled, onClick: handleClick, className: className }, other)));
}
var OptionsMenuItem = React.forwardRef(function (_a, ref) {
    var props = tslib.__rest(_a, []);
    return (React__default["default"].createElement(OptionsMenuItemComponent, tslib.__assign({ menuItemRef: ref }, props)));
});
OptionsMenuItem.displayName = 'OptionsMenuItem';

/**
 * The trigger button component to be used as the default component
 * that triggers the opening of an <OptionsMenu />.
 */
function OptionsMenuTriggerComponent(_a) {
    var className = _a.className, triggerRef = _a.triggerRef, other = tslib.__rest(_a, ["className", "triggerRef"]);
    return (React__default["default"].createElement("button", tslib.__assign({ type: "button", "aria-haspopup": "menu", ref: triggerRef }, other, { className: classNames__default["default"]('OptionsMenu__trigger', className) })));
}
var OptionsMenuTrigger = React__default["default"].forwardRef(function OptionsMenuTrigger(props, ref) {
    return React__default["default"].createElement(OptionsMenuTriggerComponent, tslib.__assign({}, props, { triggerRef: ref }));
});

var TopBarMenu = /** @class */ (function (_super) {
    tslib.__extends(TopBarMenu, _super);
    function TopBarMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            open: false
        };
        _this.handleClick = function (e) {
            var _a = _this, optionsMenuRef = _a.optionsMenuRef, state = _a.state;
            var open = state.open;
            if (optionsMenuRef && !optionsMenuRef.contains(e.target)) {
                _this.setState({ open: !open });
                e.preventDefault();
            }
        };
        _this.handleClose = function () {
            var _a;
            _this.setState({ open: false });
            (_a = _this.menuItemRef) === null || _a === void 0 ? void 0 : _a.focus();
        };
        _this.handleKeyDown = function (e) {
            var _a;
            var key = keyname__default["default"](e.which);
            var _b = _this, handleClose = _b.handleClose, state = _b.state, props = _b.props;
            var open = state.open;
            var onKeyDown = props.onKeyDown;
            if ((key === 'left' || key === 'right') && open) {
                handleClose();
            }
            else if (key === 'down' && !open) {
                _this.setState({ open: true });
                (_a = _this.optionsMenuRef) === null || _a === void 0 ? void 0 : _a.focus();
            }
            onKeyDown(e);
        };
        return _this;
    }
    TopBarMenu.prototype.render = function () {
        var _this = this;
        var _a = this, props = _a.props, state = _a.state, handleClick = _a.handleClick, handleClose = _a.handleClose, handleKeyDown = _a.handleKeyDown;
        var children = props.children, id = props.id, other = tslib.__rest(props, ["children", "id"]);
        var open = state.open;
        var menu = React__default["default"].Children.toArray(children).find(function (child) { return child.type === OptionsMenuList; });
        var otherChildren = React__default["default"].Children.toArray(children).filter(function (child) {
            return typeof child === 'string' ||
                child.type !== OptionsMenuList;
        });
        return (React__default["default"].createElement(MenuItem, tslib.__assign({}, other, { menuItemRef: function (el) {
                _this.menuItemRef = el;
                setRef(props.menuItemRef, el);
            }, "aria-controls": id, "aria-expanded": open, onClick: handleClick, onKeyDown: handleKeyDown }),
            otherChildren,
            React__default["default"].cloneElement(menu, {
                id: id,
                className: classNames__default["default"]('Dropdown', {
                    'Dropdown--active': open
                }),
                menuRef: function (el) { return (_this.optionsMenuRef = el); },
                show: open,
                onClose: handleClose
            })));
    };
    TopBarMenu.defaultProps = {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onKeyDown: function () { },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        menuItemRef: function () { }
    };
    return TopBarMenu;
}(React__default["default"].Component));

var NavBar = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.collapsed, collapsed = _b === void 0 ? false : _b, _c = _a.navTriggerLabel, navTriggerLabel = _c === void 0 ? 'MAIN MENU' : _c, propId = _a.propId, props = tslib.__rest(_a, ["children", "className", "collapsed", "navTriggerLabel", "propId"]);
    var navRef = React.useRef(null);
    var triggerRef = React.useRef(null);
    var _d = tslib.__read(React.useState(false), 2), showDropdown = _d[0], setShowDropdown = _d[1];
    var _e = tslib.__read([propId] || nextId.useId(1, 'navbar'), 1), menuId = _e[0];
    var showNavItems = !collapsed || (collapsed && showDropdown);
    var handleOutSideEvent = function (e) {
        var _a;
        var target = e.target;
        if (navRef.current && !((_a = navRef.current) === null || _a === void 0 ? void 0 : _a.contains(target))) {
            setShowDropdown(false);
        }
    };
    var handleKeyDown = function (e) {
        var _a;
        if (e.key !== 'Escape') {
            return;
        }
        setShowDropdown(false);
        (_a = triggerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    React.useEffect(function () {
        if (collapsed && showDropdown) {
            document.addEventListener('focusin', handleOutSideEvent);
            return function () {
                document.removeEventListener('focusin', handleOutSideEvent);
            };
        }
    }, [collapsed, showDropdown]);
    var handleTriggerClick = function () {
        setShowDropdown(!showDropdown);
    };
    return (React__default["default"].createElement("nav", tslib.__assign({ className: classNames__default["default"]('NavBar', className, {
            'NavBar--collapsed': collapsed
        }), ref: navRef }, props),
        collapsed && (React__default["default"].createElement("button", { "aria-haspopup": "true", "aria-expanded": showDropdown, "aria-controls": menuId, ref: triggerRef, onClick: handleTriggerClick, className: classNames__default["default"]('NavBar__trigger', {
                'NavBar__trigger--active': showDropdown
            }) },
            React__default["default"].createElement(Icon, { type: showDropdown ? 'close' : 'hamburger-menu' }),
            navTriggerLabel)),
        showNavItems && (React__default["default"].createElement("ul", { onKeyDown: handleKeyDown, id: menuId }, children))));
};
NavBar.displayName = 'NavBar';

var NavItem = function (_a) {
    var children = _a.children, active = _a.active, _b = _a["aria-current"], ariaCurrent = _b === void 0 ? true : _b, other = tslib.__rest(_a, ["children", "active", 'aria-current']);
    var additionalProps = {};
    if (active) {
        additionalProps['aria-current'] = ariaCurrent;
    }
    return (React__default["default"].createElement("li", tslib.__assign({ className: classNames__default["default"]('NavItem', {
            'NavItem--active': active
        }) }, additionalProps, other), children));
};
NavItem.displayName = 'NavItem';

/**
 * Selector for NATURALLY focusable elements
 * @type {String}
 */
var focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    'area[href]',
    'iframe',
    'object',
    'embed',
    '[tabindex="0"]',
    '[contenteditable]',
    'audio[controls]',
    'video[controls]'
].join(', ');

var SideBar = /** @class */ (function (_super) {
    tslib.__extends(SideBar, _super);
    function SideBar(props) {
        var _this = _super.call(this, props) || this;
        _this.navList = React__default["default"].createRef();
        _this.onKeyDown = _this.onKeyDown.bind(_this);
        _this.handleResize = _this.handleResize.bind(_this);
        _this.handleClickOutside = _this.handleClickOutside.bind(_this);
        _this.state = {
            wide: isWide()
        };
        return _this;
    }
    SideBar.prototype.componentDidMount = function () {
        var _this = this;
        this.resizeDebounce = function () {
            if (_this.resizeDebounceId) {
                cancelAnimationFrame(_this.resizeDebounceId);
            }
            _this.resizeDebounceId = requestAnimationFrame(function () {
                _this.handleResize();
            });
        };
        window.addEventListener('resize', this.resizeDebounce);
    };
    SideBar.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.resizeDebounce);
    };
    SideBar.prototype.handleResize = function () {
        var wide = isWide();
        if (wide === this.state.wide) {
            return;
        }
        this.setState({ wide: wide });
    };
    SideBar.prototype.onKeyDown = function (e) {
        var onDismiss = this.props.onDismiss;
        if (keyname__default["default"](e.which) !== 'esc') {
            return;
        }
        onDismiss();
    };
    SideBar.prototype.handleClickOutside = function () {
        var _a = this.props, show = _a.show, onDismiss = _a.onDismiss;
        if (show && !this.state.wide) {
            onDismiss();
        }
    };
    SideBar.prototype.componentDidUpdate = function (prevProps) {
        var show = this.props.show;
        if (prevProps.show === show) {
            return;
        }
        this.animate();
    };
    SideBar.prototype.animate = function () {
        var _this = this;
        var show = this.props.show;
        var _a = tslib.__read(show
            ? ['SideBar--show', 'SideBar--show SideBar--active']
            : ['SideBar--show', ''], 2), first = _a[0], second = _a[1];
        this.setState({ animateClass: first });
        // css3 animations require transition classes to be added on separate tics
        setTimeout(function () {
            var _a, _b;
            _this.setState({ animateClass: second });
            var firstFocusable = show &&
                ((_b = (_a = _this.navList) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.querySelector(focusableSelector));
            if (firstFocusable) {
                firstFocusable.focus();
            }
        }, 100); // slide out animation requires a min timeout of 100ms
    };
    SideBar.prototype.render = function () {
        var _a = this.state, animateClass = _a.animateClass, wide = _a.wide;
        // disabling no-unused-vars to prevent onDismiss from being passed through to dom element
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        var _b = this.props, children = _b.children, className = _b.className, show = _b.show; _b.onDismiss; var navProps = _b.navProps, other = tslib.__rest(_b, ["children", "className", "show", "onDismiss", "navProps"]);
        /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
        return (React__default["default"].createElement(React.Fragment, null,
            React__default["default"].createElement(ClickOutsideListener$1, { onClickOutside: this.handleClickOutside },
                React__default["default"].createElement("nav", tslib.__assign({}, navProps),
                    React__default["default"].createElement("ul", tslib.__assign({ className: classNames__default["default"]('SideBar', className, animateClass) }, other, { ref: this.navList, onKeyDown: this.onKeyDown }), children))),
            React__default["default"].createElement(Scrim, { show: !wide && show })));
        /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */
    };
    SideBar.defaultProps = {
        className: '',
        show: false
    };
    return SideBar;
}(React.Component));

var SideBarItem = function (_a) {
    var children = _a.children, _b = _a.autoClickLink, autoClickLink = _b === void 0 ? true : _b, other = tslib.__rest(_a, ["children", "autoClickLink"]);
    var onClick = function (e) {
        if (!autoClickLink) {
            return;
        }
        clickLink(e.target);
    };
    /* eslint-disable jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */
    return (React__default["default"].createElement("li", tslib.__assign({ onClick: onClick }, other), children));
    /* eslint-enable jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events */
};
SideBarItem.displayName = 'SideBarItem';

/**
 * Handles aria-hidden for dialogs.
 */
var AriaIsolate = /** @class */ (function () {
    function AriaIsolate(el) {
        // eslint-disable-next-line ssr-friendly/no-dom-globals-in-constructor
        if (typeof HTMLElement === 'undefined' || !(el instanceof HTMLElement)) {
            throw new Error('AriaIsolate must be instantiated with a valid HTML element');
        }
        this.element = el;
        this.affectedElements = [];
    }
    /**
     * applies aria-hidden to everything except direct parents of `this.element`
     */
    AriaIsolate.prototype.activate = function () {
        var _this = this;
        var parent = this.element.parentNode;
        while (parent && parent.nodeName !== 'HTML') {
            Array.prototype.slice
                .call(parent.children)
                .forEach(function (child) {
                if (child !== _this.element && !child.contains(_this.element)) {
                    if (child.getAttribute('aria-hidden') === 'true') {
                        return;
                    }
                    _this.affectedElements.push(child);
                    child.setAttribute('aria-hidden', 'true');
                }
            });
            parent = parent.parentNode;
        }
    };
    /**
     * restores aria-hidden state by removing aria-hidden="true"
     * from everything affected by 'activate'
     */
    AriaIsolate.prototype.deactivate = function () {
        this.affectedElements.forEach(function (affected) {
            return affected.removeAttribute('aria-hidden');
        });
        this.affectedElements = [];
    };
    return AriaIsolate;
}());

/**
 * When a component needs to track an internal ref on a component that has a
 * forwarded ref, useSharedRef will return a RefObject<T | null> that will
 * correctly invoke the parent ref as well providing an internal ref.
 *
 * @example
 * React.forwardRef(function Component({ children }, ref) {
 *   const internalRef = useSharedRef<HTMLElement>(ref)
 *   if (internalRef.current) {
 *     // do something with the internal ref...
 *   }
 *   return (<div ref={internalRef}>...</div>)
 * })
 */
function useSharedRef(ref) {
    var internalRef = React.useRef(null);
    React.useEffect(function () {
        setRef(ref, internalRef.current);
        return function () { return setRef(ref, null); };
    }, [ref]);
    return internalRef;
}

// When multiple focus traps are created, we need to keep track of all previous traps
// in the stack and temporarily suspend any traps created before the most recent trap
var focusTrapStack = [];
var removeFocusTrapFromStack = function (focusTrap) {
    var focusTrapIndex = focusTrapStack.findIndex(function (trap) { return focusTrap.targetElement === trap.targetElement; });
    focusTrapStack.splice(focusTrapIndex, 1);
};
function getActiveElement$1(target) {
    var _a;
    return (((_a = target === null || target === void 0 ? void 0 : target.ownerDocument.activeElement) !== null && _a !== void 0 ? _a : document.activeElement) ||
        document.body);
}
function elementContains(containerElement, targetElement) {
    if (!targetElement) {
        return false;
    }
    if (containerElement.getRootNode() === targetElement.getRootNode()) {
        return containerElement.contains(targetElement);
    }
    var root = targetElement.getRootNode();
    while (root && root !== containerElement.getRootNode()) {
        if (root.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
            // likely a shadow root, and we need to get the host
            root = root.host;
        }
        else {
            break;
        }
    }
    return root && containerElement.contains(root);
}
function createTrapGuard() {
    var trapGuard = document.createElement('span');
    trapGuard.setAttribute('tabindex', '0');
    trapGuard.setAttribute('aria-hidden', 'true');
    return trapGuard;
}
function createFocusTrap(targetElement, initialFocusElement) {
    var _a;
    var startGuard = createTrapGuard();
    var endGuard = createTrapGuard();
    targetElement.insertAdjacentElement('beforebegin', startGuard);
    targetElement.insertAdjacentElement('afterend', endGuard);
    var focusTrapMetadata = {
        targetElement: targetElement,
        lastFocusedElement: null,
        suspended: false
    };
    var focusListener = function (event) {
        var _a, _b, _c, _d;
        var eventTarget = event.target;
        var elementContainsTarget = elementContains(targetElement, eventTarget);
        if (focusTrapMetadata.suspended) {
            return;
        }
        if (!elementContainsTarget) {
            // If the event target element is not contained within the target element
            // for this focus trap, we need to prevent focus from escaping the container
            event.stopImmediatePropagation();
        }
        else if (eventTarget instanceof HTMLElement) {
            // Ensure we keep track of the most recent valid focus element if we
            // need to redirect focus later
            focusTrapMetadata.lastFocusedElement = eventTarget;
            return;
        }
        var focusableElements = Array.from((targetElement === null || targetElement === void 0 ? void 0 : targetElement.querySelectorAll(focusable__default["default"])) || []);
        // If focus reaches the trap guards, we need to wrap focus around to the leading
        // or trailing focusable element depending on which guard obtained focus
        if (focusableElements.length && eventTarget === startGuard) {
            (_a = focusableElements.reverse()[0]) === null || _a === void 0 ? void 0 : _a.focus();
            return;
        }
        else if (focusableElements.length && eventTarget === endGuard) {
            (_b = focusableElements[0]) === null || _b === void 0 ? void 0 : _b.focus();
            return;
        }
        // If focus somehow escaped the trap, we need to try to restore focus to
        // to a suitable focusable element within the focus trap target. Otherwise
        // we'll need to focus on an alternative within the container.
        if (elementContains(targetElement, focusTrapMetadata.lastFocusedElement)) {
            (_c = focusTrapMetadata.lastFocusedElement) === null || _c === void 0 ? void 0 : _c.focus();
        }
        else if (focusableElements.length) {
            (_d = focusableElements[0]) === null || _d === void 0 ? void 0 : _d.focus();
        }
        else {
            // if there are no focusable elements, just focus the container
            targetElement.focus();
        }
    };
    document.addEventListener('focus', focusListener, true);
    if (focusTrapStack.length >= 1) {
        // Suspend any other traps in the stack while this one is active
        focusTrapStack.forEach(function (trap) {
            trap.suspended = true;
        });
    }
    focusTrapStack.push(focusTrapMetadata);
    if (initialFocusElement) {
        initialFocusElement.focus();
    }
    else {
        // Try to find a suitable focus element
        var focusableElements = Array.from((targetElement === null || targetElement === void 0 ? void 0 : targetElement.querySelectorAll(focusable__default["default"])) ||
            /* istanbul ignore else */ []);
        (_a = focusableElements[0]) === null || _a === void 0 ? void 0 : _a.focus();
    }
    return tslib.__assign(tslib.__assign({}, focusTrapMetadata), { initialFocusElement: initialFocusElement, destroy: function () {
            var _a, _b;
            document.removeEventListener('focus', focusListener, true);
            removeFocusTrapFromStack(focusTrapMetadata);
            (_a = startGuard.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(startGuard);
            (_b = endGuard.parentNode) === null || _b === void 0 ? void 0 : _b.removeChild(endGuard);
            // If there are any remaining focus traps in the stack, we need
            // to unsuspend the most recently added focus trap
            if (focusTrapStack.length) {
                focusTrapStack[focusTrapStack.length - 1].suspended = false;
            }
        } });
}
function useFocusTrap(target, options) {
    if (options === void 0) { options = {}; }
    var _a = options.disabled, disabled = _a === void 0 ? false : _a, _b = options.returnFocus, returnFocus = _b === void 0 ? true : _b, initialFocusElementOrRef = options.initialFocusElement, returnFocusElement = options.returnFocusElement;
    var focusTrap = React.useRef(null);
    var returnFocusElementRef = React.useRef(null);
    function restoreFocusToReturnFocusElement() {
        var _a;
        var resolvedReturnFocusElement = resolveElement(returnFocusElement);
        if (resolvedReturnFocusElement instanceof HTMLElement) {
            resolvedReturnFocusElement.focus();
        }
        else {
            (_a = returnFocusElementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            returnFocusElementRef.current = null;
        }
    }
    React.useEffect(function () {
        var targetElement = resolveElement(target);
        var initialFocusElement = resolveElement(initialFocusElementOrRef);
        if (!targetElement || disabled) {
            return;
        }
        returnFocusElementRef.current = getActiveElement$1(targetElement);
        focusTrap.current = createFocusTrap(targetElement, initialFocusElement);
        return function () {
            var _a;
            (_a = focusTrap.current) === null || _a === void 0 ? void 0 : _a.destroy();
            focusTrap.current = null;
            // istanbul ignore else
            if (returnFocus) {
                restoreFocusToReturnFocusElement();
            }
        };
    }, [target, disabled]);
    return focusTrap;
}

var DialogContext = React.createContext(null);
function useDialogContext() {
    var context = React.useContext(DialogContext);
    if (!context) {
        throw new Error('Dialog compound components must be rendered within a Dialog');
    }
    return context;
}

var isEscape = function (event) {
    return event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27;
};
var Dialog = React.forwardRef(function (_a, ref) {
    var dialogRefProp = _a.dialogRef, _b = _a.forceAction, forceAction = _b === void 0 ? false : _b, className = _a.className, children = _a.children, _c = _a.closeButtonText, closeButtonText = _c === void 0 ? 'Close' : _c, heading = _a.heading, _d = _a.show, show = _d === void 0 ? false : _d, portal = _a.portal, _e = _a.scrollable, scrollable = _e === void 0 ? false : _e, _f = _a.onClose, onClose = _f === void 0 ? function () { return null; } : _f, other = tslib.__rest(_a, ["dialogRef", "forceAction", "className", "children", "closeButtonText", "heading", "show", "portal", "scrollable", "onClose"]);
    var dialogRef = useSharedRef(dialogRefProp || ref);
    var _g = tslib.__read(nextId.useId(1, 'dialog-title-'), 1), headingId = _g[0];
    var headingRef = React.useRef(null);
    var isolatorRef = React.useRef(null);
    var headingLevel = typeof heading === 'object' && 'level' in heading && heading.level
        ? heading.level
        : 2;
    var handleClose = React.useCallback(function () {
        var _a;
        (_a = isolatorRef.current) === null || _a === void 0 ? void 0 : _a.deactivate();
        if (show) {
            onClose();
        }
    }, [show, onClose]);
    var handleClickOutside = React.useCallback(function () {
        if (show && !forceAction) {
            handleClose();
        }
    }, [show, forceAction, handleClose]);
    var focusHeading = React.useCallback(function () {
        var _a, _b;
        (_a = headingRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        (_b = isolatorRef.current) === null || _b === void 0 ? void 0 : _b.activate();
    }, []);
    var handleEscape = React.useCallback(function (keyboardEvent) {
        if (!keyboardEvent.defaultPrevented && isEscape(keyboardEvent)) {
            handleClose();
        }
    }, [handleClose]);
    React.useEffect(function () {
        if (!show || !dialogRef.current)
            return;
        isolatorRef.current = new AriaIsolate(dialogRef.current);
        setTimeout(focusHeading);
        return function () {
            var _a;
            (_a = isolatorRef.current) === null || _a === void 0 ? void 0 : _a.deactivate();
        };
    }, [show, focusHeading]);
    React.useEffect(function () {
        if (!forceAction) {
            var portalElement_1 = portal
                ? 'current' in portal
                    ? portal.current
                    : portal
                : document.body;
            if (show) {
                portalElement_1 === null || portalElement_1 === void 0 ? void 0 : portalElement_1.addEventListener('keyup', handleEscape);
            }
            return function () {
                portalElement_1 === null || portalElement_1 === void 0 ? void 0 : portalElement_1.removeEventListener('keyup', handleEscape);
            };
        }
    }, [show, forceAction, portal, handleEscape]);
    useFocusTrap(dialogRef, {
        disabled: !show,
        initialFocusElement: headingRef
    });
    React.useEffect(function () {
        if (show && !heading && dialogRef.current) {
            var hasHeading = dialogRef.current.querySelector('.Dialog__heading');
            if (process.env.NODE_ENV !== 'production' && !hasHeading) {
                throw Error('Dialog: No heading provided. When using a custom header, include a DialogHeading component for accessibility.');
            }
        }
    }, [show, heading]);
    var contextValue = React.useMemo(function () { return ({
        headingId: headingId,
        headingRef: headingRef,
        headingLevel: headingLevel,
        onClose: handleClose,
        forceAction: forceAction,
        closeButtonText: closeButtonText,
        scrollable: scrollable
    }); }, [
        headingId,
        headingRef,
        headingLevel,
        handleClose,
        forceAction,
        closeButtonText,
        scrollable
    ]);
    if (!show || !isBrowser()) {
        return null;
    }
    var portalElement = portal
        ? 'current' in portal
            ? portal.current
            : portal
        : // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
            document.body;
    var dialog = (React__default["default"].createElement(ClickOutsideListener$1, { onClickOutside: handleClickOutside },
        React__default["default"].createElement("div", tslib.__assign({ role: "dialog", className: classNames__default["default"]('Dialog', className, {
                'Dialog--show': show
            }), ref: dialogRef, "aria-labelledby": headingId }, other),
            React__default["default"].createElement(DialogContext.Provider, { value: contextValue },
                React__default["default"].createElement("div", { className: "Dialog__inner" },
                    heading ? (React__default["default"].createElement(DialogHeader, null,
                        React__default["default"].createElement(DialogHeading, null, typeof heading === 'object' && 'text' in heading
                            ? heading.text
                            : heading),
                        !forceAction ? React__default["default"].createElement(DialogCloseButton, null) : null)) : null,
                    children)))));
    return reactDom.createPortal(dialog, 
    // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
    portalElement || document.body);
});
Dialog.displayName = 'Dialog';
var DialogContent = function (_a) {
    var children = _a.children, className = _a.className, align = _a.align, other = tslib.__rest(_a, ["children", "className", "align"]);
    var context = React.useContext(DialogContext);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('Dialog__content', className, {
            'text--align-left': align === 'left',
            'text--align-center': align === 'center',
            'text--align-right': align === 'right'
        }), 
        // A keyboard user can only scroll this region if it is tabbable (WCAG
        // 2.1.1). The rule allows that on role="tabpanel" only. See #680.
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex: (context === null || context === void 0 ? void 0 : context.scrollable) ? 0 : undefined }, other), children));
};
DialogContent.displayName = 'DialogContent';
var DialogFooter = function (_a) {
    var children = _a.children, className = _a.className, align = _a.align, other = tslib.__rest(_a, ["children", "className", "align"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('Dialog__footer', className, {
            'text--align-left': align === 'left',
            'text--align-center': align === 'center',
            'text--align-right': align === 'right'
        }) }, other), children));
};
DialogFooter.displayName = 'DialogFooter';
var DialogHeader = function (_a) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('Dialog__header', className) }, other), children));
};
DialogHeader.displayName = 'DialogHeader';
var DialogHeading = function (_a) {
    var children = _a.children, className = _a.className, levelProp = _a.level, other = tslib.__rest(_a, ["children", "className", "level"]);
    var _b = useDialogContext(), headingId = _b.headingId, headingRef = _b.headingRef, headingLevel = _b.headingLevel;
    var HeadingLevel = "h".concat(levelProp !== null && levelProp !== void 0 ? levelProp : headingLevel);
    return (React__default["default"].createElement(HeadingLevel, tslib.__assign({ className: classNames__default["default"]('Dialog__heading', className), ref: headingRef, tabIndex: -1, id: headingId }, other), children));
};
DialogHeading.displayName = 'DialogHeading';
var DialogCloseButton = function (_a) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    var _b = useDialogContext(), onClose = _b.onClose, forceAction = _b.forceAction, closeButtonText = _b.closeButtonText;
    if (forceAction && process.env.NODE_ENV !== 'production') {
        console.warn('DialogCloseButton: Component will not render because forceAction is true. Remove DialogCloseButton from your custom header when using forceAction.');
        return null;
    }
    return (React__default["default"].createElement("button", tslib.__assign({ className: classNames__default["default"]('Dialog__close', className), type: "button", onClick: onClose }, other), children !== null && children !== void 0 ? children : (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(Icon, { type: "close", "aria-hidden": "true" }),
        React__default["default"].createElement(Offscreen, null, closeButtonText)))));
};
DialogCloseButton.displayName = 'DialogCloseButton';

var Alert = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, heading = _a.heading, other = tslib.__rest(_a, ["children", "className", "variant", "heading"]);
    return (React__default["default"].createElement(Dialog, tslib.__assign({ className: classNames__default["default"]({ Alert__warning: variant === 'warning' }, 'Alert', className), heading: {
            text: (React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement(Icon, { type: variant === 'default' ? 'info-circle' : 'caution' }),
                typeof heading === 'object' && 'text' in heading
                    ? heading.text
                    : heading)),
            level: typeof heading === 'object' && 'level' in heading
                ? heading.level
                : undefined
        }, forceAction: true }, other), children));
};
var AlertContent = DialogContent;
var AlertActions = DialogFooter;

var Modal = function (_a) {
    var children = _a.children, className = _a.className, variant = _a.variant, scrollable = _a.scrollable, other = tslib.__rest(_a, ["children", "className", "variant", "scrollable"]);
    return (React__default["default"].createElement(Dialog, tslib.__assign({ className: classNames__default["default"]('Modal', className, {
            'Modal--info': variant === 'info',
            'Modal--scrollable': scrollable
        }) }, other, { scrollable: scrollable, forceAction: false }), children));
};
var ModalHeader = DialogHeader;
var ModalHeading = DialogHeading;
var ModalCloseButton = DialogCloseButton;
var ModalContent = DialogContent;
var ModalFooter = DialogFooter;

/**
 * <SkipLink target={'#foo'} />
 */
var SkipLink = /** @class */ (function (_super) {
    tslib.__extends(SkipLink, _super);
    function SkipLink(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { currentClass: '' };
        _this.onClick = _this.onClick.bind(_this);
        _this.onFocus = _this.onFocus.bind(_this);
        _this.onBlur = _this.onBlur.bind(_this);
        return _this;
    }
    SkipLink.prototype.render = function () {
        var currentClass = this.state.currentClass;
        var _a = this.props, target = _a.target, skipText = _a.skipText, targetText = _a.targetText, other = tslib.__rest(_a, ["target", "skipText", "targetText"]);
        return (React__default["default"].createElement("nav", tslib.__assign({ className: classNames__default["default"]('SkipLink', currentClass) }, other),
            React__default["default"].createElement("a", { href: target, className: "SkipLink__link", onClick: this.onClick, onFocus: this.onFocus, onBlur: this.onBlur },
                React__default["default"].createElement("span", { className: "SkipLink__item--first" }, skipText),
                React__default["default"].createElement("span", { className: "SkipLink__item--second" },
                    React__default["default"].createElement(Icon, { type: "triangle-right" }),
                    targetText))));
    };
    SkipLink.prototype.onClick = function () {
        if (!isBrowser()) {
            return;
        }
        var element = document.querySelector(this.props.target);
        if (element) {
            element.tabIndex = -1;
            element.focus();
        }
    };
    SkipLink.prototype.onFocus = function () {
        var _this = this;
        this.setState({ currentClass: 'SkipLink--active' });
        setTimeout(function () {
            _this.setState({
                currentClass: 'SkipLink--active SkipLink--fade'
            });
        });
    };
    SkipLink.prototype.onBlur = function () {
        var _this = this;
        this.setState({ currentClass: 'SkipLink--active' });
        setTimeout(function () {
            _this.setState({ currentClass: '' });
        });
    };
    SkipLink.defaultProps = {
        skipText: 'Skip to',
        targetText: 'Main Content'
    };
    return SkipLink;
}(React__default["default"].Component));

var Button = React.forwardRef(function (_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? 'primary' : _b, thin = _a.thin, size = _a.size, children = _a.children, className = _a.className, buttonRef = _a.buttonRef, other = tslib.__rest(_a, ["variant", "thin", "size", "children", "className", "buttonRef"]);
    return (React__default["default"].createElement("button", tslib.__assign({ type: "button", className: classNames__default["default"](className, {
            'Button--primary': variant === 'primary',
            'Button--secondary': variant === 'secondary',
            'Button--error': variant === 'error',
            'Button--danger': variant === 'danger',
            'Button--danger-secondary': variant === 'danger-secondary',
            'Button--tertiary': variant === 'tertiary',
            Link: variant === 'link',
            Tag: variant === 'tag',
            'Button--tag': variant === 'tag',
            'Tag--small': variant === 'tag' && size === 'small',
            'Button--thin': thin,
            'Button--badge': variant === 'badge'
        }), ref: ref || buttonRef }, other), children));
});
Button.displayName = 'Button';

var isEscapeKey = function (event) {
    return event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27;
};
/**
 * When a component needs to implement an escape handler, such as in modal
 * dialogs, useEscapeKey will handle the events and call the provided callback
 * handler when an escape key event has been fired.
 *
 * @example
 * useEscapeKey(() => close())
 */
function useEscapeKey(options, dependencies) {
    if (dependencies === void 0) { dependencies = []; }
    var callback = options.callback;
    var event = options.event || 'keyup';
    var target = resolveElement(options.target) || document.body;
    var active = typeof options.active === 'boolean' ? options.active : true;
    React.useEffect(function () {
        var eventListener = function (event) {
            if (isEscapeKey(event) &&
                (options.defaultPrevented ? !event.defaultPrevented : true)) {
                callback(event);
            }
        };
        if (active) {
            target === null || target === void 0 ? void 0 : target.addEventListener(event, eventListener, options.capture);
        }
        return function () {
            target === null || target === void 0 ? void 0 : target.removeEventListener(event, eventListener, options.capture);
        };
    }, tslib.__spreadArray([
        active,
        callback,
        event,
        target,
        options.capture,
        options.defaultPrevented
    ], tslib.__read(dependencies), false));
}

function getAutoAlignment(placement) {
    switch (placement) {
        case 'auto-start':
            return 'start';
        case 'auto-end':
            return 'end';
        default:
            return null;
    }
}
/**
 * Prevents large overlays from shifting off-screen above the viewport. When an overlay
 * would overflow past the top edge, this middleware signals that it should flip to an
 * alternative placement to keep content visible and accessible.
 */
var preventTopOverflowMiddleware = {
    name: 'preventTopOverflow',
    fn: function (state) {
        return tslib.__awaiter(this, void 0, void 0, function () {
            var overflow;
            return tslib.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, reactDom$1.detectOverflow(state, {
                            rootBoundary: 'document'
                        })];
                    case 1:
                        overflow = _a.sent();
                        if ((overflow === null || overflow === void 0 ? void 0 : overflow.top) >= 0) {
                            return [2 /*return*/, {
                                    reset: {
                                        // Replace the initial placement axis with 'bottom' while preserving alignment (start/end)
                                        // Examples: 'top' -> 'bottom', 'top-start' -> 'bottom-start'
                                        placement: (state.placement.replace(/\w+?(-(start|end))?$/i, 'bottom$1') || 'bottom')
                                    }
                                }];
                        }
                        return [2 /*return*/, {}];
                }
            });
        });
    }
};
// Element-resize tracking is split out of `whileElementsMounted` so it can be
// scoped to the open state. This function's identity must stay stable:
// floating-ui keys its positioning effect on whether one was passed, and a
// re-run calls `update()` again, which on close pulls focus back out of the
// trigger.
var autoUpdateWithoutElementResize = function (reference, floating, update) { return dom.autoUpdate(reference, floating, update, { elementResize: false }); };
var AnchoredOverlay = React.forwardRef(function (_a, refProp) {
    var _b, _c;
    var as = _a.as, _d = _a.placement, initialPlacement = _d === void 0 ? 'auto' : _d, target = _a.target, children = _a.children, style = _a.style, _e = _a.open, open = _e === void 0 ? false : _e, offset = _a.offset, focusTrap = _a.focusTrap, focusTrapOptions = _a.focusTrapOptions, onOpenChange = _a.onOpenChange, onPlacementChange = _a.onPlacementChange, onShiftChange = _a.onShiftChange, portal = _a.portal, props = tslib.__rest(_a, ["as", "placement", "target", "children", "style", "open", "offset", "focusTrap", "focusTrapOptions", "onOpenChange", "onPlacementChange", "onShiftChange", "portal"]);
    var ref = useSharedRef(refProp);
    var Component = as || 'div';
    var _f = reactDom$1.useFloating({
        open: open,
        // default to initial placement on top when placement is auto
        // @ts-expect-error auto placement is not a valid placement for floating-ui
        placement: initialPlacement.startsWith('auto') ? 'top' : initialPlacement,
        middleware: [
            reactDom$1.offset(offset !== null && offset !== void 0 ? offset : 0),
            initialPlacement.startsWith('auto')
                ? reactDom$1.autoPlacement({
                    alignment: getAutoAlignment(initialPlacement)
                })
                : reactDom$1.flip({
                    fallbackAxisSideDirection: 'start'
                }),
            reactDom$1.shift({
                crossAxis: false,
                boundary: 'clippingAncestors'
            }),
            preventTopOverflowMiddleware
        ].filter(Boolean),
        elements: {
            reference: resolveElement(target)
        },
        whileElementsMounted: autoUpdateWithoutElementResize
    }), refs = _f.refs, floatingStyles = _f.floatingStyles, placement = _f.placement, middlewareData = _f.middlewareData, update = _f.update, elements = _f.elements;
    // Observing the target while the overlay is closed measures it for the
    // first time mid-layout, which leaves a ResizeObserver notification
    // undelivered and has the browser report an uncaught error.
    React.useEffect(function () {
        var reference = elements.reference, floating = elements.floating;
        if (!open ||
            !reference ||
            !floating ||
            typeof ResizeObserver !== 'function') {
            return;
        }
        // Deferred a task: starting it re-positions, and a render in the middle
        // of the open sequence loses the overlay's initial focus target.
        var stopObserving;
        var timeout = setTimeout(function () {
            stopObserving = dom.autoUpdate(reference, floating, update, {
                ancestorScroll: false,
                ancestorResize: false,
                layoutShift: false,
                elementResize: true
            });
        });
        return function () {
            clearTimeout(timeout);
            stopObserving === null || stopObserving === void 0 ? void 0 : stopObserving();
        };
    }, [open, elements, update]);
    useEscapeKey({
        active: open,
        capture: true,
        defaultPrevented: true,
        callback: function (event) {
            // when an anchored overlay is open, we want to prevent other potential "escape"
            // keypress events, like the closing of modals from occurring
            event.preventDefault();
            // istanbul ignore else
            if (typeof onOpenChange === 'function') {
                onOpenChange(!open);
            }
        }
    });
    useFocusTrap(ref, !focusTrap ? { disabled: true } : focusTrapOptions);
    React.useEffect(function () {
        if (typeof onPlacementChange === 'function') {
            onPlacementChange(placement);
        }
    }, [onPlacementChange, placement]);
    React.useEffect(function () {
        var _a, _b;
        if (typeof onShiftChange === 'function') {
            onShiftChange({
                x: ((_a = middlewareData.shift) === null || _a === void 0 ? void 0 : _a.x) || 0,
                y: ((_b = middlewareData.shift) === null || _b === void 0 ? void 0 : _b.y) || 0
            });
        }
    }, [onShiftChange, (_b = middlewareData.shift) === null || _b === void 0 ? void 0 : _b.x, (_c = middlewareData.shift) === null || _c === void 0 ? void 0 : _c.y]);
    var AnchoredOverlayComponent = (React__default["default"].createElement(Component, tslib.__assign({ ref: function (element) {
            refs.setFloating(element);
            ref.current = element;
        } }, props, { style: tslib.__assign(tslib.__assign({}, floatingStyles), style) }), children));
    if (portal && !isBrowser()) {
        return null;
    }
    if (portal && typeof portal !== 'undefined') {
        var portalElement = (portal && 'current' in portal ? portal.current : portal) ||
            (
            // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
            document === null || document === void 0 ? void 0 : document.body);
        return reactDom.createPortal(AnchoredOverlayComponent, portalElement);
    }
    return AnchoredOverlayComponent;
});
AnchoredOverlay.displayName = 'AnchoredOverlay';

/**
 * Returns a unique set of id refs from the provided string
 * @param ids - string of id refs
 */
function idRefs(ids) {
    if (!ids || !ids.trim()) {
        return new Set();
    }
    return new Set(ids.trim().split(/\s+/));
}
/**
 * Returns an updated id ref string with the provided id value added
 * @param ids - string of id refs
 * @param id - id to add
 */
function addIdRef(ids, id) {
    return tslib.__spreadArray([], tslib.__read(idRefs(ids).add(id)), false).join(' ');
}
/**
 * Returns an updated id ref string with the provided id value removed
 * @param ids - string of id refs
 * @param id - id to remove
 */
function removeIdRef(_ids, id) {
    var ids = idRefs(_ids);
    ids.delete(id);
    return tslib.__spreadArray([], tslib.__read(ids), false).join(' ');
}
/**
 * Returns if an id ref string contains the provided id value
 * @param ids - string of id refs
 * @param id - id to check if it exists in the provided idRef string
 */
function hasIdRef(ids, id) {
    return idRefs(ids).has(id);
}

var TIP_HIDE_DELAY = 100;
// fires a custom "cauldron:tooltip:show" / "cauldron:tooltip:hide" event
// to allow projects using cauldron to hook into when a tooltip is shown/hidden
var fireCustomEvent = function (show, button) {
    if (!button) {
        return;
    }
    var event = new CustomEvent(show ? 'cauldron:tooltip:show' : 'cauldron:tooltip:hide', {
        bubbles: true
    });
    button.dispatchEvent(event);
};
function Tooltip(_a) {
    var _this = this;
    var propId = _a.id, _b = _a.placement, initialPlacement = _b === void 0 ? 'auto' : _b, children = _a.children, portal = _a.portal, target = _a.target, _c = _a.association, association = _c === void 0 ? 'aria-describedby' : _c, _d = _a.variant, variant = _d === void 0 ? 'text' : _d, showProp = _a.show, _e = _a.defaultShow, defaultShow = _e === void 0 ? false : _e, _f = _a.hideElementOnHidden, hideElementOnHidden = _f === void 0 ? false : _f, className = _a.className, props = tslib.__rest(_a, ["id", "placement", "children", "portal", "target", "association", "variant", "show", "defaultShow", "hideElementOnHidden", "className"]);
    var _g = tslib.__read(propId ? [propId] : nextId.useId(1, 'tooltip'), 1), id = _g[0];
    var hideTimeoutRef = React.useRef(null);
    var _h = tslib.__read(React.useState(!!showProp || defaultShow), 2), showTooltip = _h[0], setShowTooltip = _h[1];
    var _j = tslib.__read(React.useState(null), 2), tooltipElement = _j[0], setTooltipElement = _j[1];
    var _k = tslib.__read(React.useState(initialPlacement), 2), placement = _k[0], setPlacement = _k[1];
    var _l = tslib.__read(React.useState(), 2), arrowShift = _l[0], setArrowShift = _l[1];
    var hasAriaAssociation = association !== 'none';
    // Show the tooltip
    var show = React.useCallback(function () { return tslib.__awaiter(_this, void 0, void 0, function () {
        var targetElement;
        return tslib.__generator(this, function (_a) {
            targetElement = resolveElement(target);
            // Clear the hide timeout if there was one pending
            if (hideTimeoutRef.current) {
                clearTimeout(hideTimeoutRef.current);
                hideTimeoutRef.current = null;
            }
            setShowTooltip(true);
            fireCustomEvent(true, targetElement);
            return [2 /*return*/];
        });
    }); }, [target]);
    // Hide the tooltip
    var hide = React.useCallback(function () {
        var targetElement = resolveElement(target);
        if (!hideTimeoutRef.current) {
            hideTimeoutRef.current = setTimeout(function () {
                hideTimeoutRef.current = null;
                setShowTooltip(false);
                fireCustomEvent(false, targetElement);
            }, TIP_HIDE_DELAY);
        }
    }, [target]);
    // Cancel any pending hide timeout when the Tooltip unmounts so it
    // does not fire setShowTooltip on an unmounted component.
    React.useEffect(function () {
        return function () {
            if (hideTimeoutRef.current) {
                clearTimeout(hideTimeoutRef.current);
                hideTimeoutRef.current = null;
            }
        };
    }, []);
    React.useEffect(function () {
        if (typeof showProp === 'boolean') {
            setShowTooltip(showProp);
        }
    }, [showProp]);
    // Handle hover and focus events for the targetElement
    React.useEffect(function () {
        var targetElement = resolveElement(target);
        if (typeof showProp !== 'boolean') {
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.addEventListener('mouseenter', show);
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.addEventListener('mouseleave', hide);
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.addEventListener('focusin', show);
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.addEventListener('focusout', hide);
        }
        return function () {
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.removeEventListener('mouseenter', show);
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.removeEventListener('mouseleave', hide);
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.removeEventListener('focusin', show);
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.removeEventListener('focusout', hide);
        };
    }, [target, show, hide, showProp]);
    // Handle hover events for the tooltipElement
    React.useEffect(function () {
        if (typeof showProp !== 'boolean') {
            tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.addEventListener('mouseenter', show);
            tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.addEventListener('mouseleave', hide);
        }
        return function () {
            tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.removeEventListener('mouseenter', show);
            tooltipElement === null || tooltipElement === void 0 ? void 0 : tooltipElement.removeEventListener('mouseleave', hide);
        };
    }, [tooltipElement, show, hide, showProp]);
    // Keep the target's id in sync
    React.useEffect(function () {
        var targetElement = resolveElement(target);
        if (hasAriaAssociation) {
            var idRefs = targetElement === null || targetElement === void 0 ? void 0 : targetElement.getAttribute(association);
            if (!hasIdRef(idRefs, id)) {
                targetElement === null || targetElement === void 0 ? void 0 : targetElement.setAttribute(association, addIdRef(idRefs, id));
            }
        }
        return function () {
            if (targetElement && hasAriaAssociation) {
                var idRefs = targetElement.getAttribute(association);
                targetElement.setAttribute(association, removeIdRef(idRefs, id));
            }
        };
    }, [target, id, association]);
    var updateArrowShiftPosition = React.useCallback(function (_a) {
        var x = _a.x;
        if (variant === 'big' || x === 0) {
            setArrowShift(null);
            return;
        }
        // The tooltip shift position is inversely related to the direction
        // that the arrow needs to shift
        setArrowShift(x * -1);
    }, [variant]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null, (showTooltip || hideElementOnHidden) && isBrowser() ? (React__default["default"].createElement(AnchoredOverlay, tslib.__assign({ id: id, target: target, placement: initialPlacement, onPlacementChange: setPlacement, open: showTooltip && typeof showProp !== 'boolean', onOpenChange: setShowTooltip, onShiftChange: updateArrowShiftPosition, className: classNames__default["default"]('Tooltip', "Tooltip--".concat(placement), className, {
            TooltipInfo: variant === 'info',
            'Tooltip--hidden': !showTooltip && hideElementOnHidden,
            'Tooltip--big': variant === 'big'
        }), ref: setTooltipElement, role: "tooltip", offset: 8, 
        // guarded by isBrowser() check
        // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
        portal: portal || (document === null || document === void 0 ? void 0 : document.body) }, props),
        variant !== 'big' && (React__default["default"].createElement("div", { className: "TooltipArrow", style: arrowShift
                ? { transform: "translateX(".concat(arrowShift, "px)") }
                : undefined })),
        children)) : null));
}
Tooltip.displayName = 'Tooltip';
var TooltipHead = function (_a) {
    var className = _a.className, other = tslib.__rest(_a, ["className"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('TooltipHead', className) }, other)));
};
var TooltipContent = function (_a) {
    var className = _a.className, other = tslib.__rest(_a, ["className"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('TooltipContent', className) }, other)));
};

var isButton = function (component) { return component === 'button'; };
var looksLikeLink = function (props) {
    return 'to' in props || 'href' in props;
};
var IconButton = React.forwardRef(function (_a, ref) {
    var _b = _a.as, Component = _b === void 0 ? 'button' : _b, icon = _a.icon, label = _a.label, _c = _a.tooltipProps, tooltipPropsProp = _c === void 0 ? {} : _c, className = _a.className, _d = _a.variant, variant = _d === void 0 ? 'secondary' : _d, disabled = _a.disabled, _e = _a.tabIndex, tabIndex = _e === void 0 ? 0 : _e, large = _a.large, other = tslib.__rest(_a, ["as", "icon", "label", "tooltipProps", "className", "variant", "disabled", "tabIndex", "large"]);
    var internalRef = React.useRef(null);
    React.useImperativeHandle(ref, function () { return internalRef.current; });
    // Configure additional properties based on the type of the Component
    // for accessibility
    var accessibilityProps = {};
    if (isButton(Component)) {
        accessibilityProps.type = 'button';
    }
    else {
        // We don't need to set an anchor's role, since it would be redundant
        if (Component !== 'a') {
            accessibilityProps.role = looksLikeLink(other) ? 'link' : 'button';
        }
        if (disabled) {
            accessibilityProps['aria-disabled'] = disabled;
        }
    }
    var tooltipProps = tslib.__assign({ placement: 'auto', association: 'aria-labelledby', hideElementOnHidden: true }, tooltipPropsProp);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(Component, tslib.__assign({ className: classNames__default["default"](className, {
                IconButton: true,
                'IconButton--primary': variant === 'primary',
                'IconButton--secondary': variant === 'secondary',
                'IconButton--tertiary': variant === 'tertiary',
                'IconButton--error': variant === 'error',
                'IconButton--large': large
            }), ref: internalRef, disabled: disabled, tabIndex: disabled ? -1 : tabIndex }, accessibilityProps, other),
            React__default["default"].createElement(Icon, { type: icon }),
            disabled && React__default["default"].createElement(Offscreen, null, label)),
        !disabled && (React__default["default"].createElement(Tooltip, tslib.__assign({ target: internalRef }, tooltipProps), label))));
});
IconButton.displayName = 'IconButton';

/**
 * A querySelectorAll that returns a normal array rather than live node list.
 *
 * @param  {String} selector
 * @param  {HTMLElement} context
 * @return {Array}
 */
var queryAll = function (selector, context) {
    if (context === void 0) { context = document; }
    if (!isBrowser()) {
        return [];
    }
    return Array.prototype.slice.call(context.querySelectorAll(selector));
};

/**
 * Maps toast types to their classNames and icons
 */
var typeMap = {
    confirmation: {
        className: 'success',
        icon: 'check-circle'
    },
    caution: {
        className: 'warning',
        icon: 'caution'
    },
    'action-needed': {
        className: 'error',
        icon: 'no'
    },
    error: {
        className: 'error',
        icon: 'caution'
    },
    info: {
        className: 'info',
        icon: 'info-circle-alt'
    }
};
var tabIndexHandler = function (reset, toast) {
    if (reset) {
        // restore tab indices that we clobbered
        return queryAll('[data-cached-tabindex]').forEach(function (el) {
            el.tabIndex = Number(el.getAttribute('data-cached-tabindex'));
        });
    }
    queryAll(focusableSelector)
        .filter(function (el) { return !(toast === null || toast === void 0 ? void 0 : toast.contains(el)); })
        .forEach(function (el) {
        el.setAttribute('data-cached-tabindex', el.tabIndex.toString());
        el.tabIndex = -1;
    });
};

/**
 * Hook to be used similarly to the React.Component#componentDidMount.
 * Executes the provided `effect` when `dependencies` change but does not
 * execute the effect initially (on mount) - only on update.
 *
 * @param effect {Function} function to be executed when dependencies update
 * @param dependencies {Any} any valid dependency argument to React.useEffect
 */
var useDidUpdate = function (effect, dependencies) {
    var mounted = React__default["default"].useRef(false);
    React__default["default"].useEffect(function () {
        if (!mounted.current) {
            mounted.current = true;
            return;
        }
        effect();
    }, dependencies);
};

/**
 * The cauldron toast notification component
 */
var Toast = React.forwardRef(function (_a, ref) {
    var type = _a.type, children = _a.children, _b = _a.onDismiss, onDismiss = _b === void 0 ? function () {
        // noop
    } : _b, _c = _a.dismissText, dismissText = _c === void 0 ? 'Dismiss' : _c, toastRef = _a.toastRef, _d = _a.focus, focus = _d === void 0 ? true : _d, _e = _a.show, show = _e === void 0 ? false : _e, _f = _a.dismissible, dismissible = _f === void 0 ? true : _f, className = _a.className, otherProps = tslib.__rest(_a, ["type", "children", "onDismiss", "dismissText", "toastRef", "focus", "show", "dismissible", "className"]);
    var elRef = useSharedRef(ref);
    var isolatorRef = React.useRef(null);
    var timeoutsRef = React.useRef(new Set());
    var _g = tslib.__read(React.useState(show ? 'FadeIn--flex' : 'is--hidden'), 2), animationClass = _g[0], setAnimationClass = _g[1];
    // Backwards-compat: propagate to the deprecated toastRef prop as well
    React.useEffect(function () {
        var _a;
        if (!toastRef)
            return;
        setRef(toastRef, (_a = elRef.current) !== null && _a !== void 0 ? _a : null);
        return function () { return setRef(toastRef, null); };
    }, [toastRef]);
    // Timeout because CSS display: none/block and opacity:
    // 0/1 properties cannot be toggled in the same tick
    // see: https://codepen.io/isnerms/pen/eyQaLP
    var scheduleNextTick = function (fn) {
        var id = setTimeout(function () {
            timeoutsRef.current.delete(id);
            fn();
        });
        timeoutsRef.current.add(id);
    };
    var showToast = React.useCallback(function () {
        setAnimationClass('FadeIn--flex FadeIn');
        if (type === 'action-needed' && elRef.current) {
            var isolator = new AriaIsolate(elRef.current);
            tabIndexHandler(false, elRef.current);
            isolatorRef.current = isolator;
            isolator.activate();
        }
        if (elRef.current && !!focus) {
            elRef.current.focus();
        }
    }, [type, focus]);
    var dismissToast = React.useCallback(function () {
        if (!elRef.current) {
            return;
        }
        setAnimationClass('FadeIn--flex');
        scheduleNextTick(function () {
            var _a;
            if (type === 'action-needed') {
                tabIndexHandler(true, elRef.current);
                (_a = isolatorRef.current) === null || _a === void 0 ? void 0 : _a.deactivate();
            }
            setAnimationClass('is--hidden');
            onDismiss();
        });
    }, [type, onDismiss]);
    React.useEffect(function () {
        if (show) {
            scheduleNextTick(showToast);
        }
        return function () {
            var _a;
            timeoutsRef.current.forEach(clearTimeout);
            timeoutsRef.current.clear();
            (_a = isolatorRef.current) === null || _a === void 0 ? void 0 : _a.deactivate();
        };
    }, []);
    useDidUpdate(function () {
        if (show) {
            setAnimationClass('FadeIn--flex');
            scheduleNextTick(showToast);
        }
        else {
            dismissToast();
        }
    }, [show]);
    var scrim = type === 'action-needed' && show ? (React__default["default"].createElement("div", { className: "Scrim--light Scrim--show Scrim--fade-in" })) : null;
    var defaultProps = {
        tabIndex: -1,
        className: classNames__default["default"]('Toast', "Toast--".concat(typeMap[type].className), animationClass, { 'Toast--non-dismissible': !dismissible }, className)
    };
    if (!focus) {
        defaultProps.role = 'alert';
    }
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("div", tslib.__assign({ ref: elRef }, defaultProps, otherProps),
            React__default["default"].createElement("div", { className: "Toast__message" },
                React__default["default"].createElement(Icon, { type: typeMap[type].icon }),
                React__default["default"].createElement("div", { className: "Toast__message-content" }, children)),
            type !== 'action-needed' && dismissible && (React__default["default"].createElement("button", { type: "button", className: "Toast__dismiss", "aria-label": dismissText, onClick: dismissToast },
                React__default["default"].createElement(Icon, { type: "close" })))),
        scrim));
});
Toast.displayName = 'Toast';

var Link = React.forwardRef(function (_a, ref) {
    var children = _a.children, linkRef = _a.linkRef, className = _a.className, variant = _a.variant, thin = _a.thin, other = tslib.__rest(_a, ["children", "linkRef", "className", "variant", "thin"]);
    return (React__default["default"].createElement("a", tslib.__assign({ ref: ref || linkRef, className: classNames__default["default"](className, {
            Link: !variant,
            'Button--primary': variant === 'button',
            'Button--secondary': variant === 'button-secondary',
            'Button--thin': thin
        }) }, other), children));
});
Link.displayName = 'Link';

var Loader = React__default["default"].forwardRef(function (_a, ref) {
    var className = _a.className, label = _a.label, props = tslib.__rest(_a, ["className", "label"]);
    if (label === null || label === void 0 ? void 0 : label.length) {
        props['role'] = 'alert';
        props.children = React__default["default"].createElement(Offscreen, null, label);
    }
    else {
        props['aria-hidden'] = true;
    }
    return (React__default["default"].createElement("div", tslib.__assign({ ref: ref, className: classNames__default["default"]('Loader', className) }, props)));
});
Loader.displayName = 'Loader';

var i = 0;
var randomId = function () {
    var num = Math.floor(Math.random() * 10000) + 1;
    return "x_".concat(i++, "_").concat(num);
};

var Select = React__default["default"].forwardRef(function (_a, ref) {
    var options = _a.options, children = _a.children, disabled = _a.disabled, label = _a.label, id = _a.id, required = _a.required, _b = _a.requiredText, requiredText = _b === void 0 ? 'Required' : _b, error = _a.error, value = _a.value, ariaDescribedby = _a["aria-describedby"], defaultValue = _a.defaultValue, description = _a.description, onChange = _a.onChange, rest = tslib.__rest(_a, ["options", "children", "disabled", "label", "id", "required", "requiredText", "error", "value", 'aria-describedby', "defaultValue", "description", "onChange"]);
    if (options && children) {
        console.error('The Select component only takes the options props or child option elements, not both.');
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    var onChangeEvent = onChange !== null && onChange !== void 0 ? onChange : (function () { });
    var isControlled = typeof value !== 'undefined';
    var _c = tslib.__read(React.useState(value || defaultValue || ''), 2), currentValue = _c[0], setCurrentValue = _c[1];
    var handleChange = function (e) {
        onChangeEvent(e);
        if (isControlled) {
            return;
        }
        setCurrentValue(e.target.value);
    };
    React.useEffect(function () {
        if (typeof value === 'undefined') {
            return;
        }
        // handle the incoming value change for controlled <Selects />
        setCurrentValue(value);
    }, [value]);
    var selectId = id || randomId();
    var errorId = randomId();
    var descriptionId = randomId();
    var dynamicProps = {};
    if (isControlled) {
        dynamicProps.value = currentValue;
    }
    else if (typeof defaultValue !== 'undefined') {
        dynamicProps.defaultValue = defaultValue;
    }
    dynamicProps['aria-describedby'] = ariaDescribedby;
    if (description) {
        dynamicProps['aria-describedby'] = addIdRef(dynamicProps['aria-describedby'], descriptionId);
    }
    if (error) {
        dynamicProps['aria-describedby'] = addIdRef(dynamicProps['aria-describedby'], errorId);
    }
    // In order to support controlled selects, we
    // have to attach an `onChange` to the select.
    /* eslint-disable jsx-a11y/no-onchange */
    return (React__default["default"].createElement("div", { className: "Field__select" },
        React__default["default"].createElement("label", { htmlFor: selectId, className: classNames__default["default"]('Field__label', {
                'Field__label--is-required': !!required,
                'Field__label--has-error': !!error
            }) },
            React__default["default"].createElement("span", null, label),
            required && (React__default["default"].createElement("span", { className: "Field__required-text", "aria-hidden": "true" }, requiredText))),
        description && (React__default["default"].createElement("div", { id: descriptionId, className: "Field__description" }, description)),
        error && (React__default["default"].createElement("div", { id: errorId, className: "Field__error" },
            React__default["default"].createElement(Icon, { type: "caution" }),
            error)),
        React__default["default"].createElement("div", { className: classNames__default["default"]('Field__select--wrapper', {
                'Field__select--disabled': disabled,
                'Field--has-error': !!error
            }) },
            React__default["default"].createElement("select", tslib.__assign({ ref: ref, id: selectId, disabled: disabled, required: required, onChange: handleChange }, dynamicProps, rest), (options === null || options === void 0 ? void 0 : options.length)
                ? options.map(function (option) {
                    return (React__default["default"].createElement("option", { className: "Field__option", key: option.key, value: option.value, disabled: option.disabled }, option.label || option.value));
                })
                : children),
            React__default["default"].createElement("div", { className: "arrow-down" }))));
    /* eslint-disable jsx-a11y/no-onchange */
});
Select.displayName = 'Select';

var RadioGroup = React.forwardRef(function (_a, ref) {
    var name = _a.name, radios = _a.radios, defaultValue = _a.defaultValue, value = _a.value, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    _b = _a.onChange, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange = _b === void 0 ? function () { } : _b, className = _a.className, _c = _a.inline, inline = _c === void 0 ? false : _c, other = tslib.__rest(_a, ["name", "radios", "defaultValue", "value", "onChange", "className", "inline"]);
    var _d = tslib.__read(React.useState(value || defaultValue || null), 2), currentValue = _d[0], setCurrentValue = _d[1];
    var _e = tslib.__read(React.useState(null), 2), focusIndex = _e[0], setFocusIndex = _e[1];
    var inputs = React.useRef([]);
    var handleChange = function (value) {
        return setCurrentValue(value !== null && value !== void 0 ? value : null);
    };
    var onRadioFocus = function (index) { return setFocusIndex(index); };
    var onRadioBlur = function () { return setFocusIndex(null); };
    var onRadioClick = function (index) {
        var _a;
        var radio = (_a = inputs.current) === null || _a === void 0 ? void 0 : _a[index];
        if (!radio) {
            return;
        }
        radio.click();
        radio.focus();
    };
    React.useEffect(function () {
        if (typeof value === 'undefined') {
            return;
        }
        setCurrentValue(value);
    }, [value]);
    var radioButtons = radios.map(function (radio, index) {
        var label = radio.label, disabled = radio.disabled, radioValue = radio.value, labelDescription = radio.labelDescription, id = radio.id, className = radio.className, other = tslib.__rest(radio, ["label", "disabled", "value", "labelDescription", "id", "className"]);
        var isChecked = currentValue === radioValue;
        var isFocused = focusIndex === index;
        return (React__default["default"].createElement("div", { className: "Radio__wrap", key: id },
            React__default["default"].createElement("div", { className: classNames__default["default"]('Radio is--flex-row', className) },
                React__default["default"].createElement("input", tslib.__assign({ type: "radio", name: name, value: radioValue, id: id, ref: function (input) {
                        if (input) {
                            inputs.current[index] = input;
                        }
                    }, onFocus: function () { return onRadioFocus(index); }, onBlur: function () { return onRadioBlur(); }, onChange: function () {
                        var _a;
                        handleChange(radioValue);
                        onChange(radio, (_a = inputs.current) === null || _a === void 0 ? void 0 : _a[index]);
                    }, disabled: disabled, checked: isChecked, "aria-describedby": labelDescription ? "".concat(id, "Desc") : undefined }, other)),
                React__default["default"].createElement("label", { htmlFor: id, className: classNames__default["default"]('Field__label Radio__label', {
                        'Field__label--disabled': disabled
                    }) }, label),
                React__default["default"].createElement(Icon, { className: classNames__default["default"]('Radio__overlay', {
                        'Radio__overlay--focused': isFocused,
                        'Radio__overlay--disabled': disabled
                    }), type: isChecked ? 'radio-checked' : 'radio-unchecked', "aria-hidden": "true", onClick: function () { return onRadioClick(index); } })),
            labelDescription && (React__default["default"].createElement("span", { id: "".concat(id, "Desc"), className: classNames__default["default"]('Field__labelDescription', {
                    'Field__labelDescription--disabled': disabled
                }) }, labelDescription))));
    });
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"](className, { 'Radio--inline': inline }), role: "radiogroup", ref: ref }, other), radioButtons));
});
RadioGroup.displayName = 'RadioGroup';

var Panel = React.forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, collapsed = _a.collapsed, className = _a.className, heading = _a.heading, _c = _a.padding, padding = _c === void 0 ? true : _c, other = tslib.__rest(_a, ["children", "collapsed", "className", "heading", "padding"]);
    var headingId = !heading
        ? undefined
        : typeof heading === 'object' && 'id' in heading
            ? heading.id
            : randomId();
    var Heading = function () {
        if (!headingId) {
            return null;
        }
        var HeadingComponent = "h".concat(heading &&
            typeof heading === 'object' &&
            'level' in heading &&
            !!heading.level
            ? heading.level
            : 2);
        return (React__default["default"].createElement(HeadingComponent, { id: headingId, className: "Panel__Heading" }, heading && typeof heading === 'object' && 'text' in heading
            ? heading.text
            : heading));
    };
    return (React__default["default"].createElement("section", tslib.__assign({ "aria-labelledby": headingId, className: classNames__default["default"]('Panel', className, (_b = {},
            _b['Panel--collapsed'] = collapsed,
            _b['Panel--no-padding'] = !padding,
            _b)), ref: ref }, other),
        React__default["default"].createElement(Heading, null),
        children));
});
Panel.displayName = 'Panel';

var PanelContent = React.forwardRef(function (_a, ref) {
    var _b;
    var children = _a.children, className = _a.className, _c = _a.padding, padding = _c === void 0 ? true : _c, otherProps = tslib.__rest(_a, ["children", "className", "padding"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('Panel__Content', className, (_b = {},
            _b['Panel__Content--no-padding'] = !padding,
            _b)), ref: ref }, otherProps), children));
});
PanelContent.displayName = 'PanelContent';

var PanelHeader = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, otherProps = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('Panel__Header', className), ref: ref }, otherProps), children));
});
PanelHeader.displayName = 'PanelHeader';

var RadioCardGroup = function (_a) {
    var name = _a.name, radios = _a.radios, defaultValue = _a.defaultValue, value = _a.value, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    _b = _a.onChange, 
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onChange = _b === void 0 ? function () { } : _b; _a.className; var other = tslib.__rest(_a, ["name", "radios", "defaultValue", "value", "onChange", "className"]);
    var _c = tslib.__read(React.useState(value !== null && value !== void 0 ? value : defaultValue), 2), currentValue = _c[0], setCurrentValue = _c[1];
    var _d = tslib.__read(React.useState(null), 2), focusIndex = _d[0], setFocusIndex = _d[1];
    var inputs = React.useRef([]);
    var handleChange = function (value) { return setCurrentValue(value); };
    var onRadioFocus = function (index) { return setFocusIndex(index); };
    var onRadioBlur = function () { return setFocusIndex(null); };
    var onRadioClick = function (index) {
        var _a;
        var radio = (_a = inputs.current) === null || _a === void 0 ? void 0 : _a[index];
        if (!radio) {
            return;
        }
        radio.click();
        radio.focus();
    };
    React.useEffect(function () {
        if (typeof value === 'undefined') {
            return;
        }
        setCurrentValue(value);
    }, [value]);
    var radioButtons = radios.map(function (radio, index) {
        var label = radio.label, disabled = radio.disabled, radioValue = radio.value, cardImg = radio.cardImg, cardIcon = radio.cardIcon, id = radio.id; radio.className; var other = tslib.__rest(radio, ["label", "disabled", "value", "cardImg", "cardIcon", "id", "className"]);
        var isChecked = currentValue === radioValue;
        var isFocused = focusIndex === index;
        return (React__default["default"].createElement("div", { className: classNames__default["default"]('RadioCard'), key: index },
            React__default["default"].createElement(Panel, { className: classNames__default["default"]('RadioCardGroup__Card RadioCard__overlay', {
                    'RadioCard__overlay--focused': isFocused,
                    'RadioCard__overlay--checked': isChecked,
                    'RadioCard__overlay--disabled': disabled
                }), onClick: function () { return onRadioClick(index); } },
                React__default["default"].createElement("input", tslib.__assign({ type: "radio", name: name, value: radioValue, id: id, ref: function (input) {
                        if (!input) {
                            return;
                        }
                        inputs.current.push(input);
                    }, onFocus: function () { return onRadioFocus(index); }, onBlur: function () { return onRadioBlur(); }, onChange: function () {
                        var _a;
                        handleChange(radioValue);
                        onChange(radio, (_a = inputs.current) === null || _a === void 0 ? void 0 : _a[index]);
                    }, disabled: disabled, checked: isChecked }, other)),
                React__default["default"].createElement(PanelContent, null,
                    React__default["default"].createElement("div", { className: classNames__default["default"]('RadioCardGroup__Checked') }, isChecked && (React__default["default"].createElement(Icon, { className: classNames__default["default"]('RadioCardGroup__Icon'), type: cardIcon }))),
                    React__default["default"].createElement("div", { className: classNames__default["default"]('RadioCardGroup__Base') },
                        React__default["default"].createElement("div", { className: classNames__default["default"]('RadioCardGroup__Image') }, cardImg),
                        React__default["default"].createElement("label", { htmlFor: id, className: classNames__default["default"]('RadioCardGroup__Label') }, label))))));
    });
    // reset the input refs array
    // refs get clobbered every re-render anyway and this supports "dynamic" radios
    // (changing the number of radio buttons for example)
    inputs.current = [];
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('RadioCardGroup'), role: "radiogroup" }, other), radioButtons));
};
RadioCardGroup.displayName = 'RadioCardGroup';

var Checkbox = React.forwardRef(function (_a, ref) {
    var id = _a.id, label = _a.label, labelDescription = _a.labelDescription, error = _a.error, checkboxRef = _a.checkboxRef, className = _a.className, onChange = _a.onChange, _b = _a.controlled, controlled = _b === void 0 ? false : _b, onFocus = _a.onFocus, onBlur = _a.onBlur, ariaDescribedby = _a["aria-describedby"], _c = _a.disabled, disabled = _c === void 0 ? false : _c, _d = _a.checked, checked = _d === void 0 ? false : _d, _e = _a.indeterminate, indeterminate = _e === void 0 ? false : _e; _a.children; var other = tslib.__rest(_a, ["id", "label", "labelDescription", "error", "checkboxRef", "className", "onChange", "controlled", "onFocus", "onBlur", 'aria-describedby', "disabled", "checked", "indeterminate", "children"]);
    var _f = tslib.__read(React.useState(checked), 2), isChecked = _f[0], setIsChecked = _f[1];
    var _g = tslib.__read(React.useState(indeterminate), 2), isIndeterminate = _g[0], setIsIndeterminate = _g[1];
    var _h = tslib.__read(React.useState(false), 2), focused = _h[0], setFocused = _h[1];
    var checkRef = React.useRef(null);
    React.useEffect(function () {
        setIsChecked(checked);
    }, [checked]);
    React.useEffect(function () {
        setIsIndeterminate(indeterminate);
    }, [indeterminate]);
    var refProp = ref || checkboxRef;
    if (typeof refProp === 'function') {
        refProp(checkRef.current);
    }
    var _j = React.useMemo(function () {
        return {
            labelDescriptionId: nextId__default["default"](),
            errorId: nextId__default["default"]()
        };
    }, []), errorId = _j.errorId, labelDescriptionId = _j.labelDescriptionId;
    var ariaDescribedbyId = ariaDescribedby;
    if (error) {
        ariaDescribedbyId = addIdRef(ariaDescribedbyId, errorId);
    }
    if (labelDescription) {
        ariaDescribedbyId = addIdRef(ariaDescribedbyId, labelDescriptionId);
    }
    var iconType = isChecked
        ? 'checkbox-checked'
        : 'checkbox-unchecked';
    React.useEffect(function () {
        var input;
        if (refProp && typeof refProp !== 'function') {
            input = refProp.current;
        }
        else {
            input = checkRef.current;
        }
        if (input) {
            input.indeterminate = isIndeterminate;
        }
    }, [isIndeterminate, refProp, checkRef]);
    return (React__default["default"].createElement("div", { className: "Checkbox__wrap" },
        React__default["default"].createElement("div", { className: classNames__default["default"]('Checkbox is--flex-row', className) },
            React__default["default"].createElement("input", tslib.__assign({ id: id, ref: typeof refProp === 'function' || !refProp ? checkRef : refProp, type: "checkbox", checked: isChecked, disabled: disabled, onFocus: function (e) {
                    setFocused(true);
                    if (typeof onFocus === 'function') {
                        onFocus(e);
                    }
                }, onBlur: function (e) {
                    setFocused(false);
                    if (typeof onBlur === 'function') {
                        onBlur(e);
                    }
                }, "aria-describedby": ariaDescribedbyId, onChange: function (e) {
                    if (isIndeterminate) {
                        setIsIndeterminate(false);
                    }
                    if (!controlled) {
                        setIsChecked(e.target.checked);
                    }
                    if (onChange) {
                        onChange(e);
                    }
                } }, other)),
            React__default["default"].createElement("label", { className: classNames__default["default"]('Field__label Checkbox__label', {
                    'Field__label--disabled': disabled
                }), htmlFor: id }, label),
            React__default["default"].createElement(Icon, { className: classNames__default["default"]('Checkbox__overlay', {
                    'Checkbox__overlay--disabled': disabled,
                    'Checkbox__overlay--focused': focused,
                    'Field--has-error': error
                }), type: iconType, "aria-hidden": "true", onClick: function () {
                    var _a, _b;
                    if (refProp && typeof refProp !== 'function') {
                        (_a = refProp.current) === null || _a === void 0 ? void 0 : _a.click();
                    }
                    else {
                        (_b = checkRef.current) === null || _b === void 0 ? void 0 : _b.click();
                    }
                } })),
        labelDescription && (React__default["default"].createElement("span", { id: labelDescriptionId, className: "Field__labelDescription" }, labelDescription)),
        error && (React__default["default"].createElement("div", { id: errorId, className: "Error" }, error))));
});
Checkbox.displayName = 'Checkbox';

/**
 * The button's sole purpose is to provide an interactive tabstop for a tooltip. aria-disabled is used to:
 *   - Allow the button to be keyboard focusable
 *   - Inform AT users that clicking the button does not perform any action
 *   - Is presented as a focusable control to trigger the associated tooltip
 */
function TooltipTabstop(_a) {
    var children = _a.children, className = _a.className, tooltip = _a.tooltip, variant = _a.variant, association = _a.association, show = _a.show, placement = _a.placement, portal = _a.portal, hideElementOnHidden = _a.hideElementOnHidden, buttonProps = tslib.__rest(_a, ["children", "className", "tooltip", "variant", "association", "show", "placement", "portal", "hideElementOnHidden"]);
    var buttonRef = React.useRef(null);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("button", tslib.__assign({ type: "button", ref: buttonRef, "aria-disabled": "true", className: classNames__default["default"]('TooltipTabstop', className) }, buttonProps), children),
        React__default["default"].createElement(Tooltip, { target: buttonRef, variant: variant, association: association, show: show, placement: placement, portal: portal, hideElementOnHidden: hideElementOnHidden }, tooltip)));
}
TooltipTabstop.displayName = 'TooltipTabstop';

var TextField = /** @class */ (function (_super) {
    tslib.__extends(TextField, _super);
    function TextField(props) {
        var _this = _super.call(this, props) || this;
        _this.inputId = _this.props.id || randomId();
        _this.errorId = randomId();
        _this.descriptionId = randomId();
        _this.state = {
            value: typeof _this.props.value !== 'undefined'
                ? _this.props.value
                : _this.props.defaultValue || ''
        };
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }
    TextField.prototype.render = function () {
        var _this = this;
        var isRequired = !!this.props.required;
        // disabling `no-unused-vars` to prevent specific
        // props from being passed through to the input
        var _a = this.props, label = _a.label, fieldRef = _a.fieldRef, value = _a.value, description = _a.description; 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.onChange; 
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        _a.defaultValue; var _b = _a.error, error = _b === void 0 ? null : _b, requiredText = _a.requiredText, multiline = _a.multiline, ariaDescribedby = _a["aria-describedby"]; _a.children; var className = _a.className, other = tslib.__rest(_a, ["label", "fieldRef", "value", "description", "onChange", "defaultValue", "error", "requiredText", "multiline", 'aria-describedby', "children", "className"]);
        // typescript can't infer the type so it's complaining about
        // textarea and input props being incompatible
        // we should probably fix this
        var Field = multiline ? 'textarea' : 'input';
        var describedby = description
            ? addIdRef(ariaDescribedby, this.descriptionId)
            : ariaDescribedby;
        var inputProps = {
            'aria-describedby': error
                ? addIdRef(describedby, this.errorId)
                : describedby
        };
        return (React__default["default"].createElement("div", { className: "Field" },
            React__default["default"].createElement("label", { className: classNames__default["default"]('Field__label', {
                    'Field__label--is-required': isRequired,
                    'Field__label--has-error': error
                }), htmlFor: this.inputId },
                React__default["default"].createElement("span", null, label),
                isRequired && (React__default["default"].createElement("span", { className: "Field__required-text", "aria-hidden": "true" }, requiredText))),
            description && (React__default["default"].createElement("div", { className: "Field__description", id: this.descriptionId }, description)),
            error && (React__default["default"].createElement("div", { className: "Field__error", id: this.errorId },
                React__default["default"].createElement(Icon, { type: "caution" }),
                error)),
            React__default["default"].createElement(Field, tslib.__assign({ className: classNames__default["default"](className, {
                    'Field__text-input': !multiline,
                    Field__textarea: multiline,
                    'Field--has-error': error
                }), id: this.inputId, value: typeof value !== 'undefined' ? value : this.state.value, onChange: this.onChange, "aria-invalid": !!error, ref: function (input) {
                    _this.input = input;
                    setRef(fieldRef, input);
                } }, other, inputProps))));
    };
    TextField.prototype.onChange = function (e) {
        var _a, _b;
        if (this.props.onChange) {
            this.props.onChange(((_a = this.input) === null || _a === void 0 ? void 0 : _a.value) || /* istanbul ignore next: default value */ '', e);
        }
        if (typeof this.props.value !== 'undefined') {
            return;
        }
        this.setState({
            value: (_b = this.input) === null || _b === void 0 ? void 0 : _b.value
        });
    };
    TextField.displayName = 'TextField';
    TextField.defaultProps = {
        error: null,
        required: false,
        defaultValue: null,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onChange: function () { },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        fieldRef: function () { },
        requiredText: 'Required',
        multiline: false
    };
    return TextField;
}(React__default["default"].Component));

var TextFieldWrapper = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, otherProps = tslib.__rest(_a, ["className", "children"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('TextFieldWrapper', className) }, otherProps, { ref: ref }), children));
});
TextFieldWrapper.displayName = 'TextFieldWrapper';

var SearchField = React.forwardRef(function (_a, ref) {
    var className = _a.className, label = _a.label, _b = _a.defaultValue, defaultValue = _b === void 0 ? '' : _b, onChange = _a.onChange, _c = _a.hideLabel, hideLabel = _c === void 0 ? false : _c, _d = _a.placeholder, placeholder = _d === void 0 ? 'Search...' : _d, _e = _a.isForm, isForm = _e === void 0 ? true : _e, propId = _a.id, propValue = _a.value, trailingChildren = _a.trailingChildren, inputProps = tslib.__rest(_a, ["className", "label", "defaultValue", "onChange", "hideLabel", "placeholder", "isForm", "id", "value", "trailingChildren"]);
    var isControlled = typeof propValue !== 'undefined';
    var _f = tslib.__read(React.useState(isControlled ? propValue : defaultValue), 2), value = _f[0], setValue = _f[1];
    var _g = tslib.__read(propId ? [propId] : nextId.useId(1, 'search-field'), 1), id = _g[0];
    var inputId = React.useRef(id).current;
    var handleChange = function (e) {
        var newValue = e.target.value;
        if (typeof onChange === 'function') {
            onChange(newValue, e);
        }
        if (isControlled) {
            return;
        }
        setValue(newValue);
    };
    var Field = isForm ? 'form' : 'div';
    if (typeof trailingChildren === 'string') {
        trailingChildren = React__default["default"].createElement("span", null, trailingChildren);
    }
    return (React__default["default"].createElement(Field, { role: isForm ? 'search' : undefined, className: "SearchField", "aria-labelledby": isForm ? "".concat(inputId, "-label") : undefined },
        hideLabel ? (React__default["default"].createElement(Offscreen, null,
            React__default["default"].createElement("label", { htmlFor: inputId, id: "".concat(inputId, "-label") }, label))) : (React__default["default"].createElement("label", { className: "Field__label", htmlFor: inputId, id: "".concat(inputId, "-label") }, label)),
        React__default["default"].createElement(TextFieldWrapper, { className: classNames__default["default"](className, {
                'TextFieldWrapper--disabled': inputProps.disabled
            }) },
            React__default["default"].createElement(Icon, { type: "magnifying-glass", className: "SearchField__search-icon" }),
            React__default["default"].createElement("input", tslib.__assign({ id: inputId, value: isControlled ? propValue : value, onChange: handleChange, placeholder: placeholder, ref: ref }, inputProps, { type: "search" })),
            trailingChildren)));
});
SearchField.displayName = 'SearchField';

function copyTextToClipboard(text) {
    return tslib.__awaiter(this, void 0, void 0, function () {
        var copied, element, range, selection;
        return tslib.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    copied = false;
                    if (!('clipboard' in navigator)) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, navigator.clipboard.writeText(text)];
                case 2:
                    _a.sent();
                    copied = true;
                    return [3 /*break*/, 4];
                case 3:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    element = document.createElement('span');
                    element.textContent = text;
                    element.setAttribute('aria-hidden', 'true');
                    element.style.position = 'absolute';
                    element.style.height = '1px';
                    element.style.width = '1px';
                    element.style.overflow = 'hidden';
                    element.style.clip = 'rect(1px, 1px, 1px, 1px)';
                    element.style.marginTop = '-1px';
                    element.style.webkitUserSelect = 'text';
                    element.style.userSelect = 'text';
                    document.body.appendChild(element);
                    range = document.createRange();
                    selection = document.getSelection();
                    range.selectNodeContents(element);
                    selection === null || selection === void 0 ? void 0 : selection.addRange(range);
                    try {
                        document.execCommand(text);
                        copied = true;
                    }
                    catch (ex) {
                        // no fallback
                    }
                    element.remove();
                    _a.label = 6;
                case 6: return [2 /*return*/, copied];
            }
        });
    });
}

var NOTIFICATION_TIMEOUT_MS = 2000;
var CopyButton = React.forwardRef(function (_a, ref) {
    var className = _a.className, value = _a.value, _b = _a.variant, variant = _b === void 0 ? 'tertiary' : _b, _c = _a.children, children = _c === void 0 ? 'Copy' : _c, _d = _a.notificationLabel, notificationLabel = _d === void 0 ? 'Copied' : _d, _e = _a.hideVisibleLabel, hideVisibleLabel = _e === void 0 ? false : _e, _f = _a.tooltipPlacement, tooltipPlacement = _f === void 0 ? 'auto' : _f, onCopy = _a.onCopy, props = tslib.__rest(_a, ["className", "value", "variant", "children", "notificationLabel", "hideVisibleLabel", "tooltipPlacement", "onCopy"]);
    var _g = tslib.__read(React.useState(false), 2), copied = _g[0], setCopied = _g[1];
    var copyButtonRef = useSharedRef(ref);
    var handleClick = React.useCallback(function () {
        copyTextToClipboard(value);
        setCopied(true);
        if (typeof onCopy === 'function') {
            onCopy(value);
        }
    }, [value, onCopy]);
    React.useEffect(function () {
        var timeoutId = setTimeout(function () {
            setCopied(false);
        }, NOTIFICATION_TIMEOUT_MS);
        return function () {
            clearTimeout(timeoutId);
        };
    }, [copied]);
    // The visibility of the tooltip only needs to be controlled
    // when we are visually displaying the notification label
    var showTooltip = hideVisibleLabel && !copied ? undefined : copied ? true : false;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(Button, tslib.__assign({ className: classNames__default["default"](className, {
                'Button--condensed': hideVisibleLabel
            }), ref: copyButtonRef, variant: variant, onClick: handleClick }, props),
            React__default["default"].createElement(Icon, { type: copied ? 'check-solid' : 'copy' }),
            hideVisibleLabel ? React__default["default"].createElement(Offscreen, null, children) : children),
        React__default["default"].createElement(Tooltip, { target: copyButtonRef, placement: tooltipPlacement, association: "none", show: showTooltip }, hideVisibleLabel && !copied ? children : notificationLabel),
        typeof document !== 'undefined' &&
            reactDom.createPortal(React__default["default"].createElement(Offscreen, { "aria-live": "polite" }, copied ? notificationLabel : ' '), 
            // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
            document.body)));
});
CopyButton.displayName = 'CopyButton';

SyntaxHighlighter__default["default"].registerLanguage('javascript', js__default["default"]);
SyntaxHighlighter__default["default"].registerLanguage('css', css__default["default"]);
SyntaxHighlighter__default["default"].registerLanguage('html', xml__default["default"]);
SyntaxHighlighter__default["default"].registerLanguage('yaml', yaml__default["default"]);
// HACK: This is a workaround for a bug in react-syntax-highlighter's types.
var Highlighter = SyntaxHighlighter__default["default"];
var Code = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.scrollable, scrollable = _b === void 0 ? false : _b, label = _a.label, _c = _a.allowCopy, allowCopy = _c === void 0 ? false : _c, copyButtonProps = _a.copyButtonProps, props = tslib.__rest(_a, ["children", "className", "scrollable", "label", "allowCopy", "copyButtonProps"]);
    var ref = React.useRef(null);
    var _d = tslib.__read(React.useState(false), 2), scrollableRegion = _d[0], setScrollableRegion = _d[1];
    var _e = tslib.__read(nextId.useId(1, 'code'), 1), id = _e[0];
    // react-syntax-highlighter does not provide direct access to its dom elements
    // via refs, but we can specify the wrapping tags to bypass this limitation
    // see: https://github.com/react-syntax-highlighter/react-syntax-highlighter/issues/335
    var PreWithRef = function (preProps) { return (React__default["default"].createElement("pre", tslib.__assign({}, preProps, { ref: ref }))); };
    React.useEffect(function () {
        var _a;
        // Track the containing element because resize observer will not
        // trigger once an element becomes scrollable
        if (scrollable && ((_a = ref.current) === null || _a === void 0 ? void 0 : _a.parentElement)) {
            var listener = function () {
                if (!ref.current) {
                    return;
                }
                var element = ref.current;
                setScrollableRegion(element.clientWidth < element.scrollWidth);
            };
            var observer_1 = new ResizeObserver(listener);
            observer_1.observe(ref.current.parentElement);
        }
        return function () {
            setScrollableRegion(false);
        };
    }, [scrollable]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        (label || allowCopy) && (React__default["default"].createElement("div", { className: "Code__Header" },
            label && React__default["default"].createElement("span", { id: "".concat(id, "-label") }, label),
            allowCopy && React__default["default"].createElement(CopyButton, tslib.__assign({ value: children }, copyButtonProps)))),
        React__default["default"].createElement(Highlighter, tslib.__assign({}, props, { PreTag: PreWithRef, useInlineStyles: false, className: classNames__default["default"]('Code', className, {
                'Code--scrollable': scrollable
            }), tabIndex: scrollableRegion ? 0 : undefined }), children)));
};
Code.displayName = 'Code';

function AxeLoader() {
    return (React__default["default"].createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0", y: "0", viewBox: "0 0 800 800" },
        React__default["default"].createElement("path", { fill: "currentColor", d: "M641.4 555.6c-27.2-12.1-59.1.2-71.2 27.3-.5 1-.8 2.1-1.2 3.2H160l227.6-394.3 170.1 292.8 32.4-18.8L387.5 117 95 623.6h474c4.9 13.1 14.8 24.4 28.6 30.5 7.1 3.2 14.5 4.7 21.8 4.7 20.7 0 40.4-11.9 49.3-32 12.1-27.1-.1-59.1-27.3-71.2zm1.6 59.8c-5.8 13-21.1 18.9-34 13.1-13-5.8-18.9-21.1-13.1-34 4.3-9.6 13.7-15.3 23.6-15.3 3.5 0 7.1.7 10.4 2.2 13.1 5.7 18.9 21 13.1 34z" }),
        React__default["default"].createElement("path", { fill: "currentColor", d: "M379 549.9h-27.6v-16.7c-7.4 13.5-22.8 20.2-39 20.2-37.1 0-58.9-28.9-58.9-61.6 0-36.5 26.4-61.4 58.9-61.4 21.1 0 34 11.2 39 20.5V434H379v115.9zm-97.8-57.4c0 14.3 10.3 35.2 35.2 35.2 15.4 0 25.5-8 30.8-18.6 2.7-5.1 4-10.5 4.4-16.2.2-5.5-.8-11.2-3.2-16.2-4.9-11-15.6-20.5-32.3-20.5-22.4 0-35 18.1-35 36.1v.2zM436.2 488.9l-39-54.8h33.3l22.6 35.6 22.6-35.6h32.9l-38.8 54.8 43.2 61h-34L453.1 510l-26.2 39.9h-33.5l42.8-61z" })));
}

var LoaderOverlay = React.forwardRef(function (_a, ref) {
    var className = _a.className, label = _a.label, children = _a.children, focusOnInitialRender = _a.focusOnInitialRender, _b = _a.focusTrap, focusTrap = _b === void 0 ? false : _b, other = tslib.__rest(_a, ["className", "label", "children", "focusOnInitialRender", "focusTrap"]);
    var overlayRef = useSharedRef(ref);
    React.useEffect(function () {
        var isolator = overlayRef.current
            ? new AriaIsolate(overlayRef.current)
            : null;
        if (isolator) {
            focusTrap ? isolator.activate() : isolator.deactivate();
        }
        return function () {
            isolator === null || isolator === void 0 ? void 0 : isolator.deactivate();
        };
    }, [focusTrap, overlayRef.current]);
    React.useEffect(function () {
        if (!!focusOnInitialRender && overlayRef.current) {
            overlayRef.current.focus();
        }
    }, []);
    useFocusTrap(overlayRef, {
        disabled: !focusTrap,
        initialFocusElement: overlayRef
    });
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('Loader__overlay', className), ref: overlayRef, tabIndex: -1 }, other),
        React__default["default"].createElement("div", { className: "Loader__overlay__loader" },
            React__default["default"].createElement(Loader, null),
            React__default["default"].createElement(AxeLoader, null)),
        label ? React__default["default"].createElement("span", { className: "Loader__overlay__label" }, label) : null,
        children));
});
LoaderOverlay.displayName = 'LoaderOverlay';

var Line = function (_a) {
    var className = _a.className, other = tslib.__rest(_a, ["className"]);
    return (React__default["default"].createElement("hr", tslib.__assign({ className: classNames__default["default"]('Line', className) }, other)));
};
Line.displayName = 'Line';

var TagLabel = function (_a) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('Tag__label', className) }, other), children));
};
TagLabel.displayName = 'TagLabel';
var Tag = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.size, size = _b === void 0 ? 'default' : _b, other = tslib.__rest(_a, ["children", "className", "size"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('Tag', className, {
            'Tag--small': size === 'small'
        }) }, other), children));
};
Tag.displayName = 'Tag';

var BadgeLabel = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("div", tslib.__assign({ ref: ref, className: classNames__default["default"]('Badge__Label', className) }, other), children));
});
BadgeLabel.displayName = 'BadgeLabel';
var Badge = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, _b = _a.size, size = _b === void 0 ? 'default' : _b, other = tslib.__rest(_a, ["children", "className", "size"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('Badge', className, {
            'Badge--small': size === 'small'
        }), ref: ref }, other), children));
});
Badge.displayName = 'Badge';

var typeValues = {
    critical: 'Critical',
    serious: 'Serious',
    moderate: 'Moderate',
    minor: 'Minor'
};
var ImpactBadge = React.forwardRef(function (_a, ref) {
    var type = _a.type, label = _a.label, className = _a.className, other = tslib.__rest(_a, ["type", "label", "className"]);
    return (React__default["default"].createElement(Badge, tslib.__assign({ className: classNames__default["default"]("ImpactBadge", "ImpactBadge--".concat(type), className), ref: ref }, other), label || (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(BadgeLabel, null, "Impact:"),
        typeValues[type]))));
});
ImpactBadge.displayName = 'ImpactBadge';

var TagButton = React__default["default"].forwardRef(function (_a, ref) {
    var label = _a.label, value = _a.value, icon = _a.icon, className = _a.className, size = _a.size, rest = tslib.__rest(_a, ["label", "value", "icon", "className", "size"]);
    return (React__default["default"].createElement(Button, tslib.__assign({ variant: "tag", className: classNames__default["default"]('TagButton', className), size: size, ref: ref }, rest),
        React__default["default"].createElement(TagLabel, null, label),
        value,
        React__default["default"].createElement(Icon, { className: "TagButton__icon", type: icon })));
});
TagButton.displayName = 'TagButton';

var TableContext = React.createContext({
    layout: 'table',
    columns: []
});
function TableProvider(_a) {
    var children = _a.children, layout = _a.layout, columns = _a.columns;
    var Provider = TableContext.Provider;
    var contextValue = React.useMemo(function () { return ({
        layout: layout,
        columns: columns
    }); }, [layout, columns]);
    return React__default["default"].createElement(Provider, { value: contextValue }, children);
}
function useTable() {
    return React.useContext(TableContext);
}

function parseColumnWidth(width) {
    var number = Number(width);
    if (!isNaN(number)) {
        return "".concat(number, "px");
    }
    if (!width) {
        return 'auto';
    }
    return width;
}
var Table = React__default["default"].forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, variant = _a.variant, layout = _a.layout, _b = _a.columns, columnsProp = _b === void 0 ? [] : _b, style = _a.style, other = tslib.__rest(_a, ["children", "className", "variant", "layout", "columns", "style"]);
    var isGridLayout = layout === 'grid';
    var columns = React.useMemo(function () {
        if (typeof columnsProp === 'number') {
            return columnsProp > 0
                ? Array(columnsProp).fill({ align: 'start' })
                : [{ align: 'start' }];
        }
        return columnsProp;
    }, [columnsProp]);
    var styleTemplateColumns = React.useMemo(function () {
        if (layout !== 'grid') {
            return;
        }
        if (!columns) {
            return 'auto';
        }
        return columns
            .map(function (_a) {
            var width = _a.width, maxWidth = _a.maxWidth;
            if (maxWidth) {
                return "minmax(".concat(parseColumnWidth(width), ", ").concat(parseColumnWidth(maxWidth), ")");
            }
            return parseColumnWidth(width);
        })
            .join(' ');
    }, [layout, columns]);
    var tableGridStyles = isGridLayout
        ? {
            '--table-grid-template-columns': styleTemplateColumns
        }
        : {};
    return (React__default["default"].createElement("table", tslib.__assign({ ref: ref, style: tslib.__assign(tslib.__assign({}, tableGridStyles), style), className: classNames__default["default"]('Table', className, {
            'Table--border': variant === 'border',
            TableGrid: isGridLayout
        }) }, other),
        React__default["default"].createElement(TableProvider, { layout: isGridLayout ? 'grid' : 'table', columns: columns }, children)));
});
Table.displayName = 'Table';

var TableBody = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("tbody", tslib.__assign({ ref: ref, className: classNames__default["default"]('TableBody', className) }, other), children));
});
TableBody.displayName = 'TableBody';

function useTableGridStyles(_a) {
    var elementRef = _a.elementRef, align = _a.align, layout = _a.layout, columns = _a.columns;
    var isGridLayout = layout === 'grid';
    var _b = tslib.__read(React.useState(align || 'start'), 2), columnAlignment = _b[0], setColumnAlignment = _b[1];
    var _c = tslib.__read(React.useState(1), 2), gridColumnSpan = _c[0], setGridColumnSpan = _c[1];
    var _d = tslib.__read(React.useState(1), 2), gridRowSpan = _d[0], setGridRowSpan = _d[1];
    React.useEffect(function () {
        var _a;
        if (!isGridLayout) {
            return;
        }
        var element = elementRef.current;
        var column = typeof columns !== 'number' && columns[(_a = element === null || element === void 0 ? void 0 : element.cellIndex) !== null && _a !== void 0 ? _a : -1];
        if (!column) {
            setColumnAlignment(align || 'start');
        }
        else {
            setColumnAlignment(column.align);
        }
        if (element === null || element === void 0 ? void 0 : element.colSpan) {
            setGridColumnSpan(element.colSpan);
        }
        else {
            setGridColumnSpan(1);
        }
        if (element === null || element === void 0 ? void 0 : element.rowSpan) {
            setGridRowSpan(element.rowSpan);
        }
        else {
            setGridRowSpan(1);
        }
    }, [isGridLayout, columns, align]);
    return isGridLayout
        ? {
            textAlign: columnAlignment,
            gridColumn: gridColumnSpan > 1 ? "span ".concat(gridColumnSpan) : undefined,
            gridRow: gridRowSpan > 1 ? "span ".concat(gridRowSpan) : undefined
        }
        : {};
}

var TableCell = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, align = _a.align, style = _a.style, other = tslib.__rest(_a, ["children", "className", "align", "style"]);
    var tableCellRef = useSharedRef(ref);
    var _b = useTable(), layout = _b.layout, columns = _b.columns;
    var tableGridStyles = useTableGridStyles({
        elementRef: tableCellRef,
        align: align,
        columns: columns,
        layout: layout
    });
    return (React__default["default"].createElement("td", tslib.__assign({ ref: tableCellRef, style: tslib.__assign(tslib.__assign({}, tableGridStyles), style), className: classNames__default["default"]('TableCell', className) }, other), children));
});
TableCell.displayName = 'TableCell';

var TableHead = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("thead", tslib.__assign({ ref: ref, className: classNames__default["default"]('TableHead', className) }, other), children));
});
TableHead.displayName = 'TableHead';

var TableHeader = React.forwardRef(function (_a, ref) {
    var children = _a.children, sortDirection = _a.sortDirection, onSort = _a.onSort, className = _a.className, _sortAscendingAnnouncement = _a.sortAscendingAnnouncement, _sortDescendingAnnouncement = _a.sortDescendingAnnouncement, align = _a.align, _b = _a.variant, variant = _b === void 0 ? 'header' : _b, style = _a.style, other = tslib.__rest(_a, ["children", "sortDirection", "onSort", "className", "sortAscendingAnnouncement", "sortDescendingAnnouncement", "align", "variant", "style"]);
    var tableHeaderRef = useSharedRef(ref);
    var _c = useTable(), layout = _c.layout, columns = _c.columns;
    var tableGridStyles = useTableGridStyles({
        elementRef: tableHeaderRef,
        align: align,
        columns: columns,
        layout: layout
    });
    React.useEffect(function () {
        if (process.env.NODE_ENV === 'production')
            return;
        if (_sortAscendingAnnouncement !== undefined ||
            _sortDescendingAnnouncement !== undefined) {
            console.warn('[TableHeader] The following props are deprecated and no longer used: sortAscendingAnnouncement, sortDescendingAnnouncement. ' +
                'Sort state is communicated via aria-sort. ' +
                'See https://cauldron.dequelabs.com/components/Table for more information.');
        }
    }, [_sortAscendingAnnouncement, _sortDescendingAnnouncement]);
    return (React__default["default"].createElement("th", tslib.__assign({ ref: tableHeaderRef, "aria-sort": sortDirection, className: classNames__default["default"](variant === 'cell'
            ? ['TableCell', 'TableHeader--cell-variant']
            : 'TableHeader', className, {
            'TableHeader--sort-ascending': sortDirection === 'ascending',
            'TableHeader--sort-descending': sortDirection === 'descending'
        }), style: tslib.__assign(tslib.__assign({}, tableGridStyles), style) }, other), !!onSort && !!sortDirection ? (React__default["default"].createElement("button", { onClick: onSort, className: "TableHeader__sort-button", type: "button" },
        children,
        React__default["default"].createElement("span", { "aria-hidden": "true" }, sortDirection === 'none' ? (React__default["default"].createElement(Icon, { type: "sort-triangle" })) : sortDirection === 'ascending' ? (React__default["default"].createElement(Icon, { type: "table-sort-ascending" })) : (React__default["default"].createElement(Icon, { type: "table-sort-descending" }))))) : (children)));
});
TableHeader.displayName = 'TableHeader';

var TableRow = function (_a) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("tr", tslib.__assign({ className: classNames__default["default"]('TableRow', className) }, other), children));
};
TableRow.displayName = 'TableRow';

var TableFooter = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("tfoot", tslib.__assign({ ref: ref, className: classNames__default["default"]('TableFooter', className) }, other), children));
});
TableFooter.displayName = 'TableFooter';

var Tab = React__default["default"].forwardRef(function (_a, ref) {
    var children = _a.children, propId = _a.id; _a.target; var other = tslib.__rest(_a, ["children", "id", "target"]);
    return (React__default["default"].createElement("li", tslib.__assign({ id: propId, ref: ref, role: "tab" }, other), children));
});
Tab.displayName = 'Tab';

var Tabs = function (_a) {
    var children = _a.children, thin = _a.thin, _b = _a.orientation, orientation = _b === void 0 ? 'horizontal' : _b, _c = _a.initialActiveIndex, initialActiveIndex = _c === void 0 ? 0 : _c, className = _a.className, onChange = _a.onChange, labelProp = tslib.__rest(_a, ["children", "thin", "orientation", "initialActiveIndex", "className", "onChange"]);
    var _d = tslib.__read(React.useState(initialActiveIndex), 2), activeIndex = _d[0], setActiveIndex = _d[1];
    var tabsRef = React.useRef(null);
    var tabs = React__default["default"].Children.toArray(children).filter(function (child) { return child.type === Tab; });
    var tabCount = tabs.length;
    var handleClick = function (index) {
        setActiveIndex(index);
    };
    var handleKeyDown = function (event) {
        var key = event.key;
        var newIndex = activeIndex;
        var forward;
        var backward;
        if (orientation === 'horizontal') {
            forward = 'ArrowRight';
            backward = 'ArrowLeft';
        }
        else {
            forward = 'ArrowDown';
            backward = 'ArrowUp';
        }
        switch (key) {
            case backward: {
                newIndex = activeIndex - 1;
                // circularity
                if (newIndex === -1) {
                    newIndex = tabCount - 1;
                }
                setActiveIndex(newIndex);
                event.preventDefault();
                break;
            }
            case forward: {
                newIndex = activeIndex + 1;
                // circularity
                if (newIndex === tabCount) {
                    newIndex = 0;
                }
                setActiveIndex(newIndex);
                event.preventDefault();
                break;
            }
            case 'Home': {
                newIndex = 0;
                setActiveIndex(newIndex);
                event.preventDefault();
                break;
            }
            case 'End': {
                event.preventDefault();
                newIndex = tabCount - 1;
                setActiveIndex(newIndex);
                event.preventDefault();
                break;
            }
        }
    };
    var tabComponents = tabs.map(function (child, index) {
        var _a;
        var _b;
        var _c = child.props, target = _c.target, propId = _c.id, other = tslib.__rest(_c, ["target", "id"]);
        var selected = index === activeIndex;
        var _d = tslib.__read(propId ? [propId] : nextId.useId(1, 'tab'), 1), id = _d[0];
        React.useEffect(function () {
            var _a;
            (_a = target.current) === null || _a === void 0 ? void 0 : _a.setAttribute('aria-labelledby', id);
        }, [target]);
        React.useEffect(function () {
            var _a, _b;
            index === activeIndex
                ? (_a = target.current) === null || _a === void 0 ? void 0 : _a.classList.remove('TabPanel--hidden')
                : (_b = target.current) === null || _b === void 0 ? void 0 : _b.classList.add('TabPanel--hidden');
        }, [activeIndex]);
        var config = tslib.__assign((_a = { id: id, className: classNames__default["default"]('Tab', {
                    'Tab--active': selected
                }), tabIndex: index === activeIndex ? 0 : -1 }, _a['aria-controls'] = (_b = target.current) === null || _b === void 0 ? void 0 : _b.id, _a['aria-selected'] = selected, _a.onClick = function () { return handleClick(index); }, _a), other);
        return React__default["default"].cloneElement(child, config);
    });
    useDidUpdate(function () {
        var _a;
        var activeTab = (_a = tabsRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(':scope > [role="tablist"] > [aria-selected="true"]');
        activeTab === null || activeTab === void 0 ? void 0 : activeTab.focus();
        if (typeof onChange === 'function') {
            onChange({ activeTabIndex: activeIndex, target: activeTab });
        }
    }, [activeIndex]);
    return (React__default["default"].createElement("div", { className: classNames__default["default"]('Tabs', className, {
            'Tabs--thin': thin,
            'Tabs--vertical': orientation === 'vertical',
            'Tabs--horizontal': orientation === 'horizontal'
        }), ref: tabsRef },
        React__default["default"].createElement("ul", tslib.__assign({ role: "tablist", className: "Tablist" }, labelProp, { onKeyDown: handleKeyDown }), tabComponents)));
};
Tabs.displayName = 'Tabs';

var TabPanel = React.forwardRef(function (_a, ref) {
    var children = _a.children, propId = _a.id, className = _a.className, other = tslib.__rest(_a, ["children", "id", "className"]);
    var _b = tslib.__read(propId ? [propId] : nextId.useId(1, 'tabpanel'), 1), id = _b[0];
    return (React__default["default"].createElement("div", tslib.__assign({ role: "tabpanel", className: classNames__default["default"]('TabPanel', className), id: id, ref: ref }, other), children));
});
TabPanel.displayName = 'TabPanel';

var DescriptionList = function (_a) {
    var children = _a.children, className = _a.className, _b = _a.collapsed, collapsed = _b === void 0 ? false : _b, other = tslib.__rest(_a, ["children", "className", "collapsed"]);
    return (React__default["default"].createElement("dl", tslib.__assign({ className: classNames__default["default"]('DescriptionList', className, {
            'DescriptionList--collapsed': collapsed
        }) }, other), children));
};
DescriptionList.displayName = 'DescriptionList';
var DescriptionListItem = function (_a) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('DescriptionList__item', className) }, other), children));
};
DescriptionListItem.displayName = 'DescriptionListItem';
var DescriptionTerm = function (_a) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("dt", tslib.__assign({ className: classNames__default["default"]('DescriptionList__term', className) }, other), children));
};
DescriptionTerm.displayName = 'DescriptionTerm';
var DescriptionDetails = function (_a) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("dd", tslib.__assign({ className: classNames__default["default"]('DescriptionList__details', className) }, other), children));
};
DescriptionDetails.displayName = 'DescriptionDetails';

var MetadataList = React.forwardRef(function (_a, ref) {
    var _b = _a.orientation, orientation = _b === void 0 ? 'horizontal' : _b, className = _a.className, children = _a.children, rest = tslib.__rest(_a, ["orientation", "className", "children"]);
    return (React__default["default"].createElement("dl", tslib.__assign({ className: classNames__default["default"]('MetadataList', "MetadataList--".concat(orientation), className), ref: ref }, rest), children));
});
MetadataList.displayName = 'MetadataList';
var MetadataListItem = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, rest = tslib.__rest(_a, ["className", "children"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('MetadataList__item', className), ref: ref }, rest), children));
});
MetadataListItem.displayName = 'MetadataListItem';
var MetadataListLabel = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, rest = tslib.__rest(_a, ["className", "children"]);
    return (React__default["default"].createElement("dt", tslib.__assign({ className: classNames__default["default"]('MetadataList__label', className), ref: ref }, rest), children));
});
MetadataListLabel.displayName = 'MetadataListLabel';
var MetadataListValue = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, rest = tslib.__rest(_a, ["className", "children"]);
    return (React__default["default"].createElement("dd", tslib.__assign({ className: classNames__default["default"]('MetadataList__value', className), ref: ref }, rest), children));
});
MetadataListValue.displayName = 'MetadataListValue';

var isTooltipProps = function (props) {
    return !!props.tooltip;
};
var Step = function (props) {
    var _a;
    var children = props.children, status = props.status, className = props.className, other = tslib.__rest(props, ["children", "status", "className"]);
    var tooltip;
    var tooltipText;
    var liProps;
    var isTooltip = isTooltipProps(other);
    if (isTooltip) {
        (_a = other, tooltip = _a.tooltip, tooltipText = _a.tooltipText, liProps = tslib.__rest(_a, ["tooltip", "tooltipText"]));
    }
    else {
        liProps = other;
    }
    return (React__default["default"].createElement("li", tslib.__assign({ className: classNames__default["default"]('Stepper__step', "Stepper__step--".concat(status), className), "aria-current": status === 'current' ? 'step' : 'false' }, liProps),
        React__default["default"].createElement("div", { className: classNames__default["default"]('Stepper__step-line', "Stepper__step--".concat(status, "-line")) }),
        React__default["default"].createElement("div", { className: "Stepper__step-content" }, isTooltip ? (React__default["default"].createElement(TooltipTabstop, { placement: "bottom", tooltip: tooltip, 
            // the pseudo content (ex: "1") is conveyed
            // by the list item's position in the set of
            // list items, therefore it is safe to clobber
            // it with the contents of the tooltip in the
            // tab stop's accessible name.
            association: "aria-labelledby", "aria-label": tooltipText },
            React__default["default"].createElement("div", { className: classNames__default["default"]('Stepper__step-indicator', "Stepper__step--".concat(status, "-indicator")) }, status === 'complete' && React__default["default"].createElement(Icon, { type: 'check' })))) : (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement("div", { className: classNames__default["default"]('Stepper__step-indicator', "Stepper__step--".concat(status, "-indicator")) }, status === 'complete' && React__default["default"].createElement(Icon, { type: 'check' })),
            children ? (React__default["default"].createElement("div", { className: classNames__default["default"]('Stepper__step-label', "Stepper__step--".concat(status, "-label")) }, children)) : null)))));
};
Step.displayName = 'Step';
var Stepper = function (_a) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("ol", tslib.__assign({ className: classNames__default["default"]('Stepper', className) }, other), children));
};
Stepper.displayName = 'Stepper';

var ProgressBar = React.forwardRef(function (_a, ref) {
    var _b = _a.progress, progress = _b === void 0 ? 0 : _b, _c = _a.progressMax, progressMax = _c === void 0 ? 100 : _c, _d = _a.progressMin, progressMin = _d === void 0 ? 0 : _d, thin = _a.thin, props = tslib.__rest(_a, ["progress", "progressMax", "progressMin", "thin"]);
    var className = props.className, otherProps = tslib.__rest(props, ["className"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('ProgressBar', { 'ProgressBar--thin': thin }, className), role: "progressbar", "aria-valuemin": progressMin, "aria-valuemax": progressMax, "aria-valuenow": progress, ref: ref }, otherProps),
        React__default["default"].createElement("div", { className: "ProgressBar--fill", style: { width: "".concat(Math.min((progress / progressMax) * 100, 100), "%") } })));
});
ProgressBar.displayName = 'ProgressBar';

var Address = function (_a) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return (React__default["default"].createElement("address", tslib.__assign({ className: classNames__default["default"]('Address', className) }, other), children));
};
Address.displayName = 'Address';
var AddressLine = function (_a) {
    var children = _a.children, className = _a.className, other = tslib.__rest(_a, ["children", "className"]);
    return children ? (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('Address__line', className) }, other), children)) : null;
};
AddressLine.displayName = 'AddressLine';
var AddressCityStateZip = function (_a) {
    var city = _a.city, state = _a.state, zip = _a.zip, className = _a.className, other = tslib.__rest(_a, ["city", "state", "zip", "className"]);
    return city || state || zip ? (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('Address__city-state-zip', className) }, other), [[city, state].filter(Boolean).join(', '), zip]
        .filter(Boolean)
        .join(' '))) : null;
};
AddressCityStateZip.displayName = 'AddressCityStateZip';

var Pagination = React__default["default"].forwardRef(function (_a, ref) {
    var totalItems = _a.totalItems, _b = _a.itemsPerPage, itemsPerPage = _b === void 0 ? 10 : _b, _c = _a.currentPage, currentPage = _c === void 0 ? 1 : _c, _d = _a.hideStartEndPagination, hideStartEndPagination = _d === void 0 ? false : _d, statusLabel = _a.statusLabel, _e = _a.firstPageLabel, firstPageLabel = _e === void 0 ? 'First page' : _e, _f = _a.previousPageLabel, previousPageLabel = _f === void 0 ? 'Previous page' : _f, _g = _a.nextPageLabel, nextPageLabel = _g === void 0 ? 'Next page' : _g, _h = _a.lastPageLabel, lastPageLabel = _h === void 0 ? 'Last page' : _h, _j = _a.tooltipPlacement, tooltipPlacement = _j === void 0 ? 'bottom' : _j, onNextPageClick = _a.onNextPageClick, onPreviousPageClick = _a.onPreviousPageClick, onFirstPageClick = _a.onFirstPageClick, onLastPageClick = _a.onLastPageClick, className = _a.className, _k = _a.thin, thin = _k === void 0 ? false : _k, other = tslib.__rest(_a, ["totalItems", "itemsPerPage", "currentPage", "hideStartEndPagination", "statusLabel", "firstPageLabel", "previousPageLabel", "nextPageLabel", "lastPageLabel", "tooltipPlacement", "onNextPageClick", "onPreviousPageClick", "onFirstPageClick", "onLastPageClick", "className", "thin"]);
    var itemStart = currentPage * itemsPerPage - itemsPerPage + 1;
    var itemEnd = Math.min(itemStart + itemsPerPage - 1, totalItems);
    var isLastPage = itemEnd === totalItems;
    var isFirstPage = currentPage === 1;
    return (React__default["default"].createElement("div", tslib.__assign({ ref: ref, className: classNames__default["default"]('Pagination', className, {
            'Pagination--thin': thin
        }) }, other),
        React__default["default"].createElement("ul", null,
            !hideStartEndPagination && (React__default["default"].createElement("li", null,
                React__default["default"].createElement(IconButton, { icon: "chevron-double-left", tooltipProps: { placement: tooltipPlacement }, label: firstPageLabel, "aria-disabled": isFirstPage, onClick: isFirstPage ? undefined : onFirstPageClick }))),
            React__default["default"].createElement("li", null,
                React__default["default"].createElement(IconButton, { icon: "chevron-left", tooltipProps: { placement: tooltipPlacement }, label: previousPageLabel, "aria-disabled": isFirstPage, onClick: isFirstPage ? undefined : onPreviousPageClick })),
            React__default["default"].createElement("li", null,
                React__default["default"].createElement("span", { role: "log", "aria-atomic": "true", "aria-live": "polite" }, statusLabel || (React__default["default"].createElement("span", null,
                    "Showing ",
                    React__default["default"].createElement("strong", null, itemStart),
                    " to",
                    ' ',
                    React__default["default"].createElement("strong", null, itemEnd),
                    " of ",
                    React__default["default"].createElement("strong", null, totalItems))))),
            React__default["default"].createElement("li", null,
                React__default["default"].createElement(IconButton, { icon: "chevron-right", tooltipProps: { placement: tooltipPlacement }, label: nextPageLabel, "aria-disabled": isLastPage, onClick: isLastPage ? undefined : onNextPageClick })),
            !hideStartEndPagination && (React__default["default"].createElement("li", null,
                React__default["default"].createElement(IconButton, { icon: "chevron-double-right", tooltipProps: { placement: tooltipPlacement }, label: lastPageLabel, "aria-disabled": isLastPage, onClick: isLastPage ? undefined : onLastPageClick }))))));
});
Pagination.displayName = 'Pagination';

var usePagination = function (_a) {
    var totalItems = _a.totalItems, _b = _a.initialPageSize, initialPageSize = _b === void 0 ? 10 : _b, _c = _a.initialPage, initialPage = _c === void 0 ? 1 : _c;
    var _d = tslib.__read(React.useState(initialPage), 2), currentPage = _d[0], setCurrentPage = _d[1];
    var pageStart = currentPage * initialPageSize - initialPageSize + 1;
    var pageEnd = Math.min(pageStart + initialPageSize - 1, totalItems);
    var onFirstPageClick = function () { return setCurrentPage(1); };
    var onPreviousPageClick = function () { return setCurrentPage(currentPage - 1); };
    var onNextPageClick = function () { return setCurrentPage(currentPage + 1); };
    var onLastPageClick = function () {
        return setCurrentPage(Math.ceil(totalItems / initialPageSize));
    };
    var pagination = {
        totalItems: totalItems,
        currentPage: currentPage,
        itemsPerPage: initialPageSize,
        onFirstPageClick: onFirstPageClick,
        onPreviousPageClick: onPreviousPageClick,
        onNextPageClick: onNextPageClick,
        onLastPageClick: onLastPageClick
    };
    var pageStatus = {
        currentPage: currentPage,
        pageStart: pageStart,
        pageEnd: pageEnd,
        setCurrentPage: setCurrentPage
    };
    return { pagination: pagination, pageStatus: pageStatus };
};

var FieldWrap = React__default["default"].forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, _b = _a.as, Component = _b === void 0 ? 'div' : _b, props = tslib.__rest(_a, ["children", "className", "as"]);
    return (React__default["default"].createElement(Component, tslib.__assign({ ref: ref, className: classNames__default["default"]('Panel', className) }, props), children));
});
FieldWrap.displayName = 'FieldWrap';

var Breadcrumb = React.forwardRef(function (_a, ref) {
    var _b = _a.separator, separator = _b === void 0 ? '/' : _b, className = _a.className, children = _a.children, props = tslib.__rest(_a, ["separator", "className", "children"]);
    var items = React__default["default"].Children.toArray(children);
    var childrenWithSeparators = [];
    items.forEach(function (child, index) {
        if (index !== items.length - 1) {
            childrenWithSeparators.push(React__default["default"].createElement(React__default["default"].Fragment, null,
                child,
                React__default["default"].createElement("span", { className: "Breadcrumb__Separator", "aria-hidden": "true" }, separator)));
        }
        else {
            childrenWithSeparators.push(child);
        }
    });
    return (React__default["default"].createElement("nav", tslib.__assign({ className: classNames__default["default"]('Breadcrumb', className), ref: ref }, props),
        React__default["default"].createElement("ol", null, childrenWithSeparators.map(function (child, index) { return (React__default["default"].createElement("li", { className: "Breadcrumb__Item", key: "breadcrumb-".concat(index) }, child)); }))));
});
Breadcrumb.displayName = 'Breadcrumb';

var BreadcrumbItem = React.forwardRef(// eslint-disable-line react/display-name
function (_a, ref) {
    var className = _a.className, children = _a.children, props = tslib.__rest(_a, ["className", "children"]);
    return (React__default["default"].createElement("span", tslib.__assign({ className: classNames__default["default"]('Breadcrumb__Item', className), ref: ref, "aria-current": "location" }, props), children));
});

var BreadcrumbLink = React.forwardRef(function (_a, ref) {
    var className = _a.className, _b = _a.as, ElementType = _b === void 0 ? 'a' : _b, children = _a.children, props = tslib.__rest(_a, ["className", "as", "children"]);
    return (React__default["default"].createElement(ElementType, tslib.__assign({ className: classNames__default["default"]('Link', 'Breadcrumb__Link', className), ref: ref }, props), children));
});
BreadcrumbLink.displayName = 'BreadcrumbLink';

var ColumnLeft = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, props = tslib.__rest(_a, ["className", "children"]);
    return (React__default["default"].createElement("section", tslib.__assign({ className: classNames__default["default"]('TwoColumnPanel__Left', className) }, props, { ref: ref }), children));
});
ColumnLeft.displayName = 'ColumnLeft';

var ColumnRight = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, props = tslib.__rest(_a, ["className", "children"]);
    return (React__default["default"].createElement("section", tslib.__assign({ className: classNames__default["default"]('TwoColumnPanel__Right', className) }, props, { ref: ref }), children));
});
ColumnRight.displayName = 'ColumnRight';

var TwoColumnPanel = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, _b = _a.initialCollapsed, initialCollapsed = _b === void 0 ? false : _b, _c = _a.showCollapsedPanelLabel, showCollapsedPanelLabel = _c === void 0 ? 'Show Panel' : _c, _d = _a.hideCollapsedPanelLabel, hideCollapsedPanelLabel = _d === void 0 ? 'Hide Panel' : _d, _e = _a.skipLink, skipLink = _e === void 0 ? null : _e, _f = _a.collapsedMediaQuery, collapsedMediaQuery = _f === void 0 ? '(max-width: 45rem)' : _f, props = tslib.__rest(_a, ["className", "children", "initialCollapsed", "showCollapsedPanelLabel", "hideCollapsedPanelLabel", "skipLink", "collapsedMediaQuery"]);
    var _g = tslib.__read(React.useState(initialCollapsed), 2), isCollapsed = _g[0], setCollapsed = _g[1];
    var _h = tslib.__read(React.useState(false), 2), isFocusTrap = _h[0], setIsFocusTrap = _h[1];
    var _j = tslib.__read(React.useState(!initialCollapsed), 2), showPanel = _j[0], setShowPanel = _j[1];
    var toggleButtonRef = React.useRef(null);
    var closeButtonRef = React.useRef(null);
    var columnLeftRef = React.useRef(null);
    var columnRightRef = React.useRef(null);
    var columnLeft = React__default["default"].Children.toArray(children).find(function (child) { return React__default["default"].isValidElement(child) && child.type === ColumnLeft; });
    var togglePanel = function () {
        var prefersReducedMotion = 'matchMedia' in window &&
            typeof matchMedia === 'function' &&
            matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (isCollapsed) {
            setShowPanel(true);
        }
        else if (prefersReducedMotion) {
            // Immediately collapse the panel as we do not need to wait for css
            // transitions to complete
            setShowPanel(false);
        }
        // Set collapsed state on next tick so css transitions can be applied
        requestAnimationFrame(function () {
            var _a, _b;
            var collapsed = !isCollapsed;
            setCollapsed(collapsed);
            if (!collapsed) {
                (_a = columnLeftRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
            else {
                (_b = columnRightRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
        });
    };
    // The ColumnLeftComponent will end up being a focus trap when < 720px
    // This component also gets unmounted when not visible meaning that any
    // aria relationships cannot be set to items inside the component since
    // they will not be present in the dom
    var ColumnLeftComponent;
    var columnLeftId;
    if (React.isValidElement(columnLeft)) {
        var columnLeftProps = columnLeft.props;
        var ref_1 = columnLeftProps.ref || columnLeftRef;
        var id = (columnLeftId =
            columnLeftProps.id || nextId.useId(undefined, 'sidebar-')[0]);
        var CloseButton = (React__default["default"].createElement("div", { className: "TwoColumnPanel__Close" },
            React__default["default"].createElement("button", { type: "button", onClick: togglePanel, ref: closeButtonRef, "aria-label": hideCollapsedPanelLabel },
                React__default["default"].createElement(Icon, { type: "close" })),
            React__default["default"].createElement(Tooltip, { target: closeButtonRef, association: "aria-labelledby", hideElementOnHidden: true }, hideCollapsedPanelLabel)));
        var children_1 = tslib.__spreadArray([
            CloseButton
        ], tslib.__read(React__default["default"].Children.toArray(columnLeftProps.children)), false);
        ColumnLeftComponent = React.cloneElement(columnLeft, { id: id, ref: ref_1, tabIndex: -1 }, children_1.map(function (child, index) {
            return React.cloneElement(child, {
                key: child.key
                    ? child.key
                    : "left-".concat(index)
            });
        }));
    }
    var columnRight = React__default["default"].Children.toArray(children).find(function (child) { return React__default["default"].isValidElement(child) && child.type === ColumnRight; });
    var ColumnRightComponent;
    if (React.isValidElement(columnRight)) {
        var columnRightProps = columnRight.props;
        var ref_2 = columnRightProps.ref || columnRightRef;
        var ToggleButton = (React__default["default"].createElement("div", { className: "TwoColumnPanel__ButtonToggle" },
            React__default["default"].createElement("button", { type: "button", onClick: togglePanel, ref: toggleButtonRef, "aria-label": !isCollapsed ? hideCollapsedPanelLabel : showCollapsedPanelLabel, "aria-expanded": !isCollapsed, "aria-controls": columnLeftId },
                React__default["default"].createElement(Icon, { type: !isCollapsed ? 'chevron-double-left' : 'chevron-double-right' })),
            React__default["default"].createElement(Tooltip, { target: toggleButtonRef, association: "aria-labelledby", hideElementOnHidden: true }, !isCollapsed ? hideCollapsedPanelLabel : showCollapsedPanelLabel)));
        var children_2 = tslib.__spreadArray([
            ToggleButton
        ], tslib.__read(React__default["default"].Children.toArray(columnRightProps.children)), false);
        ColumnRightComponent = React.cloneElement(columnRight, { ref: ref_2, tabIndex: -1 }, children_2.map(function (child, index) {
            return React.cloneElement(child, {
                key: child.key
                    ? child.key
                    : "right-".concat(index)
            });
        }));
    }
    React.useLayoutEffect(function () {
        var _a;
        var handleTransitionEnd = function () {
            if (columnLeftRef.current && isCollapsed) {
                setShowPanel(false);
            }
        };
        (_a = columnLeftRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('transitionend', handleTransitionEnd);
        return function () {
            var _a;
            (_a = columnLeftRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('transitionend', handleTransitionEnd);
        };
    }, [columnLeftRef.current, isCollapsed]);
    // When the collapsible panel starts to overlay content, it needs to become a focus trap and collapsed by default
    React.useLayoutEffect(function () {
        var mediaQueryList = matchMedia(collapsedMediaQuery);
        var handleMatch = function (matches) {
            setIsFocusTrap(matches);
            var collapsed = matches ? true : isCollapsed;
            setCollapsed(collapsed);
            setShowPanel(!collapsed);
        };
        var listener = function (_a) {
            var matches = _a.matches;
            return handleMatch(matches);
        };
        if (mediaQueryList.matches) {
            handleMatch(mediaQueryList.matches);
        }
        mediaQueryList.addEventListener('change', listener);
        return function () {
            mediaQueryList.removeEventListener('change', listener);
        };
    }, []);
    useEscapeKey({
        callback: function () { return setCollapsed(true); },
        active: isFocusTrap
    }, [setCollapsed]);
    var handleClickOutside = function () {
        if (!isCollapsed && isFocusTrap) {
            setCollapsed(true);
        }
    };
    useFocusTrap(columnLeftRef, {
        disabled: !showPanel || !isFocusTrap
    });
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('TwoColumnPanel', className, {
            'TwoColumnPanel--show': !isCollapsed,
            'TwoColumnPanel--hide': isCollapsed
        }) }, props, { ref: ref }),
        React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(ClickOutsideListener$1, { onClickOutside: handleClickOutside, target: columnLeftRef.current }),
            isCollapsed ? null : skipLink,
            showPanel ? ColumnLeftComponent : null,
            ColumnRightComponent)));
});
TwoColumnPanel.displayName = 'TwoColumnPanel';

var ColumnHeader = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, props = tslib.__rest(_a, ["className", "children"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('TwoColumnPanel__Header', className) }, props, { ref: ref }), children));
});
ColumnHeader.displayName = 'ColumnHeader';

var ColumnGroupHeader = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, props = tslib.__rest(_a, ["className", "children"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('TwoColumnPanel__GroupHeader', className) }, props, { ref: ref }), children));
});
ColumnGroupHeader.displayName = 'ColumnGroupHeader';

var ColumnList = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, props = tslib.__rest(_a, ["className", "children"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('TwoColumnPanel__List', className) }, props, { ref: ref }), children));
});
ColumnList.displayName = 'ColumnList';

var iconTypeMap = {
    caution: 'caution',
    danger: 'report',
    info: 'info-circle',
    success: 'check-circle'
};
var Notice = React.forwardRef(function (_a, ref) {
    var _b;
    var className = _a.className, _c = _a.type, type = _c === void 0 ? 'info' : _c, title = _a.title, icon = _a.icon, _d = _a.variant, variant = _d === void 0 ? 'default' : _d, children = _a.children, otherProps = tslib.__rest(_a, ["className", "type", "title", "icon", "variant", "children"]);
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('Notice', className, (_b = {},
            _b["Notice--".concat(type)] = type,
            _b["Notice--condensed"] = variant === 'condensed',
            _b)), ref: ref }, otherProps),
        React__default["default"].createElement(Icon, { type: icon || iconTypeMap[type] }),
        React__default["default"].createElement("div", { className: "Notice__title" }, title),
        children && React__default["default"].createElement("div", { className: "Notice__content" }, children)));
});
Notice.displayName = 'Notice';

/* istanbul ignore next */
var ListboxContext = React.createContext({
    options: [],
    active: null,
    selected: null,
    multiselect: false,
    setOptions: function () { return null; },
    onSelect: function () { return null; }
});
function ListboxProvider(_a) {
    var options = _a.options, active = _a.active, selected = _a.selected, multiselect = _a.multiselect, setOptions = _a.setOptions, onSelect = _a.onSelect, children = _a.children;
    var Provider = ListboxContext.Provider;
    var value = React.useMemo(function () { return ({
        options: options,
        active: active,
        selected: selected,
        multiselect: multiselect,
        setOptions: setOptions,
        onSelect: onSelect
    }); }, [options, active, selected, multiselect, setOptions]);
    return React__default["default"].createElement(Provider, { value: value }, children);
}
function useListboxContext() {
    return React.useContext(ListboxContext);
}

var keys = ['ArrowUp', 'ArrowDown', 'Home', 'End', 'Enter', ' '];
// id for listbox options should always be defined since it should
// be provide via the author, or auto-generated via the component
var getOptionId = function (option) {
    return option.element.getAttribute('id');
};
var isDisabledOption = function (option) {
    return option.element.getAttribute('aria-disabled') === 'true';
};
var optionMatchesValue = function (option, value) {
    return typeof option.value !== null &&
        typeof option.value !== 'undefined' &&
        option.value === value;
};
var Listbox = React.forwardRef(function (_a, ref) {
    var _b = _a.as, Component = _b === void 0 ? 'ul' : _b, children = _a.children, defaultValue = _a.defaultValue, value = _a.value, _c = _a.navigation, navigation = _c === void 0 ? 'bound' : _c, _d = _a.focusStrategy, focusStrategy = _d === void 0 ? 'lastSelected' : _d, _e = _a.focusDisabledOptions, focusDisabledOptions = _e === void 0 ? false : _e, _f = _a.multiselect, multiselect = _f === void 0 ? false : _f, onKeyDown = _a.onKeyDown, onFocus = _a.onFocus, onSelectionChange = _a.onSelectionChange, controlledActiveOption = _a.activeOption, onActiveChange = _a.onActiveChange, _g = _a.disabled, disabled = _g === void 0 ? false : _g, props = tslib.__rest(_a, ["as", "children", "defaultValue", "value", "navigation", "focusStrategy", "focusDisabledOptions", "multiselect", "onKeyDown", "onFocus", "onSelectionChange", "activeOption", "onActiveChange", "disabled"]);
    var _h = tslib.__read(React.useState([]), 2), options = _h[0], setOptions = _h[1];
    var _j = tslib.__read(React.useState(controlledActiveOption || null), 2), activeOption = _j[0], setActiveOption = _j[1];
    var _k = tslib.__read(React.useState([]), 2), selectedOptions = _k[0], setSelectedOptions = _k[1];
    var listboxRef = useSharedRef(ref);
    var isControlled = typeof value !== 'undefined';
    var isActiveControlled = typeof controlledActiveOption !== 'undefined';
    var hasActiveChangeHandler = typeof onActiveChange === 'function';
    React.useEffect(function () {
        if (process.env.NODE_ENV !== 'production' &&
            isActiveControlled &&
            hasActiveChangeHandler) {
            console.warn('Listbox received both `activeOption` and `onActiveChange`. Do not ' +
                'write the option reported by `onActiveChange` back into ' +
                '`activeOption`: the two copies then race, and a stale downward ' +
                'sync can revert a newer value and re-render without settling. ' +
                'Let Listbox own the active option, or use `activeOption` only as ' +
                'a one-shot request. ' +
                'See https://github.com/dequelabs/cauldron/issues/2512');
        }
    }, [isActiveControlled, hasActiveChangeHandler]);
    React.useLayoutEffect(function () {
        if (!isControlled && selectedOptions.length > 0) {
            return;
        }
        var listboxValue = isControlled ? value : defaultValue;
        if (!listboxValue) {
            return;
        }
        if (multiselect) {
            var matchingOptions = options.filter(function (option) {
                return listboxValue.find(function (value) {
                    return optionMatchesValue(option, value);
                });
            });
            setSelectedOptions(matchingOptions);
            if (!activeOption) {
                setActiveOption(matchingOptions[0] || null);
            }
        }
        else {
            var matchingOption = options.find(function (option) {
                return optionMatchesValue(option, listboxValue);
            });
            setSelectedOptions(matchingOption ? [matchingOption] : []);
            if (!activeOption) {
                setActiveOption(matchingOption || null);
            }
        }
    }, [isControlled, options, value, defaultValue, activeOption]);
    React.useEffect(function () {
        if (activeOption) {
            onActiveChange === null || onActiveChange === void 0 ? void 0 : onActiveChange(activeOption);
        }
    }, [activeOption]);
    React.useEffect(function () {
        if (isActiveControlled &&
            (controlledActiveOption === null || controlledActiveOption === void 0 ? void 0 : controlledActiveOption.element) !== (activeOption === null || activeOption === void 0 ? void 0 : activeOption.element)) {
            setActiveOption(controlledActiveOption || null);
        }
    }, [isActiveControlled, controlledActiveOption]);
    var handleSelect = React.useCallback(function (option) {
        var _a;
        setActiveOption(option);
        if (disabled) {
            return;
        }
        var optionIsSelected = selectedOptions.some(function (selected) { return selected.element === option.element; });
        var previousValues = selectedOptions.map(function (selected) { return selected.value; });
        // istanbul ignore else
        if (!isControlled) {
            if (!multiselect) {
                setSelectedOptions([option]);
            }
            else {
                setSelectedOptions(optionIsSelected
                    ? tslib.__spreadArray([], tslib.__read(selectedOptions.filter(function (selected) { return selected.element !== option.element; })), false) : tslib.__spreadArray(tslib.__spreadArray([], tslib.__read(selectedOptions), false), [option], false));
            }
        }
        if (multiselect) {
            onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
                target: option.element,
                value: optionIsSelected
                    ? selectedOptions
                        .filter(function (selectedOption) {
                        return selectedOption.element !== option.element;
                    })
                        .map(function (selectedOption) { return selectedOption.value; })
                    : tslib.__spreadArray(tslib.__spreadArray([], tslib.__read(previousValues), false), [option.value], false),
                previousValue: previousValues
            });
        }
        else {
            onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
                target: option.element,
                value: option.value,
                previousValue: (_a = selectedOptions[0]) === null || _a === void 0 ? void 0 : _a.value
            });
        }
    }, [isControlled, selectedOptions, multiselect, onSelectionChange]);
    var handleKeyDown = React.useCallback(function (event) {
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        if (!keys.includes(event.key)) {
            return;
        }
        event.preventDefault();
        var enabledOptions = !focusDisabledOptions
            ? options.filter(function (option) { return !isDisabledOption(option); })
            : options;
        // istanbul ignore next
        if (!enabledOptions.length) {
            return;
        }
        var _a = tslib.__read(keys, 6), up = _a[0], down = _a[1], home = _a[2], end = _a[3], enter = _a[4], space = _a[5];
        var firstOption = enabledOptions[0];
        if (!activeOption) {
            setActiveOption(firstOption);
            return;
        }
        var lastOption = enabledOptions[enabledOptions.length - 1];
        var currentOption = activeOption;
        var currentIndex = enabledOptions.findIndex(function (_a) {
            var element = _a.element;
            return element === currentOption.element;
        });
        var allowCyclicalNavigation = navigation === 'cycle';
        switch (event.key) {
            case up:
                var previousOption = currentIndex === 0 && allowCyclicalNavigation
                    ? lastOption
                    : enabledOptions[Math.max(currentIndex - 1, 0)];
                setActiveOption(previousOption);
                break;
            case down:
                var nextOption = currentIndex === enabledOptions.length - 1 &&
                    allowCyclicalNavigation
                    ? firstOption
                    : enabledOptions[Math.min(currentIndex + 1, enabledOptions.length - 1)];
                setActiveOption(nextOption);
                break;
            case home:
                setActiveOption(firstOption);
                break;
            case end:
                setActiveOption(lastOption);
                break;
            case enter:
            case space: {
                if (activeOption && !isDisabledOption(activeOption)) {
                    // Since focus is managed in the listbox using `aria-activedescendant`
                    // we want to simulate a keypress on the current active list item
                    activeOption.element.click();
                }
                break;
            }
        }
    }, [options, activeOption, navigation]);
    var handleFocus = React.useCallback(function (event) {
        if (focusStrategy === 'first') {
            var firstOption = !focusDisabledOptions
                ? options.find(function (option) { return !isDisabledOption(option); })
                : options[0];
            if (firstOption && firstOption.element !== (activeOption === null || activeOption === void 0 ? void 0 : activeOption.element)) {
                setActiveOption(firstOption);
            }
            return;
        }
        if (focusStrategy === 'last') {
            var lastOption = !focusDisabledOptions
                ? tslib.__spreadArray([], tslib.__read(options), false).reverse().find(function (option) { return !isDisabledOption(option); })
                : options[options.length - 1];
            if (lastOption && lastOption.element !== (activeOption === null || activeOption === void 0 ? void 0 : activeOption.element)) {
                setActiveOption(lastOption);
            }
            return;
        }
        if (!activeOption ||
            !options.some(function (option) { return option.element === activeOption.element; })) {
            var firstOption = !focusDisabledOptions
                ? options.find(function (option) { return !isDisabledOption(option); })
                : options[0];
            // istanbul ignore else
            if (firstOption) {
                setActiveOption(firstOption);
            }
            // istanbul ignore else
        }
        else if (selectedOptions.length &&
            event.target === listboxRef.current) {
            setActiveOption(selectedOptions[selectedOptions.length - 1]);
        }
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
    }, [options, activeOption, selectedOptions, focusStrategy]);
    return (React__default["default"].createElement(Component, tslib.__assign({ role: "listbox", ref: listboxRef, tabIndex: "0", onKeyDown: handleKeyDown, onFocus: handleFocus, "aria-multiselectable": multiselect ? true : undefined, "aria-activedescendant": activeOption ? getOptionId(activeOption) : undefined }, props),
        React__default["default"].createElement(ListboxProvider, { options: options, active: activeOption, multiselect: multiselect, selected: selectedOptions, setOptions: setOptions, onSelect: handleSelect }, children)));
});
Listbox.displayName = 'Listbox';

function isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
var ListboxOption = React.forwardRef(function (_a, ref) {
    var _b;
    var _c, _d;
    var propId = _a.id, className = _a.className, _e = _a.as, Component = _e === void 0 ? 'li' : _e, children = _a.children, value = _a.value, disabled = _a.disabled, selectedProp = _a.selected, _f = _a.activeClass, activeClass = _f === void 0 ? 'ListboxOption--active' : _f, onClick = _a.onClick, props = tslib.__rest(_a, ["id", "className", "as", "children", "value", "disabled", "selected", "activeClass", "onClick"]);
    var _g = useListboxContext(), active = _g.active, selected = _g.selected, setOptions = _g.setOptions, onSelect = _g.onSelect;
    var listboxOptionRef = useSharedRef(ref);
    var _h = tslib.__read(propId ? [propId] : nextId.useId(1, 'listbox-option'), 1), id = _h[0];
    var isActive = (active === null || active === void 0 ? void 0 : active.element) === listboxOptionRef.current;
    var isSelected = typeof selectedProp === 'boolean'
        ? selectedProp
        : selected !== null &&
            !!selected.find(function (option) { return option.element === listboxOptionRef.current; });
    var optionValue = typeof value !== 'undefined'
        ? value
        : ((_d = (_c = listboxOptionRef.current) === null || _c === void 0 ? void 0 : _c.textContent) !== null && _d !== void 0 ? _d : undefined);
    React.useEffect(function () {
        var element = listboxOptionRef.current;
        setOptions(function (options) {
            var e_1, _a;
            // istanbul ignore next
            if (!element)
                return options;
            var option = { element: element, value: optionValue };
            // Elements are frequently appended, so check to see if the newly rendered
            // element follows the last element first before any other checks
            if (!options.length ||
                isElementPreceding(options[options.length - 1].element, option.element)) {
                return tslib.__spreadArray(tslib.__spreadArray([], tslib.__read(options), false), [option], false);
            }
            try {
                for (var options_1 = tslib.__values(options), options_1_1 = options_1.next(); !options_1_1.done; options_1_1 = options_1.next()) {
                    var opt = options_1_1.value;
                    if (isElementPreceding(element, opt.element)) {
                        var index = options.indexOf(opt);
                        return tslib.__spreadArray(tslib.__spreadArray(tslib.__spreadArray([], tslib.__read(options.slice(0, index)), false), [
                            option
                        ], false), tslib.__read(options.slice(index)), false);
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (options_1_1 && !options_1_1.done && (_a = options_1.return)) _a.call(options_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
            // istanbul ignore next
            // this should never happen, but just in case fall back to options
            return options;
        });
        return function () {
            setOptions(function (opts) { return opts.filter(function (opt) { return opt.element !== element; }); });
        };
    }, [optionValue]);
    var handleClick = React.useCallback(function (event) {
        if (disabled) {
            return;
        }
        onSelect({ element: listboxOptionRef.current, value: optionValue });
        onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }, [optionValue, onSelect, onClick, disabled]);
    return (React__default["default"].createElement(Component, tslib.__assign({ id: id, className: classNames__default["default"](className, (_b = {},
            _b[activeClass] = isActive,
            _b)), role: "option", ref: listboxOptionRef, "aria-disabled": typeof disabled === 'boolean' ? disabled : undefined, "aria-selected": isSelected, onClick: handleClick }, props), children));
});
ListboxOption.displayName = 'ListboxOption';

var ListboxGroup = React.forwardRef(function (_a, ref) {
    var _b = _a.as, Component = _b === void 0 ? 'ul' : _b, children = _a.children, propId = _a.id, label = _a.label, groupLabelProps = _a.groupLabelProps, props = tslib.__rest(_a, ["as", "children", "id", "label", "groupLabelProps"]);
    var _c = tslib.__read(propId ? [propId] : nextId.useId(1, 'listbox-group-label'), 1), id = _c[0];
    return (React__default["default"].createElement(Component, tslib.__assign({ role: "group", ref: ref, "aria-labelledby": id }, props),
        React__default["default"].createElement("li", tslib.__assign({ role: "presentation", id: id }, groupLabelProps), label),
        children));
});
ListboxGroup.displayName = 'ListboxGroup';

/* istanbul ignore next */
var ComboboxContext = React.createContext({
    autocomplete: 'manual',
    inputValue: undefined,
    formValues: [],
    selectedValues: [],
    removeOptionLabels: [],
    setRemoveOptionLabels: function () { return null; },
    matches: true,
    matchingOptions: new Map(),
    setMatchingOptions: function () { return null; },
    setFormValues: function () { return null; }
});
function ComboboxProvider(_a) {
    var autocomplete = _a.autocomplete, inputValue = _a.inputValue, formValues = _a.formValues, selectedValues = _a.selectedValues, removeOptionLabels = _a.removeOptionLabels, setRemoveOptionLabels = _a.setRemoveOptionLabels, matches = _a.matches, matchingOptions = _a.matchingOptions, setMatchingOptions = _a.setMatchingOptions, setFormValues = _a.setFormValues, children = _a.children;
    var Provider = ComboboxContext.Provider;
    var contextValue = React.useMemo(function () { return ({
        autocomplete: autocomplete,
        inputValue: inputValue,
        formValues: formValues,
        selectedValues: selectedValues,
        removeOptionLabels: removeOptionLabels,
        setRemoveOptionLabels: setRemoveOptionLabels,
        matches: typeof matches === 'function' && !!inputValue
            ? function (value) { return matches(inputValue, value); }
            : true,
        matchingOptions: matchingOptions,
        setMatchingOptions: setMatchingOptions,
        setFormValues: setFormValues
    }); }, [
        autocomplete,
        inputValue,
        formValues,
        selectedValues,
        removeOptionLabels,
        setRemoveOptionLabels,
        matches,
        matchingOptions,
        setMatchingOptions,
        setFormValues
    ]);
    return React__default["default"].createElement(Provider, { value: contextValue }, children);
}
function useComboboxContext() {
    return React.useContext(ComboboxContext);
}

/**
 * When a component needs to track intersection via a ref, useIntersectionRef
 * will return a ref object containing the results from IntersectionObserver
 * for the current intersection entry.
 *
 * @example
 * const elementRef = useRef<HTMLElement>()
 * const intersectionRef = useIntersectionRef<HTMLElement>(elementRef)
 * return <span ref={elementRef}>...</span>
 */
function useIntersectionRef(elementOrRef, intersectionObserverOptions) {
    if (intersectionObserverOptions === void 0) { intersectionObserverOptions = {
        root: null,
        threshold: 1.0
    }; }
    var intersectionRef = React.useRef(null);
    var element = resolveElement(elementOrRef);
    React.useEffect(function () {
        // istanbul ignore else
        if ('IntersectionObserver' in globalThis &&
            typeof IntersectionObserver === 'function') {
            if (typeof element === 'undefined' || element === null) {
                return;
            }
            if (!(element instanceof HTMLElement)) {
                console.warn('An element or ref was provided to useIntersectionRef that was not an HTMLElement.');
                return;
            }
            var handleIntersection = function (_a) {
                var _b = tslib.__read(_a, 1), entry = _b[0];
                intersectionRef.current = entry;
            };
            var observer_1 = new IntersectionObserver(handleIntersection, intersectionObserverOptions);
            observer_1.observe(element);
            return function () {
                observer_1.disconnect();
            };
        }
    }, [element]);
    return intersectionRef;
}

var ComboboxMatch = function (_a) {
    var text = _a.children;
    var inputValue = useComboboxContext().inputValue;
    if (!text) {
        return React__default["default"].createElement("span", null);
    }
    if (!(inputValue === null || inputValue === void 0 ? void 0 : inputValue.length)) {
        return React__default["default"].createElement("span", null, text);
    }
    var matchStart = text.toLowerCase().indexOf(inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase());
    if (matchStart === -1) {
        return React__default["default"].createElement("span", null, text);
    }
    var matchLength = inputValue.length;
    var matchBefore = text.substring(0, matchStart);
    var match = text.substring(matchStart, matchLength + matchStart);
    var matchAfter = text.substring(matchStart + matchLength);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("span", null, matchBefore),
        React__default["default"].createElement("em", { className: "ComboboxOption__match" }, match),
        React__default["default"].createElement("span", null, matchAfter)));
};
var ComboboxOption = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, disabled = _a.disabled, propId = _a.id, description = _a.description, propValue = _a.value, formValue = _a.formValue, removeOptionLabel = _a.removeOptionLabel, props = tslib.__rest(_a, ["className", "children", "disabled", "id", "description", "value", "formValue", "removeOptionLabel"]);
    var _b = tslib.__read(propId ? [propId] : nextId.useId(1, 'combobox-option'), 1), id = _b[0];
    var _c = useListboxContext(), selected = _c.selected, active = _c.active;
    var _d = useComboboxContext(), selectedValues = _d.selectedValues, setRemoveOptionLabels = _d.setRemoveOptionLabels, matches = _d.matches, setMatchingOptions = _d.setMatchingOptions, setFormValues = _d.setFormValues;
    var comboboxOptionRef = useSharedRef(ref);
    var intersectionRef = useIntersectionRef(comboboxOptionRef, {
        root: null,
        threshold: 1.0
    });
    var isActive = !!(active === null || active === void 0 ? void 0 : active.element) && active.element === comboboxOptionRef.current;
    var isSelected = !!(selected &&
        selected.findIndex(function (_a) {
            var element = _a.element;
            return element === comboboxOptionRef.current;
        }) !== -1);
    var isMatching = (typeof matches === 'boolean' && matches) ||
        (typeof matches === 'function' && matches(children));
    // istanbul ignore next
    React.useLayoutEffect(function () {
        var intersectionEntry = intersectionRef.current;
        if (!intersectionEntry || !isActive || !comboboxOptionRef.current) {
            return;
        }
        var rect = comboboxOptionRef.current.getBoundingClientRect();
        var isInViewport = rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= window.innerHeight &&
            rect.right <= window.innerWidth;
        if (!isInViewport || !intersectionEntry.isIntersecting) {
            comboboxOptionRef.current.scrollIntoView({
                inline: 'nearest',
                block: rect.top <= 0 ? 'end' : 'nearest'
            });
        }
    }, [isActive]);
    React.useEffect(function () {
        var _a, _b;
        var comboboxValue = typeof propValue !== 'undefined'
            ? propValue
            : ((_b = (_a = comboboxOptionRef.current) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : undefined);
        var value = typeof formValue === 'undefined' ? comboboxValue : formValue;
        setFormValues(function (prev) {
            var formValues = prev.filter(function (fv) { return fv !== value; });
            if (selectedValues.includes(comboboxValue)) {
                formValues.push(value);
            }
            return formValues;
        });
        setRemoveOptionLabels(function (prev) {
            if (!removeOptionLabel) {
                return prev;
            }
            return selectedValues.map(function (value, index) {
                return value === comboboxValue ? removeOptionLabel : prev[index];
            });
        });
    }, [selectedValues, formValue]);
    React.useEffect(function () {
        var _a, _b;
        if (isMatching) {
            var comboboxValue_1 = typeof propValue !== 'undefined'
                ? propValue
                : ((_b = (_a = comboboxOptionRef.current) === null || _a === void 0 ? void 0 : _a.textContent) !== null && _b !== void 0 ? _b : undefined);
            setMatchingOptions(function (options) {
                if (!comboboxOptionRef.current)
                    return options;
                return new Map(options.set(comboboxOptionRef.current, {
                    value: comboboxValue_1,
                    displayValue: children,
                    selected: isSelected
                }));
            });
        }
        return function () {
            setMatchingOptions(function (options) {
                options.forEach(function (_value, element) {
                    // istanbul ignore else
                    if (!element.isConnected) {
                        options.delete(element);
                    }
                });
                return new Map(options);
            });
        };
    }, [isMatching, isSelected]);
    if (!isMatching) {
        return null;
    }
    return (React__default["default"].createElement(ListboxOption, tslib.__assign({ as: "li", className: classNames__default["default"]('ComboboxOption', className, {
            'ComboboxOption--disabled': disabled
        }), activeClass: "ComboboxOption--active", 
        // @ts-expect-error use HTMLElement even though the underlying element is an li element
        ref: comboboxOptionRef, disabled: disabled, id: id, value: propValue }, props),
        React__default["default"].createElement("span", null,
            React__default["default"].createElement(ComboboxMatch, null, children),
            description && (React__default["default"].createElement("div", { className: "ComboboxOption__description" }, description))),
        isSelected ? React__default["default"].createElement(Icon, { type: "check-solid" }) : null));
});
ComboboxOption.displayName = 'ComboboxOption';

var ComboboxPill = React.forwardRef(function (_a, ref) {
    var value = _a.value, removeOptionLabel = _a.removeOptionLabel, _b = _a.disabled, disabled = _b === void 0 ? false : _b, rest = tslib.__rest(_a, ["value", "removeOptionLabel", "disabled"]);
    var commonProps = {
        ref: ref,
        'aria-label': removeOptionLabel ? removeOptionLabel : "remove ".concat(value),
        className: 'ComboboxPill',
        tabIndex: -1
    };
    return !disabled ? (React__default["default"].createElement(TagButton, tslib.__assign({ label: value || '', value: "", icon: "close" }, commonProps, rest))) : (React__default["default"].createElement(Button, tslib.__assign({ variant: "tag", disabled: disabled }, commonProps, rest), value));
});
ComboboxPill.displayName = 'ComboboxPill';

// Event Keys
var _a$1 = tslib.__read([
    'Enter',
    'Escape',
    'Home',
    'End',
    'Backspace',
    'Delete'
], 6), Enter = _a$1[0], Escape = _a$1[1], Home = _a$1[2], End = _a$1[3], Backspace = _a$1[4], Delete = _a$1[5];
var _b = tslib.__read([
    'ArrowDown',
    'ArrowUp',
    'ArrowLeft',
    'ArrowRight'
], 4), ArrowDown$1 = _b[0], ArrowUp$1 = _b[1], ArrowLeft = _b[2], ArrowRight = _b[3];
var PillKeys = [Backspace, Delete, ArrowLeft, ArrowRight];
var defaultAutoCompleteMatches = function (inputValue, value) {
    // istanbul ignore if
    if (!value) {
        return true;
    }
    return value.toLowerCase().includes(inputValue.toLowerCase());
};
var ComboboxNoResults = function (_a) {
    var children = _a.children;
    return (React__default["default"].createElement("div", { className: "ComboboxListbox__empty", role: "alert", "aria-live": "polite" }, children || 'No results found.'));
};
var Combobox = React.forwardRef(function (_a, ref) {
    var propId = _a.id, className = _a.className, label = _a.label, children = _a.children, _b = _a.options, options = _b === void 0 ? [] : _b, propValue = _a.value, defaultValue = _a.defaultValue, propInputValue = _a.inputValue, defaultInputValue = _a.defaultInputValue, _c = _a.multiselect, multiselect = _c === void 0 ? false : _c, _d = _a.requiredText, requiredText = _d === void 0 ? 'Required' : _d, error = _a.error, _e = _a.autocomplete, autocomplete = _e === void 0 ? 'manual' : _e, onSelectionChange = _a.onSelectionChange, onActiveChange = _a.onActiveChange, onChange = _a.onChange, onKeyDown = _a.onKeyDown, onFocus = _a.onFocus, onBlur = _a.onBlur, name = _a.name, renderNoResults = _a.renderNoResults, portal = _a.portal, _f = _a.inputRef, propInputRef = _f === void 0 ? null : _f, description = _a.description, ariaDescribedby = _a["aria-describedby"], _g = _a.disabled, disabled = _g === void 0 ? false : _g, props = tslib.__rest(_a, ["id", "className", "label", "children", "options", "value", "defaultValue", "inputValue", "defaultInputValue", "multiselect", "requiredText", "error", "autocomplete", "onSelectionChange", "onActiveChange", "onChange", "onKeyDown", "onFocus", "onBlur", "name", "renderNoResults", "portal", "inputRef", "description", 'aria-describedby', "disabled"]);
    var _h = tslib.__read(React.useState(new Map()), 2), matchingOptions = _h[0], setMatchingOptions = _h[1];
    var _j = tslib.__read(React.useState(function () {
        var value = defaultValue || propValue;
        var inputVal = defaultInputValue || propInputValue;
        return (Array.isArray(value) ? inputVal : value) || '';
    }), 2), inputValue = _j[0], setInputValue = _j[1];
    var _k = tslib.__read(React.useState(function () {
        var value = defaultValue || propValue;
        if (!value) {
            return [];
        }
        return Array.isArray(value) ? value : [value];
    }), 2), selectedValues = _k[0], setSelectedValues = _k[1];
    var _l = tslib.__read(React.useState([]), 2), removeOptionLabels = _l[0], setRemoveOptionLabels = _l[1];
    var _m = tslib.__read(React.useState([]), 2), formValues = _m[0], setFormValues = _m[1];
    var _o = tslib.__read(React.useState(false), 2), open = _o[0], setOpen = _o[1];
    var _p = tslib.__read(React.useState(null), 2), activeDescendant = _p[0], setActiveDescendant = _p[1];
    var _q = tslib.__read(propId ? [propId] : nextId.useId(1, 'combobox'), 1), id = _q[0];
    var comboboxRef = useSharedRef(ref);
    var inputRef = useSharedRef(propInputRef);
    var listboxRef = React.useRef(null);
    var pillsRef = React.useRef([]);
    var isControlled = typeof propValue !== 'undefined' &&
        (multiselect ? typeof propInputValue !== 'undefined' : true);
    var isRequired = !!props.required;
    var isAutoComplete = autocomplete !== 'none';
    var hasError = !!error;
    var comboboxOptions = children ||
        options.map(function (option, index) { return (React__default["default"].createElement(ComboboxOption, { key: option.key || index, id: "".concat(id, "-option-").concat(index + 1), description: option.description, value: option.value, formValue: option.formValue, removeOptionLabel: option.removeOptionLabel }, option.label)); });
    var triggerListboxKeyDown = React.useCallback(function (key) {
        var _a;
        (_a = listboxRef.current) === null || _a === void 0 ? void 0 : _a.dispatchEvent(new KeyboardEvent('keydown', {
            key: key,
            bubbles: true,
            cancelable: true
        }));
    }, [listboxRef]);
    React.useEffect(function () {
        if (!isAutoComplete) {
            return;
        }
        if (!open &&
            !multiselect &&
            selectedValues.length &&
            !selectedValues.includes(inputValue)) {
            setInputValue(selectedValues[selectedValues.length - 1] || '');
        }
        if (!open) {
            setActiveDescendant(null);
        }
        if (open && autocomplete === 'automatic' && !selectedValues.length) {
            // Fire a Home keydown event on listbox to ensure the first item is selected
            triggerListboxKeyDown(Home);
        }
    }, [open, multiselect, autocomplete, selectedValues]);
    React.useEffect(function () {
        var lastSelectedValue = selectedValues.length !== 0
            ? selectedValues[selectedValues.length - 1]
            : undefined;
        var _a = tslib.__read(Array.from(matchingOptions.entries()).find(function (_a) {
            var _b = tslib.__read(_a, 2), value = _b[1].value;
            return value === lastSelectedValue;
        }) || [], 2), element = _a[0], option = _a[1];
        if (autocomplete === 'manual') {
            // In multiselect, the listbox manages its own active option via
            // keyboard navigation. When the last-selected value no longer
            // matches any option (e.g. after deselecting the only selected
            // option), preserve the existing active descendant so the next
            // Enter keypress can re-toggle the highlighted option.
            if (multiselect &&
                !element &&
                activeDescendant &&
                matchingOptions.has(activeDescendant.element)) {
                return;
            }
            setActiveDescendant(!element ? null : tslib.__assign({ element: element }, option));
        }
        else if (autocomplete === 'automatic' &&
            matchingOptions.size &&
            !selectedValues.length) {
            // Fire a home keydown event on listbox to ensure the first item is selected
            requestAnimationFrame(function () {
                triggerListboxKeyDown(Home);
            });
        }
    }, [selectedValues, matchingOptions]);
    var handleFocus = React.useCallback(function (event) {
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(event);
        // istanbul ignore else
        if (!event.defaultPrevented) {
            setOpen(true);
            if (selectedValues.length &&
                selectedValues.includes(inputValue) &&
                isAutoComplete) {
                setInputValue('');
            }
        }
    }, [onFocus, inputValue, selectedValues]);
    var handleInputClick = React.useCallback(function (event) {
        var _a;
        if (!disabled) {
            setOpen(true);
        }
        if (selectedValues.length &&
            selectedValues.includes(inputValue) &&
            isAutoComplete) {
            setInputValue('');
        }
        if (event.target !== inputRef.current) {
            // ensure focus is set on the input field
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, [disabled, inputValue, selectedValues]);
    var handleComboboxOptionMouseDown = React.useCallback(function (event) {
        // prevent blur from triggering when activating combobox options
        event.preventDefault();
    }, []);
    var handleComboboxOptionClick = React.useCallback(function () {
        var _a;
        // maintain focus on the input
        if (inputRef.current !== document.activeElement) {
            (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    }, []);
    var handleBlur = React.useCallback(function (event) {
        var _a;
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
        setOpen(false);
        if (autocomplete === 'automatic' && activeDescendant) {
            var activeValue_1 = ((_a = activeDescendant.value) === null || _a === void 0 ? void 0 : _a.toString()) ||
                /* istanbul ignore next: default value */ '';
            setInputValue(activeValue_1);
            if (!multiselect) {
                setSelectedValues([activeValue_1]);
                onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
                    target: activeDescendant.element,
                    value: activeValue_1,
                    previousValue: selectedValues[0]
                });
            }
            else {
                var activeValueIndex = selectedValues.indexOf(activeValue_1);
                var newSelectedValues = selectedValues.filter(function (v) { return v !== activeValue_1; });
                if (activeValueIndex === -1) {
                    newSelectedValues.push(activeValue_1);
                }
                setSelectedValues(newSelectedValues);
                onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
                    target: activeDescendant.element,
                    value: newSelectedValues,
                    previousValue: selectedValues
                });
            }
        }
    }, [
        autocomplete,
        activeDescendant,
        onBlur,
        selectedValues,
        onSelectionChange
    ]);
    var handleKeyDown = React.useCallback(function (event) {
        var _a;
        onKeyDown === null || onKeyDown === void 0 ? void 0 : onKeyDown(event);
        var enterKeypress = event.key === Enter;
        var escKeypress = event.key === Escape;
        var deleteKeypress = event.key === Delete;
        var backspaceKeypress = event.key === Backspace;
        var listboxArrowKeypress = [ArrowUp$1, ArrowDown$1].includes(event.key);
        if (
        // prevent the page from scrolling and allow start/end option activation
        [Home, End].includes(event.key) ||
            // prevent combobox from submitting any forms when the listbox is expanded
            (enterKeypress && open)) {
            event.preventDefault();
        }
        if (escKeypress) {
            setOpen(false);
            return;
        }
        // Selection should not open the listbox or be
        // forwarded to the listbox component when closed
        if (enterKeypress && !open) {
            return;
        }
        setOpen(true);
        if (inputValue === '' &&
            (backspaceKeypress || deleteKeypress || event.key === ArrowLeft) &&
            pillsRef.current.length !== 0) {
            (_a = pillsRef.current[pillsRef.current.length - 1]) === null || _a === void 0 ? void 0 : _a.focus();
        }
        if (!open &&
            listboxArrowKeypress &&
            selectedValues.length &&
            isAutoComplete) {
            // If the user opens the combobox again with a selected value
            // just clear out the field to restore filtering capabilities
            setInputValue('');
        }
        // Space should not trigger selection since the user could be typing
        // a value for autocompletion. Additionally when not open and there's
        // an active descendent we do not want to forward keydown events.
        if (event.key === ' ' ||
            (!open && activeDescendant) ||
            (enterKeypress && !activeDescendant)) {
            return;
        }
        // forward input events to listbox
        triggerListboxKeyDown(event.key);
        // Close combobox with keyboard selections
        if (enterKeypress && activeDescendant && !multiselect) {
            setOpen(false);
        }
    }, [
        onKeyDown,
        isAutoComplete,
        open,
        multiselect,
        selectedValues,
        activeDescendant
    ]);
    React.useEffect(function () {
        if (isControlled) {
            if (!multiselect) {
                setInputValue(propValue || '');
            }
            else {
                setInputValue(propInputValue || '');
            }
        }
    }, [multiselect, propValue, propInputValue]);
    var handleChange = React.useCallback(function (event) {
        if (disabled) {
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
        // istanbul ignore else
        if (!isControlled) {
            setInputValue(event.target.value);
        }
    }, [isControlled, onChange]);
    var handleRemovePill = React.useCallback(function (target, value) {
        if (disabled) {
            return;
        }
        var newSelectedValues = selectedValues.filter(function (v) { return v !== value; });
        setSelectedValues(newSelectedValues);
        onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
            target: target,
            value: newSelectedValues,
            previousValue: selectedValues
        });
    }, [disabled, selectedValues, onSelectionChange]);
    var handlePillKeyDown = React.useCallback(function (event) {
        var _a, _b;
        if (!PillKeys.includes(event.key)) {
            return;
        }
        event.preventDefault();
        var isDelete = event.key === Delete;
        var isBackspace = event.key === Backspace;
        var isArrowLeft = event.key === ArrowLeft;
        var isArrowRight = event.key === ArrowRight;
        var focusedIndex = pillsRef.current.findIndex(function (p) { return document.activeElement === p; });
        var pillsLength = pillsRef.current.length;
        if (isDelete || isBackspace) {
            if (disabled) {
                return;
            }
            handleRemovePill(pillsRef.current[focusedIndex], selectedValues[focusedIndex]);
            var nextIndex = focusedIndex + 1;
            if (nextIndex == pillsLength) {
                (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
            else {
                pillsRef.current[nextIndex].focus();
            }
        }
        else if (isArrowLeft || isArrowRight) {
            var nextIndex = Math.max(focusedIndex + (isArrowLeft ? -1 : 1), 0);
            if (isArrowRight && nextIndex === pillsLength) {
                (_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.focus();
            }
            else {
                pillsRef.current[nextIndex].focus();
            }
        }
    }, [disabled, pillsRef, handleRemovePill]);
    var handleSelectionChange = React.useCallback(function (_a) {
        var target = _a.target, value = _a.value, previousValue = _a.previousValue;
        if (!multiselect) {
            var listboxValue = (value === null || value === void 0 ? void 0 : value.toString()) || '';
            var listboxPreviousValue = (previousValue === null || previousValue === void 0 ? void 0 : previousValue.toString()) || '';
            // istanbul ignore else
            if (!isControlled) {
                setInputValue(listboxValue);
            }
            setSelectedValues([listboxValue]);
            onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
                target: target,
                value: listboxValue,
                previousValue: listboxPreviousValue
            });
        }
        else {
            var listboxPreviousValue = previousValue;
            var listboxValue = value;
            var previousValueSet_1 = new Set(listboxPreviousValue);
            var valueSet_1 = new Set(listboxValue);
            var removedValues_1 = new Set(listboxPreviousValue.filter(function (v) { return !valueSet_1.has(v); }));
            var addedValues = listboxValue.filter(function (v) { return !previousValueSet_1.has(v); });
            var newSelectedValues = selectedValues
                .filter(function (v) { return !removedValues_1.has(v); })
                .concat(addedValues);
            // istanbul ignore else
            if (!isControlled) {
                setInputValue('');
            }
            setSelectedValues(newSelectedValues);
            onSelectionChange === null || onSelectionChange === void 0 ? void 0 : onSelectionChange({
                target: target,
                value: newSelectedValues,
                previousValue: selectedValues
            });
        }
        if (!multiselect) {
            setOpen(false);
        }
    }, [isControlled, multiselect, selectedValues, onSelectionChange]);
    var handleActiveChange = React.useCallback(function (option) {
        // istanbul ignore else
        if (option.element) {
            setActiveDescendant(option);
        }
        onActiveChange === null || onActiveChange === void 0 ? void 0 : onActiveChange(option);
    }, []);
    var NoMatchingOptions = React.useMemo(function () {
        return React__default["default"].isValidElement(renderNoResults)
            ? function () { return React__default["default"].createElement(ComboboxNoResults, null, renderNoResults); }
            : typeof renderNoResults === 'function'
                ? function () { return React__default["default"].createElement(ComboboxNoResults, null, renderNoResults()); }
                : ComboboxNoResults;
    }, [renderNoResults]);
    var noMatchingOptions = !!inputValue && !matchingOptions.size && (React__default["default"].createElement(NoMatchingOptions, null));
    var errorId = "".concat(id, "-error");
    var descriptionId = "".concat(id, "-description");
    var describedby = ariaDescribedby;
    if (description) {
        describedby = addIdRef(describedby, descriptionId);
    }
    if (error) {
        describedby = addIdRef(describedby, errorId);
    }
    var inputProps = tslib.__assign(tslib.__assign({}, props), { 'aria-describedby': describedby });
    var comboboxListbox = (
    // eslint-disable-next-line
    // @ts-expect-error
    // multiselect & value props are passed to Listbox, but TS is unable to infer that
    // it's a correct mapping from Combobox's multiselect & value props
    React__default["default"].createElement(Listbox, { className: classNames__default["default"]('Combobox__listbox', {
            'Combobox__listbox--open': open
        }), role: noMatchingOptions ? 'presentation' : 'listbox', "aria-labelledby": noMatchingOptions ? undefined : "".concat(id, "-label"), "aria-describedby": describedby, id: "".concat(id, "-listbox"), value: multiselect ? selectedValues : selectedValues[0], onMouseDown: handleComboboxOptionMouseDown, onClick: handleComboboxOptionClick, onSelectionChange: handleSelectionChange, onActiveChange: handleActiveChange, ref: listboxRef, tabIndex: noMatchingOptions ? undefined : -1, "aria-activedescendant": undefined, multiselect: multiselect, disabled: disabled },
        comboboxOptions,
        noMatchingOptions));
    return (React__default["default"].createElement("div", { id: id, className: classNames__default["default"]('Combobox', { 'Combobox--multiselect': multiselect }, className), ref: comboboxRef },
        name &&
            formValues.map(function (formValue, index) { return (React__default["default"].createElement("input", { type: "hidden", key: index, name: name, value: formValue })); }),
        React__default["default"].createElement("label", { className: classNames__default["default"]('Field__label', {
                'Field__label--is-required': isRequired,
                'Field__label--has-error': hasError
            }), id: "".concat(id, "-label"), htmlFor: "".concat(id, "-input") },
            React__default["default"].createElement("span", null, label),
            isRequired && (React__default["default"].createElement("span", { className: "Field__required-text", "aria-hidden": "true" }, requiredText))),
        description && (React__default["default"].createElement("span", { className: "Field__description", id: descriptionId }, description)),
        hasError && (React__default["default"].createElement("div", { className: "Field__error", id: errorId },
            React__default["default"].createElement(Icon, { type: "caution" }),
            error)),
        React__default["default"].createElement(TextFieldWrapper, { className: classNames__default["default"]({ 'TextFieldWrapper--error': hasError }), 
            // We're handling click here to open the listbox when the wrapping element is clicked,
            // there's already keyboard handlers to open the listbox on the input element
            onClick: handleInputClick },
            multiselect &&
                selectedValues.map(function (value, index) {
                    var refCallback = function (elem) {
                        if (elem) {
                            pillsRef.current[index] = elem;
                        }
                        else {
                            pillsRef.current.splice(index, 1);
                        }
                    };
                    var handleClick = function () {
                        return handleRemovePill(pillsRef.current[index], value);
                    };
                    return (React__default["default"].createElement(ComboboxPill, { ref: refCallback, key: value, value: value, removeOptionLabel: removeOptionLabels[index], disabled: disabled, onClick: handleClick, onKeyDown: handlePillKeyDown }));
                }),
            React__default["default"].createElement("input", tslib.__assign({ type: "text", id: "".concat(id, "-input"), ref: inputRef, value: inputValue, role: "combobox", disabled: disabled, "aria-invalid": error ? true : undefined, "aria-autocomplete": !isAutoComplete ? 'none' : 'list', "aria-controls": "".concat(id, "-listbox"), "aria-expanded": open, "aria-haspopup": "listbox", "aria-activedescendant": open && activeDescendant ? activeDescendant.element.id : undefined }, inputProps, { onChange: handleChange, onKeyDown: handleKeyDown, onFocus: handleFocus, onBlur: handleBlur })),
            React__default["default"].createElement("span", { className: "Combobox__arrow" })),
        React__default["default"].createElement(ComboboxProvider, { autocomplete: autocomplete, inputValue: inputValue, formValues: formValues, selectedValues: selectedValues, removeOptionLabels: removeOptionLabels, setRemoveOptionLabels: setRemoveOptionLabels, matches: !isAutoComplete || defaultAutoCompleteMatches, matchingOptions: matchingOptions, setMatchingOptions: setMatchingOptions, setFormValues: setFormValues }, portal && typeof document !== 'undefined'
            ? reactDom.createPortal(comboboxListbox, 
            // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
            portal instanceof HTMLElement
                ? portal
                : portal.current ||
                    // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
                    /* istanbul ignore next: default fallback value */ document.body)
            : comboboxListbox)));
});
Combobox.displayName = 'Combobox';

var ComboboxGroup = React.forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, label = _a.label, props = tslib.__rest(_a, ["className", "children", "label"]);
    var _b = useComboboxContext(), inputValue = _b.inputValue, autocomplete = _b.autocomplete, matchingOptions = _b.matchingOptions;
    var comboboxGroupRef = useSharedRef(ref);
    // istanbul ignore next
    var showGroup = React.useMemo(function () {
        if (autocomplete === 'none' || !(inputValue === null || inputValue === void 0 ? void 0 : inputValue.length)) {
            return true;
        }
        var elements = Array.from(matchingOptions.keys());
        return !!elements.find(function (element) { var _a; return (_a = comboboxGroupRef.current) === null || _a === void 0 ? void 0 : _a.contains(element); });
    }, [inputValue, autocomplete, matchingOptions]);
    return (React__default["default"].createElement(ListboxGroup, tslib.__assign({ as: "ul", className: classNames__default["default"]('ComboboxGroup', className, {
            'ComboboxGroup--hidden': !showGroup
        }), "aria-hidden": !showGroup, ref: comboboxGroupRef, label: label, groupLabelProps: { className: 'ComboboxGroup__label' } }, props), children));
});
ComboboxGroup.displayName = 'ComboboxGroup';

var PromptPopoverContent = function (_a) {
    var onClose = _a.onClose, _b = _a.applyButtonText, applyButtonText = _b === void 0 ? 'Apply' : _b, onApply = _a.onApply, _c = _a.closeButtonText, closeButtonText = _c === void 0 ? 'Close' : _c, infoText = _a.infoText, infoTextId = _a.infoTextId;
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement("span", { id: infoTextId }, infoText),
        React__default["default"].createElement(Button, { className: "Popover__apply", onClick: onApply, thin: true }, applyButtonText),
        React__default["default"].createElement(Button, { className: "Popover__close", variant: "secondary", onClick: onClose, thin: true }, closeButtonText)));
};
var Popover = React.forwardRef(function (_a, ref) {
    var propId = _a.id, _b = _a.placement, initialPlacement = _b === void 0 ? 'auto' : _b, children = _a.children, portal = _a.portal, target = _a.target, _c = _a.variant, variant = _c === void 0 ? 'custom' : _c, _d = _a.show, show = _d === void 0 ? false : _d, onClose = _a.onClose, className = _a.className, applyButtonText = _a.applyButtonText, closeButtonText = _a.closeButtonText, infoText = _a.infoText, onApply = _a.onApply, props = tslib.__rest(_a, ["id", "placement", "children", "portal", "target", "variant", "show", "onClose", "className", "applyButtonText", "closeButtonText", "infoText", "onApply"]);
    var _e = tslib.__read(propId ? [propId] : nextId.useId(1, 'popover'), 1), id = _e[0];
    var _f = tslib.__read(React.useState(null), 2), targetElement = _f[0], setTargetElement = _f[1];
    var _g = tslib.__read(React.useState(null), 2), isolator = _g[0], setIsolator = _g[1];
    var popoverRef = useSharedRef(ref);
    var _h = tslib.__read(React.useState(initialPlacement), 2), placement = _h[0], setPlacement = _h[1];
    var additionalProps = variant === 'prompt' && !props['aria-label']
        ? { 'aria-labelledby': "".concat(id, "-label") }
        : {};
    // Keep targetElement in sync with target prop
    React.useEffect(function () {
        var targetElement = target && 'current' in target ? target.current : target;
        setTargetElement(targetElement);
    }, [target]);
    React.useEffect(function () {
        return function () {
            isolator === null || isolator === void 0 ? void 0 : isolator.deactivate();
        };
    }, []);
    React.useEffect(function () {
        if (!isolator)
            return;
        if (show) {
            isolator.activate();
        }
        else {
            isolator.deactivate();
        }
        return function () {
            isolator === null || isolator === void 0 ? void 0 : isolator.deactivate();
        };
    }, [show, isolator]);
    React.useEffect(function () {
        if (popoverRef.current)
            attachIsolator();
    }, [popoverRef.current]);
    React.useEffect(function () {
        targetElement === null || targetElement === void 0 ? void 0 : targetElement.setAttribute('aria-expanded', Boolean(show).toString());
    }, [show]);
    React.useEffect(function () {
        var attrText = targetElement === null || targetElement === void 0 ? void 0 : targetElement.getAttribute('aria-controls');
        var hasPopupAttr = targetElement === null || targetElement === void 0 ? void 0 : targetElement.getAttribute('aria-haspopup');
        if (!(attrText === null || attrText === void 0 ? void 0 : attrText.includes(id)) && show) {
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.setAttribute('aria-controls', id);
        }
        if (!hasPopupAttr) {
            targetElement === null || targetElement === void 0 ? void 0 : targetElement.setAttribute('aria-haspopup', 'true');
        }
    }, [targetElement, id, show]);
    var handleClosePopover = function () {
        isolator === null || isolator === void 0 ? void 0 : isolator.deactivate();
        if (show) {
            onClose();
        }
    };
    var handleClickOutside = React.useCallback(function (e) {
        if (e.target === targetElement) {
            return;
        }
        if (show) {
            handleClosePopover();
        }
    }, [show, targetElement, handleClosePopover]);
    var attachIsolator = function () {
        if (popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current) {
            setIsolator(new AriaIsolate(popoverRef === null || popoverRef === void 0 ? void 0 : popoverRef.current));
        }
    };
    useEscapeKey({
        callback: handleClosePopover,
        active: show
    }, [show]);
    useFocusTrap(popoverRef, { disabled: !show, returnFocus: true });
    if (!show || !isBrowser()) {
        return null;
    }
    return (React__default["default"].createElement(ClickOutsideListener$1, { onClickOutside: handleClickOutside },
        React__default["default"].createElement(AnchoredOverlay, tslib.__assign({ id: id, className: classNames__default["default"]('Popover', "Popover--".concat(placement), className, {
                'Popover--hidden': !show,
                'Popover--prompt': variant === 'prompt'
            }), ref: popoverRef, role: "dialog", target: target, open: show, placement: initialPlacement, onPlacementChange: setPlacement, offset: 8, 
            // guarded by isBrowser() check
            // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
            portal: portal || (document === null || document === void 0 ? void 0 : document.body) }, additionalProps, props),
            React__default["default"].createElement("div", { className: "Popover__popoverArrow" }),
            React__default["default"].createElement("div", { className: "Popover__borderLeft" }),
            variant === 'prompt' ? (React__default["default"].createElement(PromptPopoverContent, { applyButtonText: applyButtonText, onApply: onApply, closeButtonText: closeButtonText, infoText: infoText || '', onClose: handleClosePopover, infoTextId: "".concat(id, "-label") })) : (children))));
});
Popover.displayName = 'Popover';

function Timeline(_a) {
    var className = _a.className, children = _a.children, props = tslib.__rest(_a, ["className", "children"]);
    return (React__default["default"].createElement("ol", tslib.__assign({ className: classNames__default["default"]('Timeline', className) }, props), children));
}

function TimelineItem(_a) {
    var className = _a.className, children = _a.children, icon = _a.icon, props = tslib.__rest(_a, ["className", "children", "icon"]);
    return (React__default["default"].createElement("li", tslib.__assign({ className: classNames__default["default"]('TimelineItem', className) }, props),
        React__default["default"].createElement("span", { className: "TimelineItem__separator" }, icon),
        React__default["default"].createElement("div", { className: "TimelineItem__details" }, children)));
}

var TextEllipsis = React__default["default"].forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, maxLines = _a.maxLines, as = _a.as, tooltipProps = _a.tooltipProps, hideTooltip = _a.hideTooltip, onOverflowChange = _a.onOverflowChange, props = tslib.__rest(_a, ["className", "children", "maxLines", "as", "tooltipProps", "hideTooltip", "onOverflowChange"]);
    var Element = 'div';
    var sharedRef = useSharedRef(ref);
    var _b = tslib.__read(React.useState(false), 2), hasOverflow = _b[0], setHasOverflow = _b[1];
    var showTooltip = hasOverflow && !hideTooltip;
    if (as) {
        Element = as;
    }
    else if (showTooltip) {
        props = Object.assign({
            role: 'button',
            'aria-disabled': true,
            tabIndex: 0
        }, props);
    }
    if (typeof maxLines === 'number') {
        props.style = tslib.__assign({ WebkitLineClamp: maxLines || 2 }, props.style);
    }
    React.useEffect(function () {
        var listener = function () {
            requestAnimationFrame(function () {
                var overflowElement = sharedRef.current;
                if (!overflowElement) {
                    return;
                }
                setHasOverflow(typeof maxLines === 'number'
                    ? overflowElement.clientHeight < overflowElement.scrollHeight
                    : overflowElement.clientWidth < overflowElement.scrollWidth);
            });
        };
        if (!sharedRef.current)
            return;
        var observer = new ResizeObserver(listener);
        observer.observe(sharedRef.current);
        return function () {
            observer.disconnect();
        };
    }, []);
    React.useEffect(function () {
        if (typeof onOverflowChange === 'function') {
            onOverflowChange(hasOverflow);
        }
    }, [onOverflowChange, hasOverflow]);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(Element, tslib.__assign({ className: classNames__default["default"]('TextEllipsis', className, {
                'TextEllipsis--multiline': !!maxLines
            }), ref: sharedRef }, props), children),
        showTooltip && (React__default["default"].createElement(Tooltip, tslib.__assign({ target: sharedRef, association: "none" }, tooltipProps), children))));
});
TextEllipsis.displayName = 'TextEllipsis';

var Drawer = React.forwardRef(function (_a, ref) {
    var children = _a.children, className = _a.className, position = _a.position, _b = _a.open, open = _b === void 0 ? false : _b, _c = _a.behavior, behavior = _c === void 0 ? 'modal' : _c, _d = _a.focusOptions, focusOptions = _d === void 0 ? {} : _d, portal = _a.portal, onClose = _a.onClose, style = _a.style, props = tslib.__rest(_a, ["children", "className", "position", "open", "behavior", "focusOptions", "portal", "onClose", "style"]);
    var drawerRef = useSharedRef(ref);
    var openRef = React.useRef(!!open);
    var focusInitial = focusOptions.initialFocus, focusReturn = focusOptions.returnFocus;
    var _e = tslib.__read(React.useState(!!open), 2), isTransitioning = _e[0], setIsTransitioning = _e[1];
    var isModal = behavior === 'modal';
    var handleClose = React.useCallback(function () {
        // istanbul ignore next
        if (open && typeof onClose === 'function') {
            onClose();
        }
    }, [open, onClose]);
    React.useEffect(function () {
        // jsdom does not trigger transitionend event
        // istanbul ignore next
        var transitionEndHandler = function () { return setIsTransitioning(false); };
        document.addEventListener('transitionend', transitionEndHandler);
        return function () {
            document.removeEventListener('transitionend', transitionEndHandler);
        };
    }, [setIsTransitioning]);
    React.useEffect(function () {
        if (openRef.current !== open) {
            setIsTransitioning(true);
        }
        openRef.current = open;
    }, [open, setIsTransitioning]);
    React.useEffect(function () {
        if (!isModal || !drawerRef.current) {
            return;
        }
        var isolator = new AriaIsolate(drawerRef.current);
        if (open) {
            isolator.activate();
        }
        else {
            isolator.deactivate();
        }
        return function () {
            isolator.deactivate();
        };
    }, [isModal, open]);
    useEscapeKey({ callback: handleClose, active: open, defaultPrevented: true }, [onClose]);
    // istanbul ignore next
    if (!isBrowser()) {
        return null;
    }
    useFocusTrap(drawerRef, {
        disabled: !isModal || !open,
        initialFocusElement: focusInitial || drawerRef,
        returnFocus: true,
        returnFocusElement: focusReturn
    });
    var portalElement = resolveElement(portal);
    return reactDom.createPortal(React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(ClickOutsideListener$1, { onClickOutside: handleClose, mouseEvent: open ? undefined : false, touchEvent: open ? undefined : false, target: drawerRef },
            React__default["default"].createElement("div", tslib.__assign({ ref: drawerRef, className: classNames__default["default"](className, 'Drawer', {
                    'Drawer--open': !!open,
                    'Drawer--top': position === 'top',
                    'Drawer--bottom': position === 'bottom',
                    'Drawer--left': position === 'left',
                    'Drawer--right': position === 'right'
                }), "aria-hidden": !open || undefined, style: tslib.__assign({ visibility: !open && !isTransitioning ? 'hidden' : undefined }, style), tabIndex: open ? -1 : undefined }, props), children)),
        React__default["default"].createElement(Scrim, { show: !!open && !!isModal })), portalElement ||
        (
        // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
        document === null || document === void 0 ? void 0 : document.body));
});
Drawer.displayName = 'Drawer';

var BottomSheet = React.forwardRef(function (_a, ref) {
    var label = _a.label, children = _a.children, className = _a.className, _b = _a.closeButtonText, closeButtonText = _b === void 0 ? 'Close' : _b, _c = _a.open, open = _c === void 0 ? false : _c, onClose = _a.onClose, focusOptions = _a.focusOptions, props = tslib.__rest(_a, ["label", "children", "className", "closeButtonText", "open", "onClose", "focusOptions"]);
    var bottomSheetRef = useSharedRef(ref);
    var _d = tslib.__read(nextId.useId(1, 'bottom-sheet-label'), 1), labelId = _d[0];
    var handleClose = React.useCallback(function () {
        // istanbul ignore else
        if (typeof onClose === 'function') {
            onClose();
        }
    }, [onClose]);
    return (React__default["default"].createElement(Drawer, tslib.__assign({ open: open, onClose: handleClose, focusOptions: tslib.__assign({ initialFocus: bottomSheetRef }, focusOptions) }, props, { behavior: "modal", position: "bottom" }),
        React__default["default"].createElement("div", { ref: bottomSheetRef, className: classNames__default["default"]('BottomSheet', className), tabIndex: -1, role: "dialog", "aria-labelledby": labelId },
            React__default["default"].createElement("div", { className: "BottomSheet__header" },
                React__default["default"].createElement("div", { id: labelId, className: "BottomSheet__title" }, label),
                React__default["default"].createElement(IconButton, { icon: "close", label: closeButtonText, "aria-label": "".concat(closeButtonText), onClick: handleClose, tooltipProps: {
                        show: false,
                        association: 'none'
                    } })),
            React__default["default"].createElement("div", { className: "BottomSheet__contents" }, children))));
});
BottomSheet.displayName = 'BottomSheet';

var FieldGroup = React.forwardRef(function (_a, ref) {
    var label = _a.label, description = _a.description, error = _a.error, children = _a.children, className = _a.className, propId = _a.id, props = tslib.__rest(_a, ["label", "description", "error", "children", "className", "id"]);
    var _b = tslib.__read(propId ? [propId] : nextId.useId(1, 'fieldgroup'), 1), id = _b[0];
    var descriptionId = "".concat(id, "-description");
    var errorId = "".concat(id, "-error");
    var ariaDescribedbyId = '';
    if (description) {
        ariaDescribedbyId = addIdRef(ariaDescribedbyId, descriptionId);
    }
    if (error) {
        ariaDescribedbyId = addIdRef(ariaDescribedbyId, errorId);
    }
    return (React__default["default"].createElement("div", tslib.__assign({ role: "group", className: classNames__default["default"]('FieldGroup', className), ref: ref }, props, { "aria-labelledby": "".concat(id, "-label"), "aria-describedby": ariaDescribedbyId || undefined }),
        React__default["default"].createElement("label", { id: "".concat(id, "-label"), className: "Field__label" }, label),
        description && (React__default["default"].createElement("div", { id: descriptionId, className: "Field__description" }, description)),
        error && (React__default["default"].createElement("div", { className: "Field__error", id: errorId },
            React__default["default"].createElement(Icon, { type: "caution" }),
            error)),
        children));
});
FieldGroup.displayName = 'FieldGroup';

var SectionHeader = React.forwardRef(function (_a, ref) {
    var className = _a.className, heading = _a.heading, description = _a.description, children = _a.children, otherProps = tslib.__rest(_a, ["className", "heading", "description", "children"]);
    if (typeof heading === 'string') {
        heading = React__default["default"].createElement("h2", null, heading);
    }
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('SectionHeader', className), ref: ref }, otherProps),
        React__default["default"].createElement("div", { className: "SectionHeader__content" },
            heading,
            description && (React__default["default"].createElement("p", { className: "SectionHeader__description" }, description)),
            children && React__default["default"].createElement("div", { className: "SectionHeader__actions" }, children))));
});
SectionHeader.displayName = 'SectionHeader';

var PageHeader = React.forwardRef(function (_a, ref) {
    var className = _a.className, heading = _a.heading, overline = _a.overline, description = _a.description, children = _a.children, otherProps = tslib.__rest(_a, ["className", "heading", "overline", "description", "children"]);
    if (typeof heading === 'string') {
        heading = React__default["default"].createElement("h1", null, heading);
    }
    return (React__default["default"].createElement("div", tslib.__assign({ className: classNames__default["default"]('PageHeader', className), ref: ref }, otherProps),
        overline && React__default["default"].createElement("div", { className: "PageHeader__overline" }, overline),
        React__default["default"].createElement(SectionHeader, { heading: heading, description: description }, children)));
});
PageHeader.displayName = 'PageHeader';

var EmptyState = React.forwardRef(function (_a, ref) {
    var className = _a.className, heading = _a.heading, description = _a.description, primaryActions = _a.primaryActions, secondaryActions = _a.secondaryActions, props = tslib.__rest(_a, ["className", "heading", "description", "primaryActions", "secondaryActions"]);
    if (typeof heading === 'string') {
        heading = React__default["default"].createElement("h2", null, heading);
    }
    return (React__default["default"].createElement("div", tslib.__assign({ ref: ref, className: classNames__default["default"]('EmptyState', className) }, props),
        heading,
        React__default["default"].createElement("p", null, description),
        primaryActions && (React__default["default"].createElement("div", { className: "EmptyState__primary" }, primaryActions)),
        secondaryActions && (React__default["default"].createElement("div", { className: "EmptyState__secondary" }, secondaryActions))));
});
EmptyState.displayName = 'EmptyState';

/* istanbul ignore next */
var ActionListContext = React.createContext({
    role: null,
    selectionType: null,
    onAction: function () { return null; }
});
function ActionListProvider(_a) {
    var role = _a.role, selectionType = _a.selectionType, onAction = _a.onAction, children = _a.children;
    var Provider = ActionListContext.Provider;
    var contextValue = React.useMemo(function () { return ({
        role: role,
        selectionType: selectionType,
        onAction: onAction
    }); }, [role, selectionType, onAction]);
    return React__default["default"].createElement(Provider, { value: contextValue }, children);
}
function useActionListContext() {
    return React.useContext(ActionListContext);
}

/**
 * Get an element's accessible name by its aria-label or text content
 */
function getAccessibleLabel(element) {
    var _a;
    return (
    // We're explicitly ignoring that we _could_ use aria-labelledby here
    // because of the additional complexity that is needed in order to calculate
    // the accessible name of an aria-labelled by idref. We're reserving that behavior
    // for future implementation if it is determined to be needed.
    element.getAttribute('aria-label') || ((_a = element.textContent) === null || _a === void 0 ? void 0 : _a.trim()) || '');
}
/**
 * Gets the active element based on the root element passed in
 */
function getActiveElement(root) {
    var activeElement;
    if (document.activeElement === root &&
        root.hasAttribute('aria-activedescendant')) {
        activeElement = document.getElementById(
        // Validating attribute above with "hasAttribute"
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        root.getAttribute('aria-activedescendant'));
    }
    else {
        activeElement = document.activeElement;
    }
    return root.contains(activeElement) ? activeElement : null;
}
/**
 * A hook that provides mnemonic navigation for keyboard users.
 *
 * Mnemonics allow users to quickly navigate to elements by typing the first
 * letter of the element's text content. Pressing the same letter repeatedly
 * cycles through all matching elements.
 */
function useMnemonics(_a) {
    var elementOrRef = _a.elementOrRef, matchingElementsSelector = _a.matchingElementsSelector, onMatch = _a.onMatch, _b = _a.enabled, enabled = _b === void 0 ? true : _b;
    var containerRef = React.useRef(null);
    React.useEffect(function () {
        if (elementOrRef instanceof HTMLElement) {
            containerRef.current = elementOrRef;
        }
        else if (!!elementOrRef && 'current' in elementOrRef) {
            containerRef.current = elementOrRef === null || elementOrRef === void 0 ? void 0 : elementOrRef.current;
        }
    }, [elementOrRef]);
    React.useEffect(function () {
        var listenerTarget = containerRef.current;
        if (!enabled || !listenerTarget) {
            return;
        }
        var keyboardHandler = function (event) {
            // Ignore keyboard events where a modifier key was pressed
            var hasModifier = event.ctrlKey || event.altKey || event.metaKey;
            if (hasModifier) {
                return;
            }
            // Ignore keyboard events where a non-alphanumeric character was pressed
            if (event.key.length !== 1 || !/[a-z\d]/i.test(event.key)) {
                return;
            }
            var currentContainer = containerRef.current;
            if (!currentContainer) {
                return;
            }
            // Prevent default behavior and stop propagation for mnemonic keys
            event.preventDefault();
            event.stopPropagation();
            var elements = Array.from(currentContainer.querySelectorAll(matchingElementsSelector !== null && matchingElementsSelector !== void 0 ? matchingElementsSelector : focusable__default["default"]));
            var matchingElements = elements.filter(function (element) {
                return getAccessibleLabel(element).toLowerCase()[0] ===
                    event.key.toLowerCase();
            });
            if (!matchingElements.length) {
                return;
            }
            var currentActiveElement = getActiveElement(currentContainer);
            var nextActiveElement = null;
            if (currentActiveElement) {
                nextActiveElement = matchingElements.find(function (element) {
                    // Find the next matching element that is _after_ the current active element
                    // within the collection of identified elements
                    return !!(element.compareDocumentPosition(currentActiveElement) &
                        Node.DOCUMENT_POSITION_PRECEDING);
                });
            }
            if (typeof onMatch === 'function') {
                onMatch(nextActiveElement !== null && nextActiveElement !== void 0 ? nextActiveElement : matchingElements[0]);
            }
        };
        listenerTarget.addEventListener('keydown', keyboardHandler);
        return function () { return listenerTarget.removeEventListener('keydown', keyboardHandler); };
    }, [enabled, containerRef, matchingElementsSelector, onMatch]);
    return containerRef;
}

var ActionList = React.forwardRef(function (_a, ref) {
    var _b = _a.selectionType, selectionType = _b === void 0 ? null : _b, onAction = _a.onAction, className = _a.className, children = _a.children, props = tslib.__rest(_a, ["selectionType", "onAction", "className", "children"]);
    // Listbox owns the active option. ActionList must not mirror it back down
    // as a controlled prop: the two copies then race, and a downward sync
    // carrying an already-stale value can revert a newer one and oscillate.
    // `activeOption` below is only a one-shot mnemonic request, never a
    // mirror. See cauldron#2512; cauldron#2522 tracks making `activeOption`
    // properly controlled so this constraint lives in the interface instead.
    var _c = tslib.__read(React.useState(), 2), activeOption = _c[0], setActiveOption = _c[1];
    var handleAction = React.useCallback(function (key, event) {
        if (typeof onAction === 'function') {
            onAction(key, event);
        }
    }, [onAction]);
    // A new object every match, even for the same element: this is a one-shot
    // request to Listbox rather than a mirror of its state, so re-using the
    // previous object would leave the controlled prop unchanged and the
    // request would never reach Listbox.
    var handleMnemonicMatch = React.useCallback(function (element) {
        setActiveOption({ element: element });
    }, []);
    var containerRef = useMnemonics({
        onMatch: handleMnemonicMatch,
        matchingElementsSelector: props.role === 'menu'
            ? '[role=menuitem],[role=menuitemcheckbox],[role=menuitemradio]'
            : '[role=option]'
    });
    return (React__default["default"].createElement(Listbox, tslib.__assign({ ref: function (element) {
            if (ref) {
                setRef(ref, element);
            }
            containerRef.current = element;
        }, 
        /* Listbox comes with an explicit role of "listbox", but we want to either
         * use the role from props, or default to the intrinsic role */
        // eslint-disable-next-line jsx-a11y/aria-role
        role: undefined, "aria-multiselectable": undefined, className: classNames__default["default"]('ActionList', className), activeOption: activeOption }, props, { navigation: "bound" }),
        React__default["default"].createElement(ActionListProvider, { role: props.role || 'list', onAction: handleAction, selectionType: selectionType }, children)));
});
ActionList.displayName = 'ActionList';

var ActionListItem = React.forwardRef(function (_a, ref) {
    var _b = _a.as, Component = _b === void 0 ? 'li' : _b, actionKey = _a.actionKey, className = _a.className, description = _a.description, selected = _a.selected, leadingIcon = _a.leadingIcon, trailingIcon = _a.trailingIcon, onAction = _a.onAction, children = _a.children, variant = _a.variant, props = tslib.__rest(_a, ["as", "actionKey", "className", "description", "selected", "leadingIcon", "trailingIcon", "onAction", "children", "variant"]);
    var _c = tslib.__read(nextId.useId(1, 'action-list-item'), 1), id = _c[0];
    var actionListItemRef = useSharedRef(ref);
    var labelRef = React.useRef(null);
    var active = useListboxContext().active;
    var _d = useActionListContext(), contextRole = _d.role, onActionListAction = _d.onAction, selectionType = _d.selectionType;
    var intersectionRef = useIntersectionRef(actionListItemRef, {
        root: null,
        threshold: 1.0
    });
    var isActive = !!(active === null || active === void 0 ? void 0 : active.element) && active.element === actionListItemRef.current;
    var handleAction = React.useCallback(function (event) {
        var _a, _b;
        if (event.defaultPrevented) {
            return;
        }
        if (selectionType === 'multiple') {
            // If action list is part of a multiselect menu, prevent the menu from closing
            event.preventDefault();
        }
        if (typeof onAction === 'function') {
            onAction(event);
        }
        // istanbul ignore else
        if (typeof onActionListAction === 'function') {
            onActionListAction(actionKey || ((_b = (_a = labelRef.current) === null || _a === void 0 ? void 0 : _a.textContent) === null || _b === void 0 ? void 0 : _b.trim()) || '', event);
        }
    }, [onAction, onActionListAction, selectionType, actionKey]);
    var listItemRole = undefined;
    if (contextRole === 'menu') {
        switch (selectionType) {
            case 'single':
                listItemRole = 'menuitemradio';
                break;
            case 'multiple':
                listItemRole = 'menuitemcheckbox';
                break;
            default:
                listItemRole = 'menuitem';
                break;
        }
    }
    else if (contextRole === 'listbox') {
        listItemRole = 'option';
    }
    // Keep the currently active item on screen when navigating via up/down arrow key navigation
    // istanbul ignore next
    React.useLayoutEffect(function () {
        var intersectionEntry = intersectionRef.current;
        if (!intersectionEntry || !isActive || !actionListItemRef.current) {
            return;
        }
        var rect = actionListItemRef.current.getBoundingClientRect();
        var isInViewport = rect.top >= 0 &&
            rect.left >= 0 &&
            rect.bottom <= window.innerHeight &&
            rect.right <= window.innerWidth;
        if (!isInViewport || !intersectionEntry.isIntersecting) {
            actionListItemRef.current.scrollIntoView({
                inline: 'nearest',
                block: rect.top <= 0 ? 'end' : 'nearest'
            });
        }
    }, [isActive]);
    var allowsSelection = !!selectionType;
    var isSelected = allowsSelection ? !!selected : undefined;
    return (React__default["default"].createElement(ListboxOption, tslib.__assign({ as: Component, ref: actionListItemRef, id: id, role: listItemRole, className: classNames__default["default"]('ActionListItem', className, {
            'ActionListItem--danger': variant === 'danger'
        }), activeClass: "ActionListItem--active", "aria-selected": undefined, "aria-checked": listItemRole !== 'option' ? isSelected : undefined, onClick: handleAction }, props),
        allowsSelection && (React__default["default"].createElement("span", { className: "ActionListItem__selection" },
            React__default["default"].createElement(Icon, { type: "check" }))),
        leadingIcon && (React__default["default"].createElement("span", { className: "ActionListItem__leadingIcon" },
            React__default["default"].createElement(Icon, { type: leadingIcon }))),
        React__default["default"].createElement("div", { className: "ActionListItem__label", ref: labelRef }, children),
        description && (React__default["default"].createElement("div", { className: "ActionListItem__description" }, description)),
        trailingIcon && (React__default["default"].createElement("span", { className: "ActionListItem__trailingIcon" },
            React__default["default"].createElement(Icon, { type: trailingIcon })))));
});
ActionListItem.displayName = 'ActionListItem';

var ActionListGroup = React.forwardRef(function (_a, ref) {
    var propId = _a.id, label = _a.label, children = _a.children, selectionType = _a.selectionType, onAction = _a.onAction, props = tslib.__rest(_a, ["id", "label", "children", "selectionType", "onAction"]);
    var _b = tslib.__read(propId ? [propId] : nextId.useId(1, 'actionlist-group-label'), 1), id = _b[0];
    var actionListContext = useActionListContext();
    var handleAction = React.useCallback(function (key, event) {
        // istanbul ignore else
        if (typeof onAction === 'function') {
            onAction(key, event);
        }
        // istanbul ignore else
        if (typeof actionListContext.onAction === 'function') {
            actionListContext.onAction(key, event);
        }
    }, [onAction, actionListContext.onAction]);
    var listItemRole = [
        'menu',
        'listbox'
    ].includes(actionListContext.role)
        ? 'none'
        : undefined;
    var groupRole = ['menu', 'listbox'].includes(actionListContext.role)
        ? 'group'
        : 'list';
    return (React__default["default"].createElement("li", tslib.__assign({ ref: ref, role: listItemRole }, props),
        React__default["default"].createElement(ListboxGroup, { id: id, role: groupRole, className: "ActionListGroup", label: label, as: "ul" },
            React__default["default"].createElement(ActionListProvider, tslib.__assign({}, actionListContext, { onAction: handleAction, selectionType: selectionType || actionListContext.selectionType }), children))));
});
ActionListGroup.displayName = 'ActionListGroup';

var ActionListSeparator = React.forwardRef(function (_a, ref) {
    var className = _a.className, props = tslib.__rest(_a, ["className"]);
    var contextRole = useActionListContext().role;
    // list and listbox roles only support listitem or option roles respectively
    // see https://github.com/w3c/aria/issues/1889
    var separatorRole = ['list', 'listbox'].includes(contextRole)
        ? 'presentation'
        : 'separator';
    return (React__default["default"].createElement("li", tslib.__assign({ ref: ref, className: classNames__default["default"]('ActionListSeparator', className), role: separatorRole, "aria-hidden": separatorRole === 'presentation' || undefined }, props)));
});
ActionListSeparator.displayName = 'ActionListSeparator';

var ActionListLinkItem = React.forwardRef(function (_a, ref) {
    var className = _a.className; 
    // ActionListLinkItem should not be able to be "selected"
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _a.selected; var props = tslib.__rest(_a, ["className", "selected"]);
    var contextRole = useActionListContext().role;
    var listItemRole = React.useMemo(function () {
        if (contextRole === 'menu') {
            return 'menuitem';
        }
        // istanbul ignore next
        if (contextRole && process.env.NODE_ENV !== 'production') {
            console.warn('Use of ActionListLinkItem outside of a menu is unsupported and may result in unintentional accessibility issues.');
        }
        return undefined;
    }, [contextRole]);
    return (React__default["default"].createElement(ActionListItem, tslib.__assign({ ref: ref, className: classNames__default["default"]('Link ActionListLinkItem', className), as: "a", role: listItemRole, tabIndex: listItemRole === 'menuitem' ? -1 : undefined }, props)));
});
ActionListLinkItem.displayName = 'ActionListLinkItem';

var _a = tslib.__read(['ArrowDown', 'ArrowUp'], 2), ArrowDown = _a[0], ArrowUp = _a[1];
var ActionMenuComponent = React.forwardRef(function (_a, ref) {
    var className = _a.className, style = _a.style, trigger = _a.trigger, _b = _a.placement, placement = _b === void 0 ? 'bottom-start' : _b, actionMenuList = _a.children, portal = _a.portal, _c = _a.renderInTrigger, renderInTrigger = _c === void 0 ? false : _c, props = tslib.__rest(_a, ["className", "style", "trigger", "placement", "children", "portal", "renderInTrigger"]);
    var _d = tslib.__read(React.useState(false), 2), open = _d[0], setOpen = _d[1];
    var _e = tslib.__read(React.useState('first'), 2), focusStrategy = _e[0], setFocusStrategy = _e[1];
    var triggerRef = React.useRef(null);
    var actionMenuRef = useSharedRef(ref);
    var _f = actionMenuList.props, actionListRef = _f.ref, actionListOnAction = _f.onAction;
    var actionMenuListRef = useSharedRef(actionListRef !== null && actionListRef !== void 0 ? actionListRef : null);
    var _g = tslib.__read(nextId.useId(1, 'menu-label'), 1), labelId = _g[0];
    var _h = tslib.__read(nextId.useId(1, 'menu-trigger'), 1), triggerId = _h[0];
    var _j = tslib.__read(nextId.useId(1, 'menu'), 1), menuId = _j[0];
    var handleTriggerClick = React.useCallback(function (event) {
        // istanbul ignore else
        if (!event.defaultPrevented) {
            setOpen(!open);
            setFocusStrategy('first');
        }
    }, [open]);
    var handleTriggerKeyDown = React.useCallback(function (event) {
        var _a;
        // istanbul ignore else
        if ([ArrowDown, ArrowUp].includes(event.key)) {
            // prevent page from scrolling if the user triggers the action menu
            // via an "ArrowDown" key press
            event.preventDefault();
            // allow other functions that may consume the event after
            // default is prevented to perform as normal
            event.defaultPrevented = false;
            setFocusStrategy(event.key === ArrowUp ? 'last' : 'first');
            if (open) {
                (_a = actionMenuListRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            }
            else {
                setOpen(true);
            }
        }
    }, [open]);
    var handleClickOutside = React.useCallback(function (event) {
        var _a, _b;
        if (!((_a = actionMenuRef.current) === null || _a === void 0 ? void 0 : _a.contains(event.target)) &&
            !((_b = triggerRef.current) === null || _b === void 0 ? void 0 : _b.contains(event.target))) {
            setOpen(false);
        }
    }, []);
    var handleOverlayBlur = React.useCallback(function (event) {
        var _a, _b;
        var relatedTarget = event.relatedTarget;
        if (!((_a = actionMenuRef.current) === null || _a === void 0 ? void 0 : _a.contains(relatedTarget)) &&
            !((_b = triggerRef.current) === null || _b === void 0 ? void 0 : _b.contains(relatedTarget))) {
            setOpen(false);
        }
    }, []);
    var handleAction = React.useCallback(function (key, event) {
        // istanbul ignore else
        if (!event.defaultPrevented) {
            setOpen(false);
        }
        if (typeof actionListOnAction === 'function') {
            actionListOnAction(key, event);
        }
    }, [actionListOnAction]);
    React.useEffect(function () {
        var _a, _b;
        if (open) {
            // Use double requestAnimationFrame to ensure layout is complete.
            // The first RAF schedules work for the next frame, the second ensures
            // the browser has actually completed the layout pass.
            // This prevents scroll jumping when opening ActionMenus.
            requestAnimationFrame(function () {
                requestAnimationFrame(function () {
                    var _a;
                    (_a = actionMenuListRef.current) === null || _a === void 0 ? void 0 : _a.focus();
                });
            });
        }
        else if ((_a = actionMenuListRef.current) === null || _a === void 0 ? void 0 : _a.contains(document.activeElement)) {
            (_b = triggerRef.current) === null || _b === void 0 ? void 0 : _b.focus();
        }
    }, [open]);
    // Triggers predating `labelId` render no label element. Since
    // `aria-labelledby` is not chained, naming the menu with such a trigger
    // would resolve back to the menu's own items, so it is left unnamed.
    var _k = tslib.__read(React.useState(false), 2), hasLabelElement = _k[0], setHasLabelElement = _k[1];
    React.useEffect(function () {
        setHasLabelElement(renderInTrigger ? !!document.getElementById(labelId) : false);
    }, [renderInTrigger, labelId]);
    React.useEffect(function () {
        // istanbul ignore next
        if (renderInTrigger &&
            !document.getElementById(labelId) &&
            process.env.NODE_ENV !== 'production') {
            console.warn("renderInTrigger should render id=\"".concat(labelId, "\" on the element wrapping the trigger's visible label, otherwise the trigger and the menu are named after the entire submenu."));
        }
    }, [renderInTrigger, labelId]);
    var labelledBy = triggerId;
    if (renderInTrigger) {
        labelledBy = hasLabelElement ? labelId : undefined;
    }
    var hidden = renderInTrigger && !open;
    var overlay = (React__default["default"].createElement(AnchoredOverlay, tslib.__assign({ ref: actionMenuRef, role: "presentation", className: classNames__default["default"]('ActionMenu', className), open: open, onOpenChange: setOpen, target: triggerRef, placement: placement, offset: 4, portal: portal, style: tslib.__assign({ display: !open ? 'none' : undefined }, style), "aria-hidden": hidden, onBlur: handleOverlayBlur }, props), React__default["default"].cloneElement(actionMenuList, {
        ref: actionMenuListRef,
        id: menuId,
        role: 'menu',
        onAction: handleAction,
        // aria-labelledby is not chained, so pointing at a trigger that
        // contains this menu would resolve to the menu's own items.
        'aria-labelledby': labelledBy,
        focusStrategy: focusStrategy,
        focusDisabledOptions: true,
        hidden: hidden
    })));
    // Spread onto a prerendered trigger element below, so this must stay
    // DOM-safe: no labelId.
    var baseTriggerProps = React.useMemo(function () {
        return {
            ref: triggerRef,
            id: triggerId,
            onClick: handleTriggerClick,
            onKeyDown: handleTriggerKeyDown,
            'aria-expanded': open,
            'aria-haspopup': 'menu',
            'aria-controls': menuId
        };
    }, [handleTriggerClick, handleTriggerKeyDown, open, triggerId, menuId]);
    if (renderInTrigger) {
        // istanbul ignore next
        if (portal && process.env.NODE_ENV !== 'production') {
            console.warn('renderInTrigger is incompatible with portal.');
        }
        // istanbul ignore next
        if (React__default["default"].isValidElement(trigger)) {
            console.warn('renderInTrigger requires the use of a trigger function, rather than a prerendered trigger ReactElement.');
        }
    }
    // Derived rather than mutated onto the memoized object, so that toggling
    // `renderInTrigger` off cannot leave a stale `children` behind.
    var triggerProps = renderInTrigger
        ? tslib.__assign(tslib.__assign({}, baseTriggerProps), { children: overlay, 'aria-labelledby': labelledBy }) : baseTriggerProps;
    var actionMenuTrigger = React__default["default"].isValidElement(trigger)
        ? React__default["default"].cloneElement(trigger, triggerProps)
        : trigger(tslib.__assign(tslib.__assign(tslib.__assign({}, triggerProps), { children: overlay }), (renderInTrigger && { labelId: labelId })), open);
    return (React__default["default"].createElement(React__default["default"].Fragment, null,
        React__default["default"].createElement(ClickOutsideListener$1, { onClickOutside: handleClickOutside, mouseEvent: open ? undefined : false, touchEvent: open ? undefined : false, target: triggerProps.ref }, actionMenuTrigger),
        renderInTrigger ? null : overlay));
});
ActionMenuComponent.displayName = 'ActionMenu';
var ActionMenu = ActionMenuComponent;

var TreeViewItem = function (_a) {
    var id = _a.id, textValue = _a.textValue, children = _a.children;
    var checkboxId = React.useMemo(function () { return nextId__default["default"]('tree-view-item-'); }, []);
    return (React__default["default"].createElement(reactAriaComponents.TreeItem, { id: id, textValue: textValue, className: "TreeView__item" },
        React__default["default"].createElement(reactAriaComponents.TreeItemContent, null, function (_a) {
            var selectionMode = _a.selectionMode, isSelected = _a.isSelected, isDisabled = _a.isDisabled;
            return (React__default["default"].createElement(React__default["default"].Fragment, null,
                React__default["default"].createElement(reactAriaComponents.Button, { slot: "chevron", className: "TreeView__chevron" },
                    React__default["default"].createElement(Icon, { type: "chevron-right" })),
                selectionMode !== 'none' ? (React__default["default"].createElement(Checkbox, { id: checkboxId, label: textValue, checked: isSelected, disabled: isDisabled, controlled: true, tabIndex: -1 })) : (React__default["default"].createElement(React__default["default"].Fragment, null, textValue))));
        }),
        children && children.length > 0 && (React__default["default"].createElement(reactAriaComponents.Collection, null, children.map(function (child) { return (React__default["default"].createElement(TreeViewItem, tslib.__assign({ key: child.id }, child))); })))));
};
TreeViewItem.displayName = 'TreeViewItem';

/** Every node id in the tree, flattened depth-first. */
function collectAllKeys(nodes) {
    return nodes.flatMap(function (node) { return tslib.__spreadArray([
        node.id
    ], tslib.__read((node.children ? collectAllKeys(node.children) : [])), false); });
}
/** Normalize react-aria's `Selection` ("all" | Set) into a concrete Set of keys. */
function toKeySet(selection, nodes) {
    if (selection !== 'all') {
        return new Set(selection);
    }
    // "Select all" only includes selectable (non-disabled) nodes.
    var disabled = new Set(collectDisabledKeys(nodes));
    return new Set(collectAllKeys(nodes).filter(function (key) { return !disabled.has(key); }));
}
/** Locate a node anywhere in the tree by its id. */
function findNode(nodes, key) {
    var e_1, _a;
    try {
        for (var nodes_1 = tslib.__values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
            var node = nodes_1_1.value;
            if (node.id === key) {
                return node;
            }
            if (node.children) {
                var found = findNode(node.children, key);
                if (found) {
                    return found;
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1.return)) _a.call(nodes_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return undefined;
}
/** All descendant ids of a node (not including the node itself). */
function collectDescendantKeys(node) {
    if (!node.children) {
        return [];
    }
    return node.children.flatMap(function (child) { return tslib.__spreadArray([
        child.id
    ], tslib.__read(collectDescendantKeys(child)), false); });
}
/** Ids of all disabled nodes (rendered disabled / non-selectable). */
function collectDisabledKeys(nodes) {
    return nodes.flatMap(function (node) { return tslib.__spreadArray(tslib.__spreadArray([], tslib.__read((node.disabled ? [node.id] : [])), false), tslib.__read((node.children ? collectDisabledKeys(node.children) : [])), false); });
}
/**
 * Toggle a single node, applying cascade per the options (multiple mode only):
 * - selecting + `cascadeSelect`: also selects all (non-disabled) descendants.
 * - deselecting + `cascadeDeselect`: also deselects all descendants.
 *
 * In `single` mode only the clicked node is selected (clicking it again clears
 * it); cascade does not apply.
 */
function toggleSelection(nodes, previous, key, selectionMode, _a) {
    var cascadeSelect = _a.cascadeSelect, cascadeDeselect = _a.cascadeDeselect;
    if (selectionMode === 'single') {
        var result_1 = new Set();
        if (!previous.has(key)) {
            result_1.add(key);
        }
        return result_1;
    }
    var result = new Set(previous);
    var node = findNode(nodes, key);
    var descendants = node ? collectDescendantKeys(node) : [];
    var disabled = new Set(collectDisabledKeys(nodes));
    if (!previous.has(key)) {
        result.add(key);
        if (cascadeSelect) {
            descendants.forEach(function (k) {
                if (!disabled.has(k)) {
                    result.add(k);
                }
            });
        }
    }
    else {
        result.delete(key);
        if (cascadeDeselect) {
            descendants.forEach(function (k) { return result.delete(k); });
        }
    }
    return result;
}
/**
 * Apply react-aria's proposed selection while enforcing cascade. Each key
 * react-aria added cascades to its descendants when `cascadeSelect` is set; each
 * key it removed cascades when `cascadeDeselect` is set. In non-multiple modes
 * (or with both toggles off) the proposed selection is used as-is.
 */
function applyCascade(nodes, previous, next, selectionMode, _a) {
    var cascadeSelect = _a.cascadeSelect, cascadeDeselect = _a.cascadeDeselect;
    if (selectionMode !== 'multiple' || (!cascadeSelect && !cascadeDeselect)) {
        return next;
    }
    var result = new Set(previous);
    var added = tslib.__spreadArray([], tslib.__read(next), false).filter(function (key) { return !previous.has(key); });
    var removed = tslib.__spreadArray([], tslib.__read(previous), false).filter(function (key) { return !next.has(key); });
    var disabled = new Set(collectDisabledKeys(nodes));
    added.forEach(function (key) {
        result.add(key);
        if (cascadeSelect) {
            var node = findNode(nodes, key);
            (node ? collectDescendantKeys(node) : []).forEach(function (k) {
                if (!disabled.has(k)) {
                    result.add(k);
                }
            });
        }
    });
    removed.forEach(function (key) {
        result.delete(key);
        if (cascadeDeselect) {
            var node = findNode(nodes, key);
            (node ? collectDescendantKeys(node) : []).forEach(function (k) {
                return result.delete(k);
            });
        }
    });
    return result;
}

/** Seeds the initial scroll math. Keep in step with `--tree-view-row-height`,
 *  which sizes a virtualized row — see the spacing-parity test. */
var ESTIMATED_ROW_HEIGHT = 36;
/** Keep in step with `--space-quarter` / `--space-half`, which `.TreeView` uses
 *  for its flex spacing — see the spacing-parity test. */
var ROW_GAP = 2;
var LIST_PADDING = 4;
var TreeView = React.forwardRef(function (_a, ref) {
    var items = _a.items, onAction = _a.onAction, _b = _a.selectionMode, selectionMode = _b === void 0 ? 'none' : _b, _c = _a.cascadeSelect, cascadeSelect = _c === void 0 ? false : _c, _d = _a.cascadeDeselect, cascadeDeselect = _d === void 0 ? false : _d, defaultExpandedKeys = _a.defaultExpandedKeys, _e = _a.virtualized, virtualized = _e === void 0 ? false : _e, height = _a.height, className = _a.className, style = _a.style, other = tslib.__rest(_a, ["items", "onAction", "selectionMode", "cascadeSelect", "cascadeDeselect", "defaultExpandedKeys", "virtualized", "height", "className", "style"]);
    var _f = tslib.__read(React.useState(new Set()), 2), selectedKeys = _f[0], setSelectedKeys = _f[1];
    var cascade = { cascadeSelect: cascadeSelect, cascadeDeselect: cascadeDeselect };
    // Cascade only applies to multiple selection.
    var isCascade = selectionMode === 'multiple' && (cascadeSelect || cascadeDeselect);
    // Selection driven by react-aria (row/checkbox press, keyboard). When
    // cascading, reconcile the proposed change; otherwise store react-aria's
    // selection as-is so the `'all'` sentinel (Ctrl+A) is preserved.
    var handleSelectionChange = function (selection) {
        setSelectedKeys(function (prev) {
            return isCascade
                ? applyCascade(items, toKeySet(prev, items), toKeySet(selection, items), selectionMode, cascade)
                : selection;
        });
    };
    // When `onAction` is set, react-aria treats a row press as an action rather
    // than a selection, so we toggle selection here ourselves.
    var handleAction = function (key) {
        if (selectionMode !== 'none') {
            setSelectedKeys(function (prev) {
                return toggleSelection(items, toKeySet(prev, items), key, selectionMode, cascade);
            });
        }
        onAction === null || onAction === void 0 ? void 0 : onAction(key);
    };
    // Disabled nodes are non-selectable; react-aria disables them via disabledKeys.
    var disabledKeys = React.useMemo(function () { return collectDisabledKeys(items); }, [items]);
    // Always control selection: react-aria's own state is lost if the tree
    // remounts (which toggling `virtualized` does), taking the user's checkboxes
    // with it.
    var selectionProps = selectionMode !== 'none'
        ? { selectedKeys: selectedKeys, onSelectionChange: handleSelectionChange }
        : {};
    // The `height` prop outranks `style.height`, but only when it is actually
    // set — spreading an undefined `height` would wipe the caller's own.
    var mergedStyle = virtualized && height !== undefined ? tslib.__assign(tslib.__assign({}, style), { height: height }) : style;
    var tree = (React__default["default"].createElement(reactAriaComponents.Tree, tslib.__assign({ ref: ref, className: classNames__default["default"]('TreeView', className, {
            'TreeView--virtualized': virtualized
        }), selectionMode: selectionMode, defaultExpandedKeys: defaultExpandedKeys }, (disabledKeys.length > 0 ? { disabledKeys: disabledKeys } : {}), (onAction ? { onAction: handleAction } : {}), selectionProps, other, { style: mergedStyle }), items.map(function (item) { return (React__default["default"].createElement(TreeViewItem, tslib.__assign({ key: item.id }, item))); })));
    // Rows are absolutely positioned here, so the list layout owns their spacing
    // rather than `.TreeView`'s flex `gap`/`padding`.
    if (virtualized) {
        return (React__default["default"].createElement(reactAriaComponents.Virtualizer, { layout: reactAriaComponents.ListLayout, layoutOptions: {
                estimatedRowHeight: ESTIMATED_ROW_HEIGHT,
                gap: ROW_GAP,
                padding: LIST_PADDING
            } }, tree));
    }
    return tree;
});
TreeView.displayName = 'TreeView';

var LIGHT_THEME_CLASS = 'cauldron--theme-light';
var DARK_THEME_CLASS = 'cauldron--theme-dark';
var ThemeContext = React.createContext({
    theme: 'light',
    toggleTheme: function () {
        throw new Error('ThemeContext not initialized');
    }
});
var ThemeProvider = function (_a) {
    var children = _a.children, 
    // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
    _b = _a.context, 
    // eslint-disable-next-line ssr-friendly/no-dom-globals-in-react-fc
    context = _b === void 0 ? typeof document !== 'undefined' ? document.body : undefined : _b, _c = _a.initialTheme, initialTheme = _c === void 0 ? 'light' : _c;
    var _d = tslib.__read(React.useState(initialTheme), 2), theme = _d[0], setTheme = _d[1];
    var getThemeFromContext = function () {
        return (context === null || context === void 0 ? void 0 : context.classList.contains(DARK_THEME_CLASS)) ? 'dark' : 'light';
    };
    var toggleTheme = function () {
        return setTheme(getThemeFromContext() === 'dark' ? 'light' : 'dark');
    };
    React.useEffect(function () {
        context === null || context === void 0 ? void 0 : context.classList.toggle(LIGHT_THEME_CLASS, theme === 'light');
        context === null || context === void 0 ? void 0 : context.classList.toggle(DARK_THEME_CLASS, theme === 'dark');
    }, [context, theme]);
    // Use a MutationObserver to track changes to the classes outside of the context of React
    var handleMutation = function (mutationList) {
        var e_1, _a;
        try {
            for (var mutationList_1 = tslib.__values(mutationList), mutationList_1_1 = mutationList_1.next(); !mutationList_1_1.done; mutationList_1_1 = mutationList_1.next()) {
                var mutation = mutationList_1_1.value;
                if (mutation.type === 'attributes' &&
                    mutation.attributeName === 'class') {
                    setTheme(getThemeFromContext());
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (mutationList_1_1 && !mutationList_1_1.done && (_a = mutationList_1.return)) _a.call(mutationList_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    React.useEffect(function () {
        if (!context) {
            return;
        }
        var observer = new MutationObserver(handleMutation);
        observer.observe(context, {
            childList: false,
            subtree: false,
            attributes: true
        });
        setTheme(getThemeFromContext());
        return function () { return observer.disconnect(); };
    }, [context]);
    return (React__default["default"].createElement(ThemeContext.Provider, { value: {
            theme: theme,
            toggleTheme: toggleTheme
        } }, children));
};
function useThemeContext() {
    return React.useContext(ThemeContext);
}

exports.Accordion = Accordion;
exports.AccordionContent = AccordionContent;
exports.AccordionTrigger = AccordionTrigger;
exports.ActionList = ActionList;
exports.ActionListGroup = ActionListGroup;
exports.ActionListItem = ActionListItem;
exports.ActionListLinkItem = ActionListLinkItem;
exports.ActionListSeparator = ActionListSeparator;
exports.ActionMenu = ActionMenu;
exports.Address = Address;
exports.AddressCityStateZip = AddressCityStateZip;
exports.AddressLine = AddressLine;
exports.Alert = Alert;
exports.AlertActions = AlertActions;
exports.AlertContent = AlertContent;
exports.AnchoredOverlay = AnchoredOverlay;
exports.AriaIsolate = AriaIsolate;
exports.Badge = Badge;
exports.BadgeLabel = BadgeLabel;
exports.BottomSheet = BottomSheet;
exports.Breadcrumb = Breadcrumb;
exports.BreadcrumbItem = BreadcrumbItem;
exports.BreadcrumbLink = BreadcrumbLink;
exports.Button = Button;
exports.Checkbox = Checkbox;
exports.ClickOutsideListener = ClickOutsideListener$1;
exports.Code = Code;
exports.ColumnGroupHeader = ColumnGroupHeader;
exports.ColumnHeader = ColumnHeader;
exports.ColumnLeft = ColumnLeft;
exports.ColumnList = ColumnList;
exports.ColumnRight = ColumnRight;
exports.Combobox = Combobox;
exports.ComboboxGroup = ComboboxGroup;
exports.ComboboxOption = ComboboxOption;
exports.CopyButton = CopyButton;
exports.DescriptionDetails = DescriptionDetails;
exports.DescriptionList = DescriptionList;
exports.DescriptionListItem = DescriptionListItem;
exports.DescriptionTerm = DescriptionTerm;
exports.Dialog = Dialog;
exports.DialogCloseButton = DialogCloseButton;
exports.DialogContent = DialogContent;
exports.DialogFooter = DialogFooter;
exports.DialogHeader = DialogHeader;
exports.DialogHeading = DialogHeading;
exports.Drawer = Drawer;
exports.EmptyState = EmptyState;
exports.ExpandCollapsePanel = ExpandCollapsePanel;
exports.FieldGroup = FieldGroup;
exports.FieldWrap = FieldWrap;
exports.Icon = Icon;
exports.IconButton = IconButton;
exports.ImpactBadge = ImpactBadge;
exports.Layout = Layout;
exports.Line = Line;
exports.Link = Link;
exports.Listbox = Listbox;
exports.ListboxGroup = ListboxGroup;
exports.ListboxOption = ListboxOption;
exports.Loader = Loader;
exports.LoaderOverlay = LoaderOverlay;
exports.Main = Main;
exports.MenuBar = TopBar$1;
exports.MenuItem = MenuItem;
exports.MetadataList = MetadataList;
exports.MetadataListItem = MetadataListItem;
exports.MetadataListLabel = MetadataListLabel;
exports.MetadataListValue = MetadataListValue;
exports.Modal = Modal;
exports.ModalCloseButton = ModalCloseButton;
exports.ModalContent = ModalContent;
exports.ModalFooter = ModalFooter;
exports.ModalHeader = ModalHeader;
exports.ModalHeading = ModalHeading;
exports.NavBar = NavBar;
exports.NavItem = NavItem;
exports.Notice = Notice;
exports.Offscreen = Offscreen;
exports.OptionsMenu = OptionsMenu;
exports.OptionsMenuItem = OptionsMenuItem;
exports.OptionsMenuList = OptionsMenuList;
exports.OptionsMenuTrigger = OptionsMenuTrigger;
exports.OptionsMenuWrapper = OptionsMenuWrapper;
exports.PageHeader = PageHeader;
exports.Pagination = Pagination;
exports.Panel = Panel;
exports.PanelContent = PanelContent;
exports.PanelHeader = PanelHeader;
exports.PanelTrigger = PanelTrigger$1;
exports.Popover = Popover;
exports.ProgressBar = ProgressBar;
exports.RadioCardGroup = RadioCardGroup;
exports.RadioGroup = RadioGroup;
exports.Scrim = Scrim;
exports.SearchField = SearchField;
exports.SectionHeader = SectionHeader;
exports.Select = Select;
exports.SideBar = SideBar;
exports.SideBarItem = SideBarItem;
exports.Sidebar = SideBar;
exports.SkipLink = SkipLink;
exports.Step = Step;
exports.Stepper = Stepper;
exports.Tab = Tab;
exports.TabPanel = TabPanel;
exports.Table = Table;
exports.TableBody = TableBody;
exports.TableCell = TableCell;
exports.TableFooter = TableFooter;
exports.TableHead = TableHead;
exports.TableHeader = TableHeader;
exports.TableRow = TableRow;
exports.Tabs = Tabs;
exports.Tag = Tag;
exports.TagButton = TagButton;
exports.TagLabel = TagLabel;
exports.TextEllipsis = TextEllipsis;
exports.TextField = TextField;
exports.ThemeContext = ThemeContext;
exports.ThemeProvider = ThemeProvider;
exports.Timeline = Timeline;
exports.TimelineItem = TimelineItem;
exports.Toast = Toast;
exports.Tooltip = Tooltip;
exports.TooltipContent = TooltipContent;
exports.TooltipHead = TooltipHead;
exports.TooltipTabstop = TooltipTabstop;
exports.TopBar = TopBar;
exports.TopBarItem = MenuItem;
exports.TopBarMenu = TopBarMenu;
exports.TopBarTrigger = TopBarTrigger;
exports.TreeView = TreeView;
exports.TwoColumnPanel = TwoColumnPanel;
exports.Workspace = Workspace;
exports.focusableSelector = focusableSelector;
exports.iconTypes = iconTypes;
exports.useDidUpdate = useDidUpdate;
exports.usePagination = usePagination;
exports.useThemeContext = useThemeContext;
